/* global conditionalLogicHelpers, Mark, _ */
import HrbrMiniEditor from '@/components/HrbrMiniEditor.vue';
import HrbrVerificationsConsent from '@/components/Modals/HrbrVerificationsConsent.vue';
import HrbrReviewAgreement from '@/components/Other/HrbrReviewAgreement.vue';
import HrbrUrlInput from '@/components/ui/HrbrUrlInput.vue';
import { COUNTRIES_LIST } from '@/config/countries.js';
import { firebaseConfig } from '@/config/firebase';
import { CANADA_STATES, US_STATES } from '@/config/states';
import { DEFAULT_INPUTS_MAP, DEFAULT_PROVIDER_PER_CHECK } from '@/config/verification-inputs';
import externalServicesApiService from '@/services/external-services-api-service';
import { SuperdocService } from '@/services/superdoc-services';
import verificationsApiService from '@/services/verifications-api-service';
import { useHarbourStore } from '@/stores/harbour-store';
import { useSuperdocStore } from '@/stores/superdoc-store.js';
// LEGACY: Get the CK HTML for a template
// TODO: Remove this once we are ready
import { useCkeditorStore } from '@/stores/ckeditor-store.js';
import debounce from '@/utils/debounce';
import { getBlobFromUrl, isImageValid, readFileAsDataUrl } from '@/utils/helpers/functions';
import * as validationHelpers from '@/utils/helpers/input-validation-helpers';
import { injectListStylesIfNeeded } from '@/utils/list-styles';
import translations from '@/utils/translations/translations';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { v4 as uuidv4 } from 'uuid';
import ReassignModal from './components/ReassignModal.vue';

const wait = (ms = 1000) => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

export default {
  name: 'HrbrAgreeLink',

  components: {
    HrbrReviewAgreement,
    HrbrUrlInput,
    ReassignModal,
    HrbrMiniEditor,
  },

  data() {
    return {
      linkDisplayId: null, //link-agreement ID in the URL
      isInitialLoading: true, //initial loading
      isMobileView: false, //toggle size-responsize layout elements
      isTabletView: false, //toggle PDF-render layout elements
      //
      isInvalidLink: false, //missing active inputs (e.g., branding, agreement)
      //
      isPasscodeNeeded: false,
      isPasscodeInvalid: false,
      linkPasscode: null,
      isTryingNewPasscode: false,
      //
      isEmailConfirmationNeeded: false,
      isEmailConfirmationInvalid: false,
      isEmailConfirmationValidButWrongIndex: false,
      isEmailConfirmationButAgreementAlreadyFullyCompleted: false,
      isEmailConfirmationButAgreementAlreadySignedByGroup: false,
      isEmailConfirmationButAgreementAlreadySignedByUser: false,
      emailConfirmationValue: null,
      isTryingNewEmail: false,
      //
      isAlreadyCompletedBeforeFinalSubmission: false,
      //
      activeStepperSection: 0, //current step
      validatedSections: [], //used to store/enable backtrack-clickable step markers
      //
      clientDeploymentId: 'default', //*previously dynamic
      clientReferrer: null, //refering site
      clientUrlParams: null, //current URL parameters
      clientSessionId: null, //unique page id (*changes on refresh)
      //
      isFinalSubmitAlreadyCompleted: false,
      isFinalSubmitLoading: false,
      isCompleted: false, //final submission completed
      completedTitle: 'Completed', //final submission resulting text (*can be set in the agreement config)
      completedMessage: null, //final submission resulting text (*can be set in the agreement config)
      //
      brandingId: null,
      brandingData: null,
      isMissingBrandingData: null,
      brandingThemeCSS: null,
      //
      agreementId: null,
      agreementData: null,
      organizationId: null,
      isMissingAgreementData: null,
      agreementRequestCount: 0,
      isInitialWaitForRendereredPDF: null,
      partnerInfo: null,
      //
      agreementDocumentSignedUrl: null,
      agreementPdfGcpPath: null,
      agreementDocumentFilename: null,
      agreementCustomInputs: null,
      isAgreementDocumentRendered: false,
      //
      itemValues: {}, //*ongoing store of latest itemid to current item value mapping
      //
      itemMetadata: {}, //*store of latest itemid to pertinent metadata mapping
      //
      checkboxRenderKey: 0, //*used to force re-rendering of checkbox components when needed
      //
      linkReferenceAttachments: [], //*attachments added to agreement link (in Import by URL builder)
      linkPageAttachments: [], // ageement link page attachments
      showPrevewWithAttachments: true,
      allSignersAttachments: [],
      //
      isUserContentUploadingEnabled: null,
      userContentMainUploaderItem: null, //*UPLOAD item -- where linkedspecialvalue is "MAINCONTENTUPLOAD" --> connect to default uploader
      userContentAttachments: [], //*attachments added to agreement link now by recipient
      userContentAttachmentsBuffer: [], // temporary buffer for attachments (used to work with multiple uploaders)
      userContentMaxPreviewBytes: 209715200, //*200MB
      userContentMaxPreviewAcceptableUploadBytes: 53687091200, //~50GB
      isUserContentPendingUploads: false,
      //
      userInfo: null,
      //
      bannerBackgroundImage:
        'linear-gradient(141deg,#e5e5e5 0%,rgb(248, 248, 248) 61%,rgb(235, 235, 235) 120%)',
      //
      linkedSpecialValues: {
        //*eligible special values
        EMAIL: null,
        FULLNAME: null,
      },
      linkGenerationId: null,
      //Stored signatures and initials
      agreelinkStoredInitials: [],
      agreelinkStoredSignatures: [],
      agreelinkIssigloading: false,
      //User login and guest account
      isEmailConfirmationLink: false,
      isLoginPopupBlocked: false,
      isLoginFailed: false,
      isEmailConfirmationValidAndUserExists: false,
      isShowEmailLogin: false,
      isAuthenticatedByMagicLink: false,
      isAuthenticatedBySystemEmail: false,
      isUser: false,
      isGuest: false,
      userName: '',
      typedUserName: '',
      userProfilePhoto: '',
      userJobTitle: '',
      responseData: null,
      userEmail: '',
      linkOrgSubdomain: '',
      linkOrgOwnerId: '',
      linkOrgOwnerName: '',
      numberOfNameFields: 0,
      //
      contextDict: null,

      autocompleteInputTypes: [
        'ADDRESSTEXTINPUT',
        'STREETADDRESSTEXTINPUT',
        'CITYTEXTINPUT',
        'STATETEXTINPUT',
        'ZIPCODETEXTINPUT',
        'COMPANYNAMETEXTINPUT',
        'COUNTYTEXTINPUT',
        'COUNTRYTEXTINPUT',
      ],
      // one full address per group
      fullAddress: {},
      // Mapping input types -> item id's
      autocompleteGeoInputs: {
        city: null,
        state: null,
        zipcode: null,
        street: null,
        country: null,
        county: null,
      },
      // vue references
      autocompleteGeoInputRefs: {},
      // shared autocomplete suggestions
      globalSuggestions: { suggestions: [] },
      // Mapping item id's -> booleans (for checking if selection made via autofill)
      autofilledInputs: {},
      isPdfPreviewActive: false,
      isPdfPreviewSubmitVisible: false,
      // import conditional logic helper functions
      currentlyHiddenConditionalInputs: {},
      isLoginOptionDisabled: false,
      agreementReferenceId: null,

      isCkeditorAgreement: false,
      ckeditorAgreementId: null,
      ckeditorHtmlData: null,

      // Autosave additions
      saveStatus: null,
      initialSave: true,
      displayAutosaveMessage: false,
      autosaveData: {},
      maxSizeOfLocalStorage: 5000000,
      autosavedConditionals: [],
      visibleSections: [],

      previousSignerData: null,
      consolidatedData: null,
      isNetworkConnectionLost: false,
      finaldocumentviewed: false,

      // Verification checks
      checkInputTypes: [
        'IDENTITYCHECK',
        'USBACKGROUNDCHECK',
        'VEHICLERECORDCHECK',
        'PANELDRUGCHECK',
      ],
      checkIframeUrl: '',
      checkIframeId: null,
      isCheckModalActive: false,
      isPanelDrugModalActive: false,
      isPanelDrugSchedulingInProgress: false,
      isIframeLoading: false,
      checkStatuses: {},
      addressData: {},
      checkResultLoading: {},
      drugCheckParams: {},
      checkConsents: [],
      isConsentsGiven: false,
      verificationResults: {
        pending: 'In progress',
        verified: 'Verified',
        rejected: 'In review',
      },
      verificationIconTypes: {
        'In progress': 'is-success',
        'In review': 'is-warning',
        Verified: 'is-success',
      },
      // To support older links
      verificationContentText: {
        IDENTITYCHECK: 'Verify identity with a government-issued ID',
        USBACKGROUNDCHECK: 'Begin US background check',
        VEHICLERECORDCHECK: 'Begin motor vehicle record check',
        PANELDRUGCHECK: 'Begin panel drug check',
      },
      drugCheckUserId: null,
      currentPollingMessage: '',
      turnCheckId: null,
      notRequiredConditionalInputs: [],

      // Reassigning
      isReassignModalActive: false,
      isReassigned: false,
      reassignedTo: null,
      downloadDocxState: 'initial',
      downloadDocxIcon: {
        initial: 'fa-arrow-down-to-bracket',
        working: 'loader',
        done: 'fa-check',
      },
      signerRedlineCtaMsg: {
        writer: 'Suggest changes',
        owner: 'Suggest changes',
        commentator: 'Leave comment',
      },
      updatingRedliningSignerRole: false,
      isPdfPreviewLoading: false,
      autocompleteSelectEventInProgress: false,
      econsentModalActive: false,
      isDownloadDisabled: false,
      //
      isConsentChecked: false,
      //
      translations,

      superdocId: null,
      superdocViewerModal: null,
      superdocPreviewData: null,
      activeSuperdocFile: null,
      agreementOwnerAttachments: [],
    };
  },

  setup() {
    const harbourStore = useHarbourStore();
    const superdocStore = useSuperdocStore();
    const ckeditorStore = useCkeditorStore();

    return {
      harbourStore,
      superdocStore,
      ckeditorStore,
    };
  },

  computed: {
    //Determine whether or not to show stepper labels
    isShowingStepperLabels() {
      let self = this;
      if (self.isMobileView == true) {
        //On mobile --> display up to 3 stepper labels
        if (self.totalStepperSections < 4) {
          return true;
        }
      } else {
        //On desktop --> display up to 4 stepper labels
        if (self.totalStepperSections < 5) {
          return true;
        }
      }
      return false;
    },

    //Determine sections count
    totalStepperSections() {
      let self = this;
      if (self.agreementData == null) {
        return null;
      }
      const sections = self.visibleSections;
      return sections.length;
    },

    //Determine if item is eligible to be visibly displayed (*computed to re-update after each new value update)
    visibleIneligibleItemsArray() {
      //Validate: we have agreement data loaded
      let self = this;
      let newIneligibleItems = [];
      if (self.agreementData == null) {
        return newIneligibleItems; //*[]
      }

      //Validate: check each section item for visibility eligibility
      let sections = self.agreementData.agreementcontent.sections;
      sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          //Validate: eligible based on index (*e.g., first reviewer/signer - for email-based authentication)
          if (item.itemvisiblerequiredindex != undefined && item.itemvisiblerequiredindex != null) {
            let requredIndex = item.itemvisiblerequiredindex;
            let userIndex = self.userInfo.completionindex;
            if (requredIndex != userIndex) {
              newIneligibleItems.push(item.itemid);
              return;
            }
          }

          //Validate: eligible based on role (*for email-based authentication)
          if (
            item.itemvisiblerequiredrole != undefined &&
            item.itemvisiblerequiredrole != null &&
            item.itemvisiblerequiredrole != '*' &&
            item.itemvisiblerequiredrole != ''
          ) {
            let requredRole = item.itemvisiblerequiredrole;
            let userRole = self.userInfo.role;
            if (requredRole != userRole) {
              newIneligibleItems.push(item.itemid);
              return;
            }
          }

          //Validate: is actively not displayed based on flag
          if (item.isdefaultdisplayed != undefined && item.isdefaultdisplayed == false) {
            newIneligibleItems.push(item.itemid);
            return;
          }

          //Validate: is actively not displayed as conditionally dependent on other item's value
          if (
            item.isconditionallydisplayedlinkeditemid != undefined &&
            item.isconditionallydisplayedlinkeditemid != null &&
            item.isconditionallydisplayedlinkeditemvalue != undefined &&
            item.isconditionallydisplayedlinkeditemvalue != null
          ) {
            let currentLinkedItemValue = self.itemValues[item.isconditionallydisplayedlinkeditemid];
            if (Array.isArray(currentLinkedItemValue) == true) {
              //e.g., *"YESNO" item with array of ['YES'] --> "YES"
              currentLinkedItemValue = currentLinkedItemValue.join(',');
            }
            let currentLinkedItemValueClean = (currentLinkedItemValue + '').toLowerCase().trim();
            let currentLinkedConditionalItemValueClean = (
              item.isconditionallydisplayedlinkeditemvalue + ''
            )
              .toLowerCase()
              .trim();
            if (currentLinkedItemValueClean != currentLinkedConditionalItemValueClean) {
              newIneligibleItems.push(item.itemid);
              return;
            }
          }
        });
      });

      //Validate: make ineligible the conditional items dependent on another-currently-ineligible conditional item
      sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          if (
            item.isconditionallydisplayedlinkeditemid != undefined &&
            item.isconditionallydisplayedlinkeditemid != null
          ) {
            if (newIneligibleItems.includes(item.isconditionallydisplayedlinkeditemid) == true) {
              newIneligibleItems.push(item.itemid);
            }
          }
        });
      });

      //Return newly-computed ineligible items
      return newIneligibleItems;
    },

    /*
    allSignerInputs lists all signer inputs in the agreement (signers 1 through 10).
    This provides a convenience for working with all inputs (excluding document inputs),
    and keeps code simple, allowing for all inputs to be interacted with in one loop.
    */
    allSignerInputs() {
      const allInputs = [];
      const allSections = this.agreementData.agreementcontent.sections;

      allSections.forEach((section) => {
        allInputs.push(...section.sectionitems);
      });

      return allInputs;
    },

    currentSignerInputs() {
      return this.allSignerInputs.filter(
        (field) =>
          field.itemvisiblerequiredindex === this.userInfo.completionindex ||
          field.itemvisiblerequiredindex === null,
      );
    },

    /*
    inputDependencyMap outlines the dependent relationship between all inputs, from the
    perspective of the dependent (child).
    For example: A has dependents B, C, and D.
    inputDependencyMap would contain: B -> A, C -> A, and D -> A

    In general, this structure can be used to build other, possibly simpler structures
    modeling this relationship (e.g. array of inputs dependent on input A).
    Specifically, this structure is used to place "depends on ..." labels on draggable
    inputs in agreementEditor and for filtering all inputs into dependent inputs.
    */
    inputDependencyMap() {
      return conditionalLogicHelpers.buildInputDependencyMap(this.allSignerInputs);
    },

    /*
    allAnnotations lists all annotations for the agreement, and gives a conveniently
    short variable name through which this information can be accessed.
    Essentially an aliasing of "this.agreementData.agreementannotations.documentannotationsmap"
    */
    allAnnotations() {
      return this.agreementData.agreementannotations.documentannotationsmap;
    },

    itemValuesPopulated() {
      return Object.fromEntries(
        Object.entries(this.itemValues).filter(([itemid, value]) => value != null),
      );
    },

    isSuperdoc() {
      return !!this.superdocId;
    },
  },

  watch: {
    // watch for any item values changes, so we can show/hide sections correctly.
    // with migration to Vite can be replaced with computed property.
    itemValues: {
      handler() {
        this.visibleSectionsMethod();
      },
      deep: true,
    },
  },

  methods: {
    generateRandomFieldId() {
      let uuid;
      try {
        uuid = crypto.randomUUID();
      } catch (e) {
        // For older browsers that don't have crypto
        const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        let id = '';
        for (let i = 0; i < 8; i++) {
          const randomIndex = Math.floor(Math.random() * charset.length);
          id += charset.charAt(randomIndex);
        }
        uuid = id;
      }
      return uuid;
    },

    triggerWebhook(eventType, payload) {
      this.$harbourData
        .post('/api/webhooks/trigger', {
          event_type: eventType,
          request_payload: payload,
          organization_id: this.organizationId,
        })
        .catch((error) => {
          console.log('-- ERROR: failed to trigger webhook', error);
        });
    },

    // Send a request to remove this live signer session
    handleBeforeUnload() {
      const options = {
        deletion_request: {
          link_id: this.linkDisplayId,
          session_id: this.clientSessionId,
        },
      };
      this.$harbourData.delete('/core/sessions/live', options).catch((error) => {
        console.log('-- ERROR: failed to delete live session', error);
      });
    },

    viewDocumentClickHandler(data = null) {
      if (!data) {
        console.error('viewDocumentClickHandler: data is required');
        return;
      }

      if (this.isCkeditorAgreement && !this.linkPageAttachments.length) {
        this.viewCkeditorDocument(data);
      } else if (this.isSuperdoc) {
        this.openSuperdocDocxPreview(data);
      } else {
        this.viewPdfDocument(data);
      }

      // mark input as viewed for validation checks on submit
      const input = data.itemJson;
      if (input.itemtype === 'FINALDISPLAYTEXT') {
        this.finaldocumentviewed = true;
      } else {
        input.documentviewed = true;
      }
    },

    viewPdfDocument(data) {
      if (!data) {
        console.error('viewPdfDocument: data is required');
        return;
      }
      const { submitBtnAttr } = data;
      const { itemJson } = data;
      this.openPdfPreview(itemJson, submitBtnAttr);
    },

    viewCkeditorDocument(data = null) {
      if (!data) {
        console.error('viewCkeditorDocument: data is required');
        return;
      }

      // For agreelink, we need to remove INCOMPLETE annotations that are not for this signer
      const hiddenPreviewItems = { ...this.currentlyHiddenConditionalInputs };

      // Remove any SIGNDATEINPUT items from document inputs as these are appended last
      this.agreementCustomInputs.custominputs.forEach((item) => {
        if (item.itemfieldtype === 'SIGNDATEINPUT') {
          hiddenPreviewItems[item.itemid] = true;
        }
      });

      // Remove any annotations that aren't previously signed and don't belong to current signer
      this.visibleIneligibleItemsArray.forEach((itemid) => {
        if (itemid in this.previousSignerData?.aggregateditemvalues) return;
        if (itemid in this.itemValues && this.itemValues[itemid] != null) return;
        hiddenPreviewItems[itemid] = true;
      });

      // Pass in hiddenPreviewItems (annotations to remove) to processing function
      let htmlData = this.ckeditorStore.prepareHtmlData(
        this.ckeditorHtmlData,
        hiddenPreviewItems,
        this.processAnnotationsForPreview,
        true,
      );

      // Inject list styles before DOM manipulation
      htmlData = injectListStylesIfNeeded(htmlData);

      const htmlDataDOM = new DOMParser().parseFromString(htmlData, 'text/html');
      this.updateCkeditorAnnotationText(htmlDataDOM);
      htmlData = htmlDataDOM.documentElement.outerHTML;

      const documentName = this.agreementData.agreementheader;

      let submitItem;
      this.agreementData?.agreementcontent.sections.forEach((section) => {
        section.sectionitems.forEach((item) => {
          if (item.itemtype === 'FINALSUBMIT') {
            submitItem = item;
          }
        });
      });

      const submitCta = {
        id: 'submit',
        label: 'Submit',
        type: 'primary',
        icon: 'paper-plane',
        disabled: this.isUserContentPendingUploads,
        onClick: () => {
          if (submitItem) {
            this.storeAgreementUpdate(submitItem, '#BUTTONCLICKED', 'button interaction');
          }
          this.finalSubmit();
        },
      };

      let headerCtas = [];

      const isSectionsValid = this.validateSection('ALL', () => {}, { hideAlert: true });
      if (isSectionsValid) headerCtas.push(submitCta);

      this.superdocViewerModal = this.$openSuperdocViewerModal({
        linktitle: documentName,
        id: this.agreementId,
        source: htmlData,
        headerCtas,
      });

      // scroll to anchor if present
      const { anchorName } = data;
      if (!anchorName) return;
      setTimeout(() => {
        window.location.hash = ''; // reset
        window.location.hash = anchorName;
        setTimeout(() => (window.location.hash = ''), 100);
      }, 600);
    }, // end click handler

    openSuperdocDocxPreview(data) {
      if (!data) {
        return;
      }

      let submitItem;
      this.agreementData?.agreementcontent.sections.forEach((section) => {
        section.sectionitems.forEach((item) => {
          if (item.itemtype === 'FINALSUBMIT') {
            submitItem = item;
          }
        });
      });

      let documentName = this.agreementData.agreementheader;
      let headerCtas = [];
      if (!this.isDownloadDisabled) {
        headerCtas.push({
          id: 'download',
          label: 'Download',
          icon: 'file-arrow-down',
          type: 'secondary',
        });
      }

      const submitCta = {
        id: 'submit',
        label: 'Submit',
        type: 'primary',
        icon: 'paper-plane',
        disabled: this.isUserContentPendingUploads,
        onClick: () => {
          if (submitItem) {
            this.storeAgreementUpdate(submitItem, '#BUTTONCLICKED', 'button interaction');
          }
          this.finalSubmit();
        },
      };

      const isSectionsValid = this.validateSection('ALL', () => {}, { hideAlert: true });
      if (isSectionsValid) headerCtas.push(submitCta);

      this.superdocViewerModal = this.$openSuperdocViewerModal({
        linktitle: documentName,
        id: this.agreementId,
        source: this.superdocPreviewData[0].data,
        headerCtas,
        events: {
          editorBeforeCreate: ({ editor }) => {
            editor.element.style.visibility = 'hidden';
          },
          editorCreate: async ({ editor }) => {
            await this.superdocStore.previewSuperdocEditorAnnotations({
              editor,
              source: 'signerLink',
              options: {
                customInputs: this.agreementCustomInputs,
                signerInputs: this.allSignerInputs,
                hiddenConditionalInputs: this.currentlyHiddenConditionalInputs,
                visibleIneligibleItems: this.visibleIneligibleItemsArray,
                previousSignerData: this.previousSignerData,
                itemValues: this.itemValues,
                userContentAttachments: this.userContentAttachments,
                allSignersAttachments: this.allSignersAttachments,
                referenceAttachments: this.agreementOwnerAttachments,
                agreementData: this.agreementData,
                userInfo: this.userInfo,
                linkDisplayId: this.linkDisplayId,
              },
            });

            editor.element.style.visibility = '';
          },
        },
      });
    },

    /**
     * Builds a map of annotations completed by other signers
     */
    makePreviousSignerAnnotationsArray() {
      let completedAnnotations = [];
      if (this.previousSignerData?.aggregateditemvalues) {
        completedAnnotations = Object.keys(this.previousSignerData?.aggregateditemvalues);
      }
      return completedAnnotations;
    },

    isDocumentOwnerAnnotation(annotation) {
      const hasOwnerClass = annotation.classList.contains('document-owner-annotation');
      const { itemid } = annotation.dataset;

      let customInputsKey;
      if ('custominputs' in this.agreementCustomInputs) customInputsKey = 'custominputs';
      else if ('custominputsitems' in this.agreementCustomInputs)
        customInputsKey = 'custominputsitems';
      else return false;

      const customInputs = this.agreementCustomInputs[customInputsKey] || [];
      const isInCustomInputs = customInputs.find((input) => input.itemid === itemid);
      return hasOwnerClass || isInCustomInputs || false;
    },

    processAnnotationsForPreview(annotations) {
      // Adding this from the previously-completed signer data to include previously-signed values
      const completedAnnotations = this.makePreviousSignerAnnotationsArray();

      const currentSignerAnnotationsMap = this.buildCkeditorSignerAnnotationsMap(annotations);

      annotations.forEach((annotation) => {
        if (annotation.style.display === 'none') {
          return;
        }
        const isOwnerAnnotation = this.isDocumentOwnerAnnotation(annotation);

        const fontFamily = annotation.style.fontFamily;
        const fontSize = annotation.style.fontSize;
        const fontFamilyStyle = fontFamily ? `font-family: ${fontFamily};` : '';
        const fontSizeStyle = fontSize ? `font-size: ${fontSize};` : '';

        if (
          isOwnerAnnotation &&
          (isOwnerAnnotation?.itemfieldtype == 'SIGNATUREINPUT' ||
            annotation.dataset.itemfieldtype === 'SIGNATUREINPUT')
        ) {
          annotation.remove();
        } else if (isOwnerAnnotation) {
          const style =
            `background-color: transparent; border: none!important; ${fontFamilyStyle} ${fontSizeStyle}`.trim();
          annotation.setAttribute('style', style);
          return;
        }
        const { itemid } = annotation.dataset;
        const currentSignerAnnotation = currentSignerAnnotationsMap.get(itemid);

        // Additional check here if this annotation is from a previously-completed signer then let's not remove
        if (!currentSignerAnnotation) {
          if (completedAnnotations.length && !completedAnnotations.includes(itemid)) {
            annotation.remove();
          } else {
            // Remove background and border for previous signer annotations
            const style =
              `background-color: transparent; border: none!important; ${fontFamilyStyle} ${fontSizeStyle}`.trim();
            annotation.setAttribute('style', style);
          }
        }
      });
    },

    /**
     * Get base64 data for previous signers attachments for document preview
     *
     * @param {array} attachments The list of prior signers attachments
     */
    async prepareSignersAttachments(attachments) {
      this.allSignersAttachments = [];
      if (attachments) {
        for (let priorAttachment of attachments) {
          const {
            userattachmentdepotgcspath,
            userattachmentcloudstorageendpath,
            userattachmentinputid,
            userattachmentid,
            session_id,
            userattachmentfilename,
          } = priorAttachment;

          const newFileUrl = `${window.location.origin}/agreelinkusercontentattachment/${this.linkDisplayId}/${session_id}/${userattachmentcloudstorageendpath}/${userattachmentfilename}`;
          const blob = await getBlobFromUrl(newFileUrl);
          const base64 = await readFileAsDataUrl(blob);

          const newFile = new File([blob], priorAttachment.userattachmentfilename);

          newFile.isnew = false;
          newFile.uploadpercent = 100;
          newFile.isuploaded = true;

          newFile.userattachmentdepotgcspath = userattachmentdepotgcspath;
          newFile.userattachmentcloudstorageendpath = userattachmentcloudstorageendpath;
          newFile.itemid = userattachmentinputid;

          newFile.base64data = base64;
          newFile.id = userattachmentid || `attachment-${uuidv4()}`;

          const maxWidth = 600;
          const maxHeight = 600;
          this.createThumbnailFromFile(newFile, maxWidth, maxHeight, (resizedImageBase64Data) => {
            newFile.thumbnail = resizedImageBase64Data;
          });

          this.allSignersAttachments.push(newFile);
        }
      }
    },

    /**
     * Get base64 for attachments saved in local storage and upload it to google cloud under new session.
     * Since we have multiple image upload now the problem of saving large number of images to the local storage appeared due to its size
     * Attachments are saved in local storage without base64 data
     *
     * @param {array} attachments The list of attachments presaved in local starage
     */
    async prepareLocalStorageAttachments(attachments) {
      for (let priorAttachment of attachments) {
        const {
          id,
          cloudStorageEndPath,
          isimagestamp,
          name,
          itemid,
          itemtype,
          sessionId,
          previewcloudstoragepath,
        } = priorAttachment;

        const newFileUrl = `${window.location.origin}/agreelinkusercontentattachment/${this.linkDisplayId}/${sessionId}/${cloudStorageEndPath}/${name}`;
        const blob = await getBlobFromUrl(newFileUrl);
        const base64 = await readFileAsDataUrl(blob);

        const newFile = new File([blob], priorAttachment.name, { type: blob.type });

        newFile.itemid = itemid;
        newFile.itemtype = itemtype;
        newFile.isimagestamp = isimagestamp;
        newFile.base64data = base64;
        newFile.id = id || `attachment-${uuidv4()}`;
        newFile.previewcloudstoragepath = previewcloudstoragepath;

        const maxDimension = 600;
        this.createThumbnailFromFile(newFile, maxDimension, maxDimension, (resizedImageBase64Data) => {
          newFile.thumbnail = resizedImageBase64Data;
        });

        this.userContentAttachments.push(newFile);
        this.storeNewUploads(newFile);
      }
    },

    buildCkeditorSignerAnnotationsMap(annotationElems) {
      const annotations = [...annotationElems];
      const sections = this.agreementData.agreementcontent?.sections || [];
      const currentSignerAnnotationsMap = new Map();

      const signerInputsWithAnnotations = annotations.reduce((arr, annotation) => {
        const { itemid } = annotation.dataset;
        for (const section of sections) {
          let sectionItem = section.sectionitems.find((item) => item.itemid === itemid);

          // search for corresponding checkbox option if no section item found
          let checkboxOptionItem = null;
          if (!sectionItem) {
            const checkboxInputs = section.sectionitems.filter(
              (item) => item.itemtype === 'CHECKBOXINPUT',
            );

            const predicate = (option) => option.itemid === itemid;
            // find the checkbox input that contains the option
            const correspondingGroup = checkboxInputs.find((checkboxInput) =>
              checkboxInput.itemoptions.some(predicate),
            );
            const correspondingOption = correspondingGroup?.itemoptions.find(predicate);
            if (correspondingOption) {
              checkboxOptionItem = correspondingOption;
            }
          }

          if (sectionItem) arr.push([sectionItem, annotation]);
          if (checkboxOptionItem) arr.push([checkboxOptionItem, annotation]);
        }
        return arr;
      }, []);

      for (const [item, annotation] of signerInputsWithAnnotations) {
        if (
          item.itemvisiblerequiredindex === this.userInfo.completionindex ||
          item.itemvisiblerequiredindex === null ||
          item.itemtype === 'CHECKBOXINPUT_NESTED'
        ) {
          currentSignerAnnotationsMap.set(item.itemid, annotation);
        }
      }

      return currentSignerAnnotationsMap;
    },

    // update all or one ckeditor annotation
    updateCkeditorAnnotationText(htmlContainer = null) {
      if (htmlContainer == null) {
        console.warn(
          '#vue-agreelink - updateCkeditorAnnotationText() - missing hrbr-ckeditor-html-viewer__content, skipping...',
        );
        return false;
      }

      const annotations = htmlContainer.querySelectorAll('.annotation');
      let multipleUploadValueCount = 0;
      let updatedInputId = null;

      annotations.forEach((annotation) => {
        if (this.isDocumentOwnerAnnotation(annotation)) {
          const { itemfieldtype: itemFieldType } = annotation.dataset;
          const isUrlInput = itemFieldType.toLowerCase() === 'urltextinput';
          const textContent = annotation.textContent;
          if (isUrlInput && textContent) {
            let href = textContent;
            if (!href.startsWith('http')) href = 'http://' + href;
            annotation.innerHTML = `<a href="${href}" target="_blank">${textContent}</a>`;
          }
          return;
        }
        const itemId = annotation.getAttribute('data-itemid');
        const itemFieldType = annotation.getAttribute('data-itemfieldtype');
        const completedAnnotations = this.makePreviousSignerAnnotationsArray();
        const isPreviouslyCompletedAnnotation = completedAnnotations.includes(itemId);
        const correspondingInput = this.allSignerInputs.find((input) => input.itemid === itemId);
        let newValue = null;
        // get the value from the previous signer data if it exists
        if (isPreviouslyCompletedAnnotation) {
          const { aggregateditemvalues: previousSignerResponses } = this.previousSignerData;
          if (previousSignerResponses[itemId]) {
            newValue = previousSignerResponses[itemId];
          }
        } else {
          // get current user's value
          newValue = this.itemValues[itemId] || '';
          if (itemFieldType === 'CHECKBOXINPUT') {
            // blank space if checkbox unchecked == empty string.
            newValue = this.itemValues[itemId] || '&nbsp;&nbsp;';
          }
          // highlight the annotation
          annotation.classList.add('for-current-user');
        }

        if (newValue) {
          const isSignatureInput = itemFieldType.toLowerCase() === 'signatureinput';
          const isImageInput = itemFieldType.toLowerCase() === 'imageinput';
          const isUrlInput = itemFieldType.toLowerCase() === 'urltextinput';

          if (
            ['DATEINPUT', 'SIGNDATEINPUT'].includes(itemFieldType) &&
            correspondingInput?.itemformat &&
            /^(\d{4})-(\d{1,2})-(\d{1,2})$/.test(newValue)
          ) {
            newValue = this.getFormattedDate(newValue, correspondingInput.itemformat);
          }

          if (isImageInput) {
            if (updatedInputId && updatedInputId !== correspondingInput.itemid) {
              multipleUploadValueCount = 0;
            }

            const inputValue =
              this.itemValues[correspondingInput.itemid] ||
              this.previousSignerData?.aggregateditemvalues[correspondingInput.itemid] ||
              [];

            const imageIndex = correspondingInput.multiple ? multipleUploadValueCount : 0;

            newValue = this.getBase64ForImageInput(
              correspondingInput.itemid,
              inputValue[imageIndex]?.userattachmentid,
            );
            if (inputValue.length) multipleUploadValueCount++;
            updatedInputId = correspondingInput.itemid;
          }

          if (isSignatureInput || isImageInput) {
            // insert base64 image into annotation
            annotation.innerHTML = newValue ? `<img src="${newValue}" />` : '';
          } else if (isUrlInput) {
            let href = newValue;
            if (!href.startsWith('http')) href = 'http://' + href;
            annotation.innerHTML = `<a href="${href}" target="_blank">${newValue}</a>`;
          } else {
            const annotationText = annotation.querySelector('.annotation-text');
            annotationText.innerHTML = newValue;
          }
        }
      });
    },

    // Autosave draft data
    autosave(item, itemValue, itemMessage) {
      let self = this;
      if (self.isReassigned) return;

      // Ignoring the first call (before user input)
      // Ignore file upload (wait for completion)
      if (self.initialSave) {
        self.initialSave = false;
        return;
      } else if (itemMessage == 'user upload started') {
        self.saveStatus = 'Checking file...';
        self.displayMessage = true;
        return;
      }

      // Display saving message
      self.saveStatus = 'Saving...';
      if (!self.displayAutosaveMessage) self.displayAutosaveMessage = true;

      const storageSize = self.getLocalStorageSize(self.linkDisplayId);
      let dataToSave = { ...self.itemValuesPopulated };
      dataToSave.attachments = [];
      let autosaveSize = new Blob([JSON.stringify(dataToSave)]).size + storageSize;

      // If the last change is too big to save, don't save it.
      if (autosaveSize > self.maxSizeOfLocalStorage) {
        dataToSave[item.itemid] = '';
      } else {
        // Iterate through attachments, saving each one as size allows
        for (let item of self.userContentAttachments) {
          // Save empty base64data for attachments due to local storage size
          const attachmentToSave = {
            ...item,
            size: item.size,
            name: item.name,
            base64data: '',
          };
          dataToSave.attachments.push(attachmentToSave);
          autosaveSize = new Blob([JSON.stringify(dataToSave)]).size + storageSize;
          if (autosaveSize > self.maxSizeOfLocalStorage) {
            dataToSave.attachments.pop();
            autosaveSize = new Blob([JSON.stringify(dataToSave)]).size + storageSize;
            break;
          }
        }
      }

      // Attempt to save to local storage
      try {
        localStorage.setItem(self.linkDisplayId, JSON.stringify(dataToSave));
        if (Object.keys(self.addressData).length) {
          localStorage.setItem(
            `${self.linkDisplayId}_addressData`,
            JSON.stringify(self.addressData),
          );
        }
      } catch (error) {
        console.log('[dev] AUTOSAVE error:', error);
      }
      setTimeout(() => (self.saveStatus = 'Saved'), 2000);
    },

    getLocalStorageSize(linkDisplayId) {
      let totalSize = 0;
      for (let key in localStorage) {
        if (!localStorage.hasOwnProperty(key) || key === linkDisplayId) {
          continue;
        }
        let currentSize = new Blob([localStorage[key]]).size;
        totalSize += currentSize;
      }
      return totalSize;
    },

    unhideAutosaveData(item, value) {
      // Used to remove from hiddenInputs array if the item is autosaved and should be shown
      let self = this;
      if (value) {
        let conditionals = item.logicrules?.filter((item) => item.operand === value);
        if (conditionals?.length) {
          for (let conditional of conditionals) {
            self.autosavedConditionals = [...self.autosavedConditionals, ...conditional.inputs];
          }
        }
      }
    },

    // Clear form data
    handleClearForm() {
      let self = this;
      const result = window.confirm('Clear form data?');

      self.userEmail = '';
      self.isConsentChecked = false;
      self.isEmailConfirmationValidAndUserExists = false;
      self.isShowEmailLogin = false;
      self.isUser = false;
      self.$forceUpdate();

      // If user chooses to clear the form, clear values.
      if (result) {
        // Clear images and checkboxes
        const sections = self.agreementData?.agreementcontent?.sections || [];
        for (let section of sections) {
          for (let item of section.sectionitems) {
            if (item.itemtype == 'CHECKBOXINPUT') {
              for (let box of item.itemoptions) {
                if (self.itemValues[box.itemid]) {
                  box.valueToggle = false;
                }
              }
            }
            if (item.itemtype == 'IMAGEINPUT') {
              item.itemfilename = null;
              item.itemname = null;
            }
          }
        }

        // Clear signature pads, if any
        if (self.$refs.signaturepad?.length > 0) {
          for (let pad of self.$refs.signaturepad) {
            pad.signaturePad.clear();
            pad.dataUrl = null;
          }
        }

        // null all values
        for (let key in self.itemValues) {
          self.itemValues[key] = '';
        }

        self.userContentAttachments = [];
        self.displayAutosaveMessage = false;
        self.clearAutosaveData();
        self.$forceUpdate();
      }
    },

    // Autosave function to load draft signatures
    handleSigpadReady(component, itemId) {
      let self = this;
      if (self.itemValues[itemId]) component.loadDefaultSignature(this.itemValues[itemId]);
    },

    // Remove draft data from local storage
    clearAutosaveData() {
      let self = this;
      self.displayAutosaveMessage = false;
      localStorage.removeItem(self.linkDisplayId);
    },

    //Get login provider gmail/microsoft
    loginGetProvider(successCallback) {
      firebase
        .auth()
        .fetchSignInMethodsForEmail(this.userEmail)
        .then((providers) => {
          if (providers.length > 0) {
            let auth_provider = providers[0];
            let provider = new firebase.auth.OAuthProvider(auth_provider);
            provider.setCustomParameters({
              login_hint: this.userEmail,
            });
            successCallback(provider);
          } else {
            successCallback(null);
          }
        });
    },

    //Check for firebase apps, if none initializeApp
    loginFirebaseCheck() {
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig);
      }
    },

    //Agreement link login for existing users
    agreeLinkLogin() {
      let self = this;

      if (!self.isUser || !self.contextDict || self.contextDict['systememail'] != self.userEmail) {
        self.loginFirebaseCheck();
        self.loginGetProvider(function (provider) {
          try {
            firebase
              .auth()
              .signInWithPopup(provider)
              .then((result) => {
                // if the agreement link requires email confirmation
                if (self.isEmailConfirmationNeeded) {
                  //Login the user and show the agreement fields
                  if (result && result.user.email == self.userEmail) {
                    self.isInitialLoading = true;
                    self.isEmailConfirmationInvalid = false;
                    self.isShowEmailLogin = false;
                    self.isUser = true;
                    self.authenticatedSendCredentials(result.user, function () {
                      console.log('#agreeLinkLogin send credentials success');
                      self.processAgreementData(self.responseData);
                    });
                  }

                  //Show error message for wrong user and enable submit to try again
                  else {
                    self.isEmailConfirmationInvalid = true;
                    self.isEmailConfirmationValidAndUserExists = false;
                    self.isTryingNewEmail = false;
                    self.isShowEmailLogin = false;
                    self.isUser = false;
                  }
                } else {
                  //Login the user and request the stored signatures and inititals
                  if (result.user.email == self.userEmail) {
                    self.isEmailConfirmationInvalid = false;
                    self.isShowEmailLogin = false;
                    self.isUser = true;
                    self.agreelinkIssigloading = true;
                    self.isGuest = false;
                    self.getContextDict();
                    self.initItemValuesStoreDefaults();
                    self.initConsentsGivenFlag();
                    self.initEConsentStoreDefaults();
                    self.authenticatedSendCredentials(result.user, function () {
                      console.log('#agreeLinkLogin send credentials success');
                      self.requestSignaturesAndInitials(
                        function (response) {
                          console.log('#agreeLinkLogin signatures and initials loaded');
                        },
                        function (error) {
                          console.log('#agreeLinkLogin error while signatures and initials loaded');
                          console.log(error);
                        },
                      );
                    });
                  }
                }
                return false;
              })
              .catch(function (error) {
                self.isShowEmailLogin = true;
                self.isUser = false;

                //Show error message for wrong user and enable submit to try again
                if (error.code == 'auth/popup-blocked') {
                  self.isLoginPopupBlocked = true;
                } else {
                  self.isLoginFailed = true;
                }
                self.isInitialLoading = false;
                self.isEmailConfirmationValidAndUserExists = true;
                self.isTryingNewEmail = false;
                console.log('#agreeLinkLogin error while login');
                console.log(error);
                return false;
              });
            return false;
          } catch (error) {
            self.isUser = false;
            console.log('#agreeLinkLogin error while log in');
            console.log(error);
            return false;
          }
        });
      } else {
        self.isEmailConfirmationInvalid = false;
        self.isShowEmailLogin = false;
        self.initItemValuesStoreDefaults();
        self.initEConsentStoreDefaults();
        self.requestSignaturesAndInitials(
          function (response) {
            console.log('#agreeLinkLogin signatures and initials loaded');
          },
          function (error) {
            console.log('#agreeLinkLogin error while signatures and initials loaded');
            console.log(error);
          },
        );
        return false;
      }
    },

    //With a fully authenticated user, send crendentials to Harbour to create/store a secure session
    authenticatedSendCredentials(user, successCallback) {
      user.getIdToken().then((tokenId) => {
        // Create secure session on server, then redirect to destination URL
        firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
        let postData = {
          tokenId: tokenId,
          email: firebase.auth().currentUser.email,
          uid: firebase.auth().currentUser.uid,
          destinationUrl: null,
        };
        this.$harbourData
          .post(
            '/loginstore',
            postData,
            {},
            {
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              withCredentials: true,
            },
          )
          .then((response) => {
            console.log('-- 3) auth: new credentials stored', response);
            successCallback();
          })
          .catch((error) => {
            console.log('-- ERROR: auth session not stored:', error);
            alert(
              'Error - we could not validate your secure credentials at this point. Try again in a bit or contact support@harbourshare.com',
            );
          });
      });
    },

    //Continue as guest option
    continueAsGuest() {
      let self = this;
      self.isShowEmailLogin = false;
      self.isUser = false;
      self.isGuest = true;
      self.userName = '';
      self.agreelinkStoredSignatures = [];
      self.agreelinkStoredInitials = [];
      if (self.isEmailConfirmationNeeded) {
        self.processAgreementData(self.responseData);
      }
    },

    //Check if the email for an existing user
    requestEmailCheck(email, successCallback, failedCallback) {
      let self = this;
      let agreeDataCheckUserEmailUrl = '/agreelinkemailcheck?agreelinkdata-checkusersemail';
      let agreeCheckUserPostData = {
        requesttype: 'agreelinkdata-checkusersemail',
        email: email,
      };

      if (self.clientSessionId) {
        self.storeAgreementUpdate('#USEREMAILCHANGE', email, 'User entered email: ' + email);
      }

      self.$harbourData
        .post(agreeDataCheckUserEmailUrl, agreeCheckUserPostData)
        .then((response) => {
          self.isUserEmail = response.data.isuseremail;
          if (!self.isUserEmail) {
            self.continueAsGuest();
            self.autosave();
            successCallback(response);
          } else {
            self.userEmail = response.data.useremail;
            self.userName = response.data.username;
            self.userJobTitle = response.data.userjobtitle;
            self.typedUserName = self.userName;
            self.isEmailConfirmationValidAndUserExists = true;
            self.isShowEmailLogin = true;
            if (self.isShowEmailLogin && self.isUserEmail) {
              let isLoggedIn =
                self.contextDict != null &&
                'systememail' in self.contextDict &&
                self.contextDict['systememail'] == self.userEmail;
              self.isUser = isLoggedIn;
              if (self.isEmailConfirmationNeeded) {
                if (isLoggedIn) {
                  if ('picture' in self.contextDict && !self.isMobileView) {
                    self.userProfilePhoto = self.contextDict['picture'];
                    if (self.userProfilePhoto) {
                      self.userProfilePhoto = 'url(' + self.userProfilePhoto + ')';
                    }
                  }
                }
                self.isEmailConfirmationValidAndUserExists = true;
              }
              self.autosave();
              successCallback(response);
            } else {
              self.continueAsGuest();
              successCallback(response);
            }
          }
        })
        .catch((error) => {
          console.log('#requestEmailCheck error: ', error);
          self.continueAsGuest();
          failedCallback(error);
        });
    },

    openReassignModal() {
      // Open the reassign modal
      this.isReassignModalOpen = true;
    },

    setInitialHiddenInputs() {
      // set properties of conditionally hidden inputs for conditional logic inputs
      const hiddenInputs = this.allSignerInputs.filter((input) =>
        this.inputDependencyMap.hasOwnProperty(input.itemid),
      );
      hiddenInputs.forEach((input) => {
        // If this input has been autosaved as conditional, do not hide
        if (this.autosavedConditionals.includes(input.itemid)) return;
        input.isdependent = true;
        input.isconditionallyhidden = true;
        this.currentlyHiddenConditionalInputs[input.itemid] = true;
      });
    },

    //Agreement response data processing
    async processAgreementData(responseData) {
      let self = this;

      //Authenticated: store returned agreement info/states
      self.isInitialLoading = false;
      self.clientSessionId = responseData.agreesessionid;

      self.isPasscodeNeeded = false;
      self.isPasscodeInvalid = false;
      self.isEmailConfirmationNeeded = false;
      self.isEmailConfirmationInvalid = false;
      self.agreementData = responseData.agreementdata;
      self.agreementId = responseData.agreementdata.agreementid;
      self.linkReferenceAttachments = responseData.agreementdata.agreementattachments.attachments;
      self.linkPageAttachments =
        responseData.agreementdata.agreementlinkpageattachments.attachments;
      self.agreementDocumentSignedUrl = responseData.agreementdocumentsignedurl;
      self.agreementPdfGcpPath = responseData.agreementpdfgcppath;
      self.agreementDocumentFilename = responseData.agreementdocumentfilename;
      self.agreementCustomInputs = responseData.agreementdata.agreementcustominputs;
      self.linkGenerationId = responseData.linkgenerationid;
      self.userInfo = responseData.userinfo;
      self.organizationId = responseData.organization_id;
      self.partnerInfo = responseData.partner_info;
      self.isEmailConfirmationLink = responseData.authmode === 'EMAILS';

      this.getSuperdocAgreementOwnerImages();

      // If reassign in magic link, open the reassign modal
      if (!!self.clientUrlParams && 'reassign' in self.clientUrlParams) {
        this.isReassignModalActive = true;
        this.openReassignModal();
      }

      // hide download UI if dl is in URL params
      // TODO: Remove hardcoded organization ID - tracked in Linear HAR-9899
      // ref: https://linear.app/harbour/issue/HAR-9899/p3-dobbert-append-all-urls-with-dl=none-hardcoded-for-dobbert-in-new
      // This is a temporary hardcoded fix for a specific client requirement
      const TEMP_DOBBERT_COMPANIES_ORG_ID = 'ORG-thedobbertcompanies-1712945478218_809303ad739041c6bc051888bd8fd229';
      if ('dl' in self.clientUrlParams || self.organizationId === TEMP_DOBBERT_COMPANIES_ORG_ID) {
        self.isDownloadDisabled = true;
      }

      // data for ckeditor
      self.ckeditorAgreementId = self.agreementCustomInputs.ckeditoragreementid || null;
      self.ckeditorHtmlData = self.agreementCustomInputs.ckeditorhtmldata || null;
      if (self.ckeditorAgreementId && self.ckeditorHtmlData) {
        console.log('ckeditorAgreementId loaded');
        console.log('ckeditorHtmlData loaded');
        self.isCkeditorAgreement = true;
      } else {
        console.log('no ckeditor data loaded');
      }

      // superDoc data
      self.superdocId = self.agreementData.superdoc_id || null;

      // Previous signer data for multi-signer agreements
      self.previousSignerData = responseData.previoussignerdata;

      // set current user document sharing role
      const allSigners = self.previousSignerData.allsignersinfo;
      const currentSignerInfo = allSigners.find(
        (signer) => signer.recipientemail === self.userInfo.email,
      );
      const currentSignerSharingRole = currentSignerInfo?.recipientdocumentsharingrole;
      self.userInfo.recipientdocumentsharingrole = currentSignerSharingRole || 'reader';

      //Determine if user uploads are allowed
      self.isUserContentUploadingEnabled = false; //#default
      let countEmailInput = 0;

      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          //Get item type
          let itemType = item.itemtype;
          console.log('-- #processAgreementData - loading item (' + itemType + ')', item);

          // If item is required, hidden and URL param enabled we need to ensure
          // That we have a value for it. If no value, we must show it on the form for user input.
          if (item.ishidden && item.isurlparametervalueenabled) {
            const is_required = item.itemvalidations.some(
              (validation) => validation?.itemvalidationtype === 'REQUIREDINPUT',
            );
            const defaultValue = item.itemdefaultvalue;
            const urlParamId = item.urlparameterid;
            const urlValue = self.clientUrlParams[urlParamId];

            // Check: is it required and has no default value and has no URL param value? If so, show it
            // Otherwise agreement can't be submitted
            if (!!is_required && !defaultValue && !urlValue) {
              item.ishidden = false;
            }
          }
          if (itemType == 'UPLOAD') {
            self.isUserContentUploadingEnabled = true;
          }
          if (
            item.itemspeciallinkedvalue == 'EMAIL' ||
            item.iteminputtededitorselectiontype == 'EMAILTEXTINPUT'
          ) {
            if (self.userInfo && 'completionindex' in self.userInfo) {
              let requredIndex = item.itemvisiblerequiredindex;
              let userIndex = self.userInfo.completionindex;
              if (
                requredIndex == userIndex ||
                item.itemvisiblerequiredindex == undefined ||
                item.itemvisiblerequiredindex == null
              ) {
                countEmailInput += 1;
              }
            }
          }
          if (countEmailInput > 1) {
            self.isLoginOptionDisabled = true;
          }

          if (!self.itemValues) return;

          // Autosave loading: Detect fields that need
          // special treatment to update their values:
          // textarea, image, checkbox, email, upload, signature
          let autosavedValue = null;
          if (itemType == 'HTMLINPUT') {
            item.itemdefaultvalue = self.itemValues[item.itemid] || item.itemdefaultvalue;
          } else if (itemType == 'IMAGEINPUT') {
            if (self.itemValues[item.itemid]) {
              item.itemfilename = self.itemValues[item.itemid];
              item.itemname = self.itemValues[item.itemid + '_name'];
              autosavedValue = self.itemValues[item.itemid];
            }
          } else if (itemType == 'SIGNATUREINPUT') {
            // This is handled when the signature pad emits the 'ready' event
            // which calls self.handleSigpadReady()
          } else if (itemType == 'CHECKBOXINPUT') {
            if (typeof item.checkcount !== 'number') {
              item.checkcount = 0;
            }
            for (let box of item.itemoptions) {
              if (self.itemValues[box.itemid] === item.itemcheckedvalueyes) {
                box.valueToggle = true;
                item.checkcount++;
              } else {
                self.itemValues[box.itemid] = item.itemcheckedvalueno;
              }
            }
            self.$forceUpdate();
          } else if (itemType == 'CHECKBOX') {
            const checkboxValue = self.itemValues[item.itemid];
            if (checkboxValue) {
              item.itemdefaultvalue = checkboxValue;
              const itemIsChecked = checkboxValue === item.itemcheckedvalueyes;
              self.updateStoreCheckboxValue(item, itemIsChecked);
              // update consent checkbox
              if (item.itemgroup === 'esignconsent') self.isConsentChecked = itemIsChecked;
            }
          } else if (itemType == 'TEXTINPUT' && item.iteminputtype == 'email') {
            if (!self.emailConfirmationValue) {
              self.userEmail = self.itemValues[item.itemid];
              self.typingEmailConfirmationDebounced(item);
            }
          } else if (itemType == 'UPLOAD') {
            if (self.itemValues.attachments) {
              self.userContentAttachments = [];
              for (let file of self.itemValues.attachments) {
                const loadFile = new File([file.base64data], file.name, { type: file.type });
                loadFile.base64data = file.base64data;
                loadFile.itemid = file.itemid;
                self.userContentAttachmentsBuffer.push(loadFile);
                self.fileUploadInputClickHandler(item);
              }
              delete self.itemValues['attachments'];
            }
          } else if (itemType == 'YESNO') {
            if (self.itemValues[item.itemid] && Array.isArray(self.itemValues[item.itemid])) {
              self.checkboxInputHandler(item, self.itemValues[item.itemid][0]);
              self.unhideAutosaveData(item, self.itemValues[item.itemid][0]);
            }
          } else if (itemType == 'SELECT') {
            if (self.itemValues[item.itemid]) {
              self.unhideAutosaveData(item, self.itemValues[item.itemid]);
            }
          } else if (self.checkInputTypes.includes(item.itemtype)) {
            if (item.itemconsents) {
              item.itemconsents.forEach((consent) => {
                if (!self.checkConsents.some((e) => e.consenttype == consent.consenttype)) {
                  consent.id = `checkconsent-${Date.now()}-${Math.floor(
                    Math.random() * 1000000000000,
                  )}`;
                  self.checkConsents.push(consent);
                }
              });
            }
          }
        });
      });

      //If user uploads allowed --> determine/store which one is connected to the main uploader
      if (self.isUserContentUploadingEnabled == true) {
        //Find/associate connected uploader item
        self.agreementData.agreementcontent.sections.forEach(function (section) {
          section.sectionitems.forEach(function (item) {
            if (item.itemspeciallinkedvalue == 'MAINCONTENTUPLOAD') {
              self.userContentMainUploaderItem = item;
            }
          });
        });
        //Connected UPLOADER item found?
        if (self.userContentMainUploaderItem == null) {
          alert('Agreement misconfiguration: no MAINCONTENTUPLOAD specified');
          return false;
        }
      }

      //Run quick item validations --> cancel render if issue found, log issue
      if (self.initialAgreementDataValidations() == false) {
        console.log('-- #AGEEMENTDATA - agreement data validations failed');
        return false;
      }

      // Prepare previous signers attachments for preview
      self.prepareSignersAttachments(
        responseData.previoussignerdata?.aggregateditemvalues.userattachments,
      );

      //Set initial item IDs in the order of appearing on UI
      self.initItemValuesItemIds();

      //Set initial item values by URL parameters, as items are eligible
      self.initItemValuesStoreUrlParameterValues();

      //Set initial item stored values -- i.e, empty or set to agreement-provided default value
      self.initItemValuesStoreDefaults();

      // set properties of conditionally hidden inputs for conditional logic inputs
      self.setInitialHiddenInputs();

      // load item values stored in local storage
      await self.loadLocalStorageValues();

      // set esign consent check
      self.setEsignConsentCheckByItemValue();

      // update saved image upload values to support single image upload inputs
      self.updateImageUploadValues();

      //Set inital econsent stored value
      self.initEConsentStoreDefaults();

      self.initConsentsGivenFlag();

      //Success~! - store update and return
      self.storeAgreementUpdate(
        '#AGREELINKAUTHENTICATEDANDCONTENTLOADED',
        '#AGREELINKAUTHENTICATEDANDCONTENTLOADED',
        'agreement link authenticated and content loaded',
      );

      if (self.isUser && self.isUserEmail) {
        self.agreelinkIssigloading = true;
        self.requestSignaturesAndInitials(
          function (response) {
            console.log('#processAgreementData signatures and initials loaded');
          },
          function (error) {
            console.log('#processAgreementData error while signatures and initials loaded');
            console.log(error);
          },
        );
      }


      this.initCheckStatuses();

      await this.askForEnhancedVerificationResult();
      await this.getCheckResult();
    },

    //Validate user input for targeted section(s)
    requestAgreementData(successCallback = () => {}, failedCallback = () => {}) {
      //Reset prior
      let self = this;
      self.isInitialWaitForRendereredPDF = false;
      self.agreementRequestCount = self.agreementRequestCount + 1;
      self.isPasscodeInvalid = false;

      //Make new agreement data request
      let agreeDataUrl = '/agreelinkdata?agreelinkdata-getagreementdata';
      let agreePostData = {
        requesttype: 'agreelinkdata-getagreementdata',
        linkdisplayid: self.linkDisplayId,
        agreepasscode: self.linkPasscode,
        agreeemailconfirmationvalue: self.emailConfirmationValue,
        sessionid: self.clientSessionId,
      };
      console.log('Requesting... ' + agreeDataUrl);
      console.log('   - request:', agreePostData);

      self.$harbourData
        .post(agreeDataUrl, agreePostData)
        .then(async(response) => {
          //Response back
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - response:', response);

          if (response.data.superdoc_document_files) {
            await self.prepareSuperdocPreview(response.data.superdoc_document_files);
          }

          //Stop initial "loading" overlay
          self.isInitialLoading = false;

          //Get agreement data from response
          let responseData = response.data;
          self.responseData = responseData;

          //Validate: link x agreement record data found?
          if (
            responseData.agreementstate == undefined ||
            responseData.agreementstate == 'MISSINGAGREEMENTRECORD'
          ) {
            self.isMissingAgreementData = true;
            console.log('-- #AGEEMENTDATA - no agreement found (*inactive or non-existent ID)');
            return false;
          }

          //Validate: link-attached agreement PDF found? (*allow wait to check again in a bit, if needed)
          if (
            responseData.agreementstate == 'NORENDEREDDISPLAYPDFYET' &&
            self.agreementRequestCount < 4
          ) {
            console.log(
              '-- #AGEEMENTDATA - waiting for rendering of agreemment PDF... ' +
                self.agreementRequestCount +
                ' (+10 seconds)',
            );
            self.isInitialWaitForRendereredPDF = true; //*keep loading
            setTimeout(function () {
              self.isInitialLoading = true;
              self.requestAgreementData();
            }, 6000); //~6 seconds
            return false;
          }

          //Validate: successful authentication?
          if (
            responseData.agreementstate != 'ALLAGREEMENTINFOFOUND' ||
            responseData.isauthenticationsuccess != true
          ) {
            //== PASSCODE ==
            //-- missing passcode (*e.g., first link open)
            if (responseData.authenticationstatemessage == '#MISSINGPASSCODE') {
              console.log('-- #AGEEMENTDATA - missing passcode (e.g., first load)');
              self.isPasscodeNeeded = true;
              self.isPasscodeInvalid = false;
              //-- invalid passcode attempt
            } else if (responseData.authenticationstatemessage == '#INVALIDPASSCODE') {
              console.log('-- #AGEEMENTDATA - invalid passcode');
              self.isPasscodeNeeded = true;
              self.isPasscodeInvalid = true;
              self.isTryingNewPasscode = false;
              self.linkPasscode = '';
              //== EMAILS ==
              //-- missing email confirmation (*e.g., first link open)
            } else if (responseData.authenticationstatemessage == '#MISSINGEMAILCONFRIMATION') {
              console.log('-- #AGEEMENTDATA - missing email confirmation value (e.g., first load)');
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = false;
              self.isEmailConfirmationValidButWrongIndex = false;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
              //-- invalid email confirmation attempt
            } else if (responseData.authenticationstatemessage == '#INVALIDEMAILCONFRIMATION') {
              console.log(
                '-- #AGEEMENTDATA - invalid email confirmation value (e.g., wrong email)',
              );
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = true;
              self.isEmailConfirmationValidButWrongIndex = false;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
              //-- already fully completed agreement
            } else if (
              responseData.authenticationstatemessage == '#EMAILCONFIRMATIONALLPARTIESCOMPLETED'
            ) {
              console.log('-- #AGEEMENTDATA - already completed agreement, nothing to do here');
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = false;
              self.isEmailConfirmationValidButWrongIndex = false;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = true;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
              //-- required group already signed
            } else if (
              responseData.authenticationstatemessage == '#EMAILCONFIRMATIONGROUPALREADYSIGNED'
            ) {
              console.log('-- #AGEEMENTDATA - already signed by group');
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = false;
              self.isEmailConfirmationValidButWrongIndex = false;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = true;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
              //-- user already signed
            } else if (
              responseData.authenticationstatemessage == '#EMAILCONFIRMATIONEMAILUSERALREADYSIGNED'
            ) {
              console.log('-- #AGEEMENTDATA - already signed by user');
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = false;
              self.isEmailConfirmationValidButWrongIndex = false;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = true;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
              //-- valid email but not of current index/order attempt
            } else if (
              responseData.authenticationstatemessage ==
              '#VALIDBUTNOTOFCURRENTINDEXEMAILCONFRIMATION'
            ) {
              console.log(
                '-- #AGEEMENTDATA - valid email but of incorrect index (e.g., waiting on someone else first)',
              );
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = false;
              self.isEmailConfirmationValidButWrongIndex = true;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
              //-- other
            } else if (responseData.authenticationstatemessage === '#REASSIGNED') {
              console.log('-- #AGEEMENTDATA - valid email but has been reassigned', responseData);
              self.isReassigned = true;
              self.reassignedTo = responseData.userinfo.reassignedto;
              self.isEmailConfirmationNeeded = true;
              self.isEmailConfirmationInvalid = false;
              self.isEmailConfirmationValidButWrongIndex = false;
              self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
              self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
              self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
              self.isTryingNewEmail = false;
              self.emailConfirmationValue = null;
            } else {
              alert(
                'Unable to authenticate link -- please try again later or contact support@harbourshare.com',
              );
            }
            if (self.isEmailConfirmationNeeded) {
              self.isEmailConfirmationLink = true;
            }

            failedCallback();
            return false;
          }
          if (self.isEmailConfirmationNeeded) {
            self.requestEmailCheck(
              self.emailConfirmationValue,
              function () {
                self.isReassigned = false;
                self.reassignedTo = null;
                if (self.isUser && self.isShowEmailLogin) {
                  self.isEmailConfirmationInvalid = false;
                  self.isEmailConfirmationValidButWrongIndex = false;
                  self.isEmailConfirmationButAgreementAlreadyFullyCompleted = false;
                  self.isEmailConfirmationButAgreementAlreadySignedByGroup = false;
                  self.isEmailConfirmationButAgreementAlreadySignedByUser = false;
                } else {
                  self.userEmail = self.emailConfirmationValue;
                }
                self.isTryingNewEmail = false;
                successCallback(responseData);
                return true;
              },
              function (error) {
                self.isTryingNewEmail = false;
                self.continueAsGuest();
                console.log('#requestEmailCheck error: ', error);
                failedCallback(error);
                return false;
              },
            );
          } else {
            self.isUser = true;
            self.isUserEmail = self.emailConfirmationValue;
            self.processAgreementData(responseData);
            successCallback(responseData);
            return true;
          }
        })
        .catch((error) => {
          self.isInitialLoading = false;
          self.isInvalidLink = true;
          console.log(error);
          failedCallback();

          // console logs will show up in Sentry
          console.log('agreePostData - object', agreePostData);
          const postDataString = JSON.stringify(agreePostData);
          console.log('agreePostData - string', postDataString);
          const message = 'Agreement Link Loading Error - requestAgreementData';
          console.log(`${message} - ${error} - ${postDataString}`);

          Sentry.captureException(error);
          Sentry.captureMessage(message);

          return false;
        });
    },

    showReassignedConfirmation(newSigner, originalSigner) {
      let self = this;
      const update = {
        itemid: '#REASSIGN',
        itemdisplaylabel: 'Reassign',
        itemtype: 'REASSIGN',
        itemspeciallinkedvalue: '',
      };
      const itemMessage = `from ${originalSigner}`;
      const itemValue = `to ${newSigner.name} (${newSigner.email})`;

      self.storeAgreementUpdate(update, itemMessage, itemValue);

      self.clearAutosaveData();
      self.isReassigned = true;
      self.isCompleted = true;
      self.completedTitle = 'Reassigned';
      self.reassignedTo = newSigner.email;
      self.reassignedName = newSigner.name;
      self.agreementReferenceId = null;
      self.completedMessage = `
        This agreement has been reassigned to ${newSigner.name} (<b>${newSigner.email}</b>). <br />
        They will receive an email shortly with a link to complete the agreement.
      `;
    },

    //Store base64 into file
    storeBase64() {
      let self = this;
      for (let i = 0; i < self.userContentAttachments.length; i++) {
        let tgtFile = self.userContentAttachments[i];

        if (!tgtFile.base64data) {
          //Get base64 if under max size
          if (tgtFile.size < self.userContentMaxPreviewBytes) {
            //Read file as base64 and store it appended the file
            let reader = new window.FileReader();
            reader.onloadend = function () {
              let base64data = reader.result;
              tgtFile.base64data = base64data;
              self.$forceUpdate();
            };
            reader.readAsDataURL(tgtFile);
          }
        }
      }
    },

    fileUploadInputClickHandler(item) {
      // Use buffer to work with multiple uploader inputs.
      // Written to by b-upload v-model.
      if (!this.userContentAttachmentsBuffer.length) return;
      const attachments = [...this.userContentAttachmentsBuffer];
      this.userContentAttachmentsBuffer = [];

      // save in actual attachments
      this.userContentAttachments.push(...attachments);
      this.storeNewUploads(item);
      this.storeBase64();
    },

    requestSignaturesAndInitials(successCallback, failedCallback) {
      let self = this;

      self.$harbourData
        .post('/agreelinksignaturesdata?agreelinkdata-viewusersstoredsignatures', {
          requesttype: 'agreelinkdata-viewusersstoredsignatures',
          email: self.userEmail,
        })
        .then((response) => {
          if (!response.data['stored_signatures_json'] && !response.data['stored_initials_json']) {
            self.agreelinkIssigloading = false;
          } else {
            //Stored signatures, initials json values
            self.agreelinkStoredSignatures = response.data.stored_signatures_json;
            self.agreelinkStoredInitials = response.data.stored_initials_json;
            self.agreelinkIssigloading = false;
            successCallback(response);
          }
          return true;
        })
        .catch((error) => {
          console.log('#requestSignaturesAndInitials error: ', error);
          self.agreelinkStoredSignatures = [];
          self.agreelinkStoredInitials = [];
          self.agreelinkIssigloading = false;
          failedCallback(error);
        });
    },

    //Validate user input for targeted section(s)
    requestBrandingData: function (successCallback) {
      //Make new agreement data request
      let self = this;
      let agreeDataUrl = '/agreelinkdata?agreedata-getbrandingdata';
      let agreePostData = {
        requesttype: 'agreelinkdata-getbrandingdata',
        agreedisplayid: self.linkDisplayId,
        agreementid: self.agreementId,
      };
      console.log('Requesting... ' + agreeDataUrl);
      console.log('   - request:', agreePostData);

      self.$harbourData
        .post(agreeDataUrl, agreePostData)
        .then((response) => {
          //Success!
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - response:', response);

          //Branding found?
          let responseData = response.data;
          if (
            responseData.brandingstate == undefined ||
            responseData.brandingstate != 'BRANDINGFOUND'
          ) {
            self.isMissingBrandingData = true;
            console.log('-- no branding results (*inactive or non-existent ID)');
            return false;
          }

          //Success --> return callback
          successCallback(responseData);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //Submit new agreement value for updated agreement data
    updatePasscodeGetAgreementData() {
      //Validate: passcode is entered by user
      let self = this;
      if (self.linkPasscode == null || self.linkPasscode == '') {
        alert('Please enter a required passcode here to proceed further - thanks!');
        return false;
      }
      //Send to server for response
      self.isPasscodeInvalid = false;
      self.isTryingNewPasscode = true;
      self.requestAgreementData(() => {
        self.isTryingNewPasscode = false;
      });
    },

    //Submit new agreement value for updated agreement data
    typingEmailConfirmation(item) {
      //Validate: email value is entered by user
      let self = this;
      if (self.itemValues[item.itemid] != self.userEmail) {
        self.itemValues[item.itemid] = self.userEmail;
      }
      if (self.initialSave) {
        self.autosave(item, self.userEmail, '');
      }

      let regex = /\S+@\S+\.\S{2,}/;
      let validation = regex.test(self.userEmail);
      if (!validation) {
        self.continueAsGuest();
        return false;
      }
      self.isTryingNewEmail = true;

      //Check if the entered email is for existing user
      self.requestEmailCheck(
        self.userEmail,
        function () {
          self.isTryingNewEmail = false;
          console.log('#requestEmailCheck success');
        },
        function (error) {
          self.isTryingNewEmail = false;
          self.continueAsGuest();
          console.log('#requestEmailCheck error: ', error);
        },
      );
    },

    //Submit new agreement value for updated agreement data
    updateEmailConfirmationGetAgreementData() {
      //Validate: email value is entered by user
      let self = this;
      if (self.emailConfirmationValue == null || self.emailConfirmationValue == '') {
        alert('Please enter a required email here to proceed further - thanks!');
        return false;
      }
      if (
        self.emailConfirmationValue.includes('@') == false ||
        self.emailConfirmationValue.includes('.') == false
      ) {
        alert('Please enter a valid email here to proceed further - thanks!');
        return false;
      }

      //Send to server for response
      self.isEmailConfirmationInvalid = false;
      self.isTryingNewEmail = true;
      self.requestAgreementData(function () {
        // store/notify agreement view event
        self.storeAgreementLinkView();

        //Send to mixpanel
        if (typeof self.activityRecorder === 'function') {
          self.activityRecorder(
            'WebApp - Agreement Link',
            'email manually confirmed (no magic link)',
            {
              message: 'web app agreement link - email manually confirmed',
              linkid: self.linkDisplayId,
            },
            'MEDIUM',
            'MANUAL-EMAILCONFIRMATION',
          );
        }
      });
    },

    //Update stored signature and send to server
    updateStoredSignature(item, newValue) {
      let self = this;
      let itemId = item.itemid;
      self.itemValues[itemId] = newValue;

      if (newValue != null) {
        self.storeAgreementUpdate(item, '#SIGNED', 'signaturepad updated');
      } else {
        self.storeAgreementUpdate(item, '#EMPTY', 'signaturepad updated');
      }
      self.$forceUpdate();
      return false;
    },

    //Update stored html editor value and send to server
    updateStoredHtmlInput(item, newValue) {
      let self = this;
      let itemId = item.itemid;
      self.itemValues[itemId] = newValue;
      if (newValue != null) {
        self.debounceStoreAgreementUpdate(item, '#PARAGRAPHTEXTUPDATED', 'html paragraph updated');
      } else {
        self.debounceStoreAgreementUpdate(item, '#EMPTY', 'signaturepad updated');
      }
      self.$forceUpdate();
      return false;
    },

    //Reloads on click
    reloadSite() {
      location.reload();
    },

    //Open new tab
    openNewTab(tgtUrl) {
      window.open(tgtUrl);
    },

    //Onload item validation
    initialAgreementDataValidations() {
      //Init
      let self = this;
      let isValid = true;
      let foundIds = [];

      //Check items
      self.agreementData.agreementcontent.sections.forEach(function (section, sectionIndex) {
        section.sectionitems.forEach(function (item, itemIndex) {
          //Item info
          let itemId = item.itemid;
          let itemLabel = item.itemdisplaylabel;

          //Validate: look for duplicate item ids
          if (foundIds.includes(itemId) == true) {
            alert(
              'Invalid form: duplicate item ID detected on: ' + itemLabel + ' (' + itemId + ')',
            );
            console.log('Item validation - ISSUE:', item);
            isValid = false;
          }
          foundIds.push(itemId);

          //Validate: item validations array exists
          if (item.itemvalidations == undefined || Array.isArray(item.itemvalidations) == false) {
            alert(
              'Invalid form: missing item validations array ' + itemLabel + ' (' + itemId + ')',
            );
            console.log('Item validation - ISSUE:', item);
            isValid = false;
          }
        });
      });
      return isValid;
    },

    //Setup all item IDs (visible and invisible) in order of appearing on the UI
    initItemValuesItemIds() {
      let sections = this.agreementData?.agreementcontent.sections;
      for (let section of sections) {
        for (let item of section.sectionitems) {
          this.itemValues[item.itemid] = null;
        }
      }
    },

    // Backward compatibility for image upload input
    updateImageUploadValues() {
      let sections = this.agreementData?.agreementcontent.sections;
      for (let section of sections) {
        for (let item of section.sectionitems) {
          if (item.itemtype === 'IMAGEINPUT' && this.itemValues[item.itemid]) {
            // if not array
            if (!Array.isArray(this.itemValues[item.itemid])) {
              const attachment = this.userContentAttachments.find(
                (attachment) => attachment.itemid === item.itemid,
              );
              if (!attachment) continue;
              this.itemValues[item.itemid] = attachment
                ? [
                    {
                      userattachmentid: attachment.id,
                    },
                  ]
                : [];
            } else {
              // if array
              // filter values which was not saved to local storage due to its size
              this.itemValues[item.itemid] = this.itemValues[item.itemid].filter((valueItem) => {
                const attachment = this.userContentAttachments.find(
                  (attachment) => attachment.id === valueItem.userattachmentid,
                );
                return attachment?.id;
              });
            }
          }
        }
      }
    },

    setEsignConsentCheckByItemValue() {
      const esignConsentInput = this.allSignerInputs.find(
        (item) => item.itemgroup === 'esignconsent',
      );
      if (!esignConsentInput) return;

      const esignItemValue = this.itemValues[esignConsentInput?.itemid] || null;
      if (esignItemValue === esignConsentInput.itemcheckedvalueyes) this.isConsentChecked = true;
    },

    async loadLocalStorageValues() {
      // Autosave feature: Load the data in local storage if any
      let draftData = null;
      try {
        draftData = localStorage.getItem(this.linkDisplayId);
      } catch (e) {
        console.debug('No autosave data found');
      }

      const addressData = localStorage?.getItem(`${this.linkDisplayId}_addressData`);
      if (addressData) {
        this.addressData = JSON.parse(addressData);
      }
      if (draftData) {
        const parsedData = JSON.parse(draftData);
        const { attachments, ...rest } = parsedData;
        this.itemValues = {
          ...this.itemValues,
          ...rest,
        };

        if (attachments.length) {
          // add id for attachments uploaded before multiple upload input implemented
          await this.prepareLocalStorageAttachments(attachments);
        }

        if (this.itemValues.activeStepperSection) {
          this.activeStepperSection = this.itemValues.activeStepperSection;
        }

        // side effects
        this.allSignerInputs.forEach((input) => {
          const { itemtype } = input;

          if (itemtype === 'CHECKBOXINPUT') {
            for (let box of input.itemoptions) {
              const boxValue = this.itemValues[box.itemid];
              const isChecked = boxValue === box.itemcheckedvalueyes;

              // only tally checked boxes
              if (isChecked) {
                box.valueToggle = true;
                this.updateStoreCheckboxValue(box, isChecked, input);
              }
            }
          }

          if (itemtype === 'SELECT') {
            this.dropdownInputSelectHandler(input);
          }

          if (itemtype === 'YESNO') {
            const { itemid } = input;
            const value = this.itemValues[itemid];
            if (Array.isArray(value) && value.length) {
              this.checkboxInputHandler(input, value[0]);
            }
          }
        });
      }
    },

    //Pre-create item values store with any default values and markup
    initItemValuesStoreUrlParameterValues() {
      let self = this;
      let defaultItemStore = JSON.parse(JSON.stringify(self.itemValues)); //*copy

      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach(function (currentItem) {
          //Get url parameter enabled state
          let isUrlParameterEnabled = false;
          if (
            currentItem.isurlparametervalueenabled != undefined &&
            currentItem.isurlparametervalueenabled != null
          ) {
            isUrlParameterEnabled = currentItem.isurlparametervalueenabled; //*false/true
          }

          //Get any matching url parameter id and URL value (if exists)
          let urlParameterId = null;
          let urlParameterValue = null;
          if (currentItem.urlparameterid != undefined && currentItem.urlparameterid != null) {
            urlParameterId = currentItem.urlparameterid; //e.g, "item-123abc"
            urlParameterValue = self.clientUrlParams[urlParameterId]; //e.g, "Bruce Wayne"
          }

          //Populate any item/URL-eligible item value
          let itemId = currentItem.itemid;
          if (
            isUrlParameterEnabled == true &&
            urlParameterId != null &&
            urlParameterValue != undefined &&
            urlParameterValue != null
          ) {
            defaultItemStore[itemId] = self.markupCustomizeInputs(urlParameterValue);

            // populating userEmail with query param value
            // TODO: handle multiple email fields
            if (currentItem.iteminputtype === 'email') self.userEmail = defaultItemStore[itemId];
          }
        });
      });

      self.itemValues = {
        ...self.itemValues,
        ...defaultItemStore,
      };
      return false;
    },

    //Pre-create item values store with any default values and markup
    initItemValuesStoreDefaults() {
      let self = this;
      let defaultItemStore = JSON.parse(JSON.stringify(self.itemValues)); //*copy

      let userIndex = self.userInfo.completionindex;

      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          //Set item default value (if it has one)
          let itemLinkedValue = item.itemspeciallinkedvalue;
          let itemCurrentValue = self.itemValues[item.itemid];

          let isAgreementEditorNameField =
            'iteminputtededitorselectiontype' in item
              ? item.iteminputtededitorselectiontype == 'NAMETEXTINPUT'
              : false;
          let isAgreementEditorEmailField =
            'iteminputtededitorselectiontype' in item
              ? item.iteminputtededitorselectiontype == 'EMAILTEXTINPUT'
              : false;

          let isAgreementEditorJobTitleField =
            'iteminputtededitorselectiontype' in item
              ? item.iteminputtededitorselectiontype == 'JOBTITLETEXTINPUT'
              : false;

          let isAgreementEditorPhoneNumberField =
            'iteminputtededitorselectiontype' in item
              ? item.iteminputtededitorselectiontype == 'PHONETEXTINPUT'
              : false;

          //Check for pre-populating the name and email values either because the user is signed in
          // or because it's an email auth agreement link
          if (!self.isGuest) {
            if ((isAgreementEditorNameField || itemLinkedValue === 'NAME') && !itemCurrentValue) {
              if (!item.itemdefaultvalue && self.userName && !self.isLoginOptionDisabled) {
                item.itemdefaultvalue = self.userName;

                const [firstName, lastName] = self.userName.split(' ');
                if (item.autoaddedinternalname === 'first_name') {
                  item.itemdefaultvalue = firstName;
                } else if (item.autoaddedinternalname === 'last_name') {
                  item.itemdefaultvalue = lastName;
                }
              } else if (
                self.isAuthenticatedByMagicLink &&
                'userinfo' in self.responseData &&
                self.responseData.userinfo &&
                !self.isLoginOptionDisabled
              ) {
                item.itemdefaultvalue = self.responseData.userinfo.fullname;

                const [firstName, lastName] = self.responseData.userinfo.fullname.split(' ');
                if (item.autoaddedinternalname === 'first_name') {
                  item.itemdefaultvalue = firstName;
                } else if (item.autoaddedinternalname === 'last_name') {
                  item.itemdefaultvalue = lastName;
                }
              }
            }
            if (isAgreementEditorJobTitleField && !itemCurrentValue) {
              if (!item.itemdefaultvalue && self.userJobTitle && !self.isLoginOptionDisabled) {
                item.itemdefaultvalue = self.userJobTitle;
              }
            }
            if (isAgreementEditorPhoneNumberField && !itemCurrentValue) {
              if (
                !item.itemdefaultvalue &&
                self.contextDict?.userinfo_phonenumber &&
                !self.isLoginOptionDisabled
              ) {
                item.itemdefaultvalue = self.contextDict?.userinfo_phonenumber;
              }
            }
            if (
              (isAgreementEditorEmailField || itemLinkedValue === 'EMAIL') &&
              !itemCurrentValue &&
              !self.isLoginOptionDisabled
            ) {
              if (!item.itemdefaultvalue && self.userEmail) {
                item.itemdefaultvalue = self.userEmail;
                self.typingEmailConfirmationDebounced(item);
              } else if (
                self.isAuthenticatedByMagicLink &&
                'userinfo' in self.responseData &&
                self.responseData.userinfo &&
                !self.isLoginOptionDisabled
              ) {
                item.itemdefaultvalue = self.responseData.userinfo.email;
                self.typingEmailConfirmationDebounced(item);
              }
            }
          }
          if (
            self.isGuest &&
            self.isEmailConfirmationLink &&
            'userinfo' in self.responseData &&
            self.responseData.userinfo
          ) {
            if (
              (isAgreementEditorNameField || itemLinkedValue === 'NAME') &&
              !itemCurrentValue &&
              !self.isLoginOptionDisabled
            ) {
              const [firstName, lastName] = self.responseData.userinfo.fullname.split(' ');
              if (item.autoaddedinternalname === 'first_name') {
                item.itemdefaultvalue = firstName;
              } else if (item.autoaddedinternalname === 'last_name') {
                item.itemdefaultvalue = lastName;
              } else if (!self.visibleIneligibleItemsArray.includes(item.itemid)) {
                item.itemdefaultvalue = self.responseData.userinfo.fullname;
              }
            }
            if (
              (isAgreementEditorEmailField || itemLinkedValue === 'EMAIL') &&
              !itemCurrentValue &&
              !self.isLoginOptionDisabled
            ) {
              //console.log('EMAIL field before default', item, item.itemtype, 'id', item.itemid, 'default value:', item.itemdefaultvalue, item.iteminputtededitorselectiontype)
              // Any email field is being defaulted to current user
              // Where are email fields being hidden?
              if (!self.visibleIneligibleItemsArray.includes(item.itemid)) {
                item.itemdefaultvalue = self.responseData.userinfo.email;
                self.typingEmailConfirmationDebounced(item);
              }
              //console.log('EMAIL field after default', item, item.itemtype, 'id', item.itemid, 'default value:', item.itemdefaultvalue, item.iteminputtededitorselectiontype)
            }
          }
          let itemId = item.itemid;
          let itemDefaultValue = item.itemdefaultvalue;
          if (itemDefaultValue != undefined && itemDefaultValue != null && itemDefaultValue != '') {
            defaultItemStore[itemId] = self.markupCustomizeInputs(itemDefaultValue);
          }

          // Add sign date input
          if (
            item.itemtype === 'TEXTINPUT' &&
            (item.iteminputtededitorselectiontype == 'DATEINPUT' ||
              item.iteminputtededitorselectiontype == 'SIGNDATEINPUT') &&
            item.isdefaultdisplayed == false
          ) {
            if (
              item.itemvisiblerequiredindex != undefined &&
              item.itemvisiblerequiredindex != null
            ) {
              let requredIndex = item.itemvisiblerequiredindex;
              let userIndex = self.userInfo.completionindex;
              if (requredIndex == userIndex) {
                let current_date = self.getFormattedDate(null, item.itemformat);
                defaultItemStore[itemId] = current_date;
              }
            } else {
              let current_date = self.getFormattedDate(null, item.itemformat);
              defaultItemStore[itemId] = current_date;
            }
          }

          //Check how many number of name fields we have to pre-populate the type-to-sign value
          if (isAgreementEditorNameField || itemLinkedValue == 'NAME') {
            if (self.userInfo && 'completionindex' in self.userInfo) {
              let requredIndex = item.itemvisiblerequiredindex;
              let userIndex = self.userInfo.completionindex;
              if (
                requredIndex == userIndex ||
                item.itemvisiblerequiredindex == undefined ||
                item.itemvisiblerequiredindex == null
              ) {
                // TODO: empty block?
              }
            }
          }

          //Remove default values for name fields not belonging to this signer
          if (item.itemvisiblerequiredindex && item.itemvisiblerequiredindex !== userIndex) {
            delete defaultItemStore[item.itemid];
            self.visibleIneligibleItemsArray.push(item.itemid);
          }
        });
      });
      self.itemValues = {
        ...self.itemValues,
        ...defaultItemStore,
      };
      if (
        self.isEmailConfirmationLink &&
        'userinfo' in self.responseData &&
        self.responseData.userinfo
      ) {
        self.typedUserName = self.responseData.userinfo.fullname;
      }
      return false;
    },

    initConsentsGivenFlag() {
      const emailValue = this.userEmail || '';
      this.isConsentsGiven = this.getLocalStorageKey('consents_given', emailValue) || false;
    },

    //Pre-click e-consent checkbox if signer has just-recently checked it from a different link
    initEConsentStoreDefaults() {
      //If we do not have a recent, prior stored YES e-consent(s), then skip any action
      let self = this;
      let priorStoredEConsents = self.getCookie('harbour-prior-econsents');
      if (
        priorStoredEConsents == null ||
        priorStoredEConsents == '' ||
        priorStoredEConsents == 'NO'
      ) {
        console.log(
          '#initEConsentStoreDefaults - no prior, recent stored e-consents for auto-checking, skipping',
        );
        return false;
      }

      //If we have recent, prior stored YES e-consent(s) -- but includes the same link display id -- then skip any action
      let currentLinkDisplayId = '||' + self.linkDisplayId + '||';
      if (priorStoredEConsents.indexOf(currentLinkDisplayId) !== -1) {
        console.log(
          '#initEConsentStoreDefaults - currently link is a repeat and ineligble for auto-checking, skipping',
        );
        return false;
      }

      //With recent, prior stored YES e-consents(s), then auto-check e-consents checkbox on load
      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          if (item.itemgroup == 'esignconsent' && item.itemtype == 'CHECKBOX') {
            console.log('#initEConsentStoreDefaults - found prior, recent econsent: auto-checking');
            self.$set(self.itemValues, item.itemid, 'YES');
            self.isConsentChecked = true;
            self.$forceUpdate();
          }
        });
      });

      //Done
      return false;
    },

    //Validate user input for targeted section(s)
    validateSection(sectionNum, successCallback, options) {
      let self = this;
      let isSuccess = true;
      const { hideAlert } = options ?? {};
      self.agreementData.agreementcontent.sections.forEach(function (section, sectionIndex) {
        section.sectionitems.forEach(function (item, itemIndex) {
          // skip item if hidden by conditional logic input
          if (self.currentlyHiddenConditionalInputs[item.itemid] || item.ishidden) {
            return;
          }

          //Get values
          let itemId = item.itemid;
          let itemLabel = item.itemdisplaylabel;
          let itemGroup = item.itemgroup;
          let itemLabelDisplay = '';
          if (itemLabel == null || itemLabel.trim() == '') {
            itemLabelDisplay = 'An item';
          } else {
            itemLabelDisplay = 'The "' + itemLabel + '" item';
          }
          let itemType = item.itemtype;
          let itemCurrentValue = self.itemValues[item.itemid];
          if (itemCurrentValue == undefined) {
            itemCurrentValue = null;
          }
          if (itemCurrentValue == '') {
            itemCurrentValue = null;
          }
          let itemFiles = self.userContentAttachments.filter(function (d) {
            return d.itemid == itemId;
          });

          //Save any special values
          let itemLinkedValue = item.itemspeciallinkedvalue;
          if (itemLinkedValue == 'EMAIL') {
            self.linkedValueUserEmail = itemCurrentValue;
          }

          //Get all group counts
          let itemGroupCollection = [];
          self.agreementData.agreementcontent.sections.forEach(function (sect) {
            sect.sectionitems.forEach(function (d) {
              if (d.itemgroup != undefined && d.itemgroup != null && d.itemgroup == itemGroup) {
                itemGroupCollection.push(d);
              }
            });
          });

          //Eligible item to validate
          if (sectionNum == 'ALL' || sectionNum == sectionIndex) {
            //Validate eligible item
            let requiredValidations = item.itemvalidations;
            requiredValidations.forEach(function (validation) {
              //*Skip validation if item not eligible for display
              if (self.visibleIneligibleItemsArray.includes(item.itemid) == true) {
                return;
              }
              if (
                item.itemtype === 'TEXTINPUT' &&
                (item.iteminputtededitorselectiontype == 'DATEINPUT' ||
                  item.iteminputtededitorselectiontype == 'SIGNDATEINPUT') &&
                item.isdefaultdisplayed == false
              ) {
                return;
              }

              // skip if validation type not present
              if (!validation.itemvalidationtype) {
                console.log(
                  `#validateSection - ${itemLabelDisplay} was not validated - missing validation type`,
                );
                return;
              }

              //DISPLAYTEXT - required agreement view
              if (
                isSuccess === true &&
                itemType === 'DISPLAYTEXT' &&
                validation.itemvalidationtype === 'REQUIREDAGREEMENTVIEW' &&
                !self.finaldocumentviewed
              ) {
                if (!item.documentviewed) {
                  isSuccess = false;
                  console.log(
                    '#validateSection - failed validation - REQUIREDAGREEMENTVIEW, halted',
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      // build alert message
                      const sectionsCount = self.agreementData.agreementcontent.sections.length;
                      const sectionLabel =
                        sectionsCount > 1 ? `section ${sectionIndex + 1}` : 'this section';
                      const viewAgreementLabel = item.itemdisplaylabel
                        ? `under "${item.itemdisplaylabel}"`
                        : '';
                      const alertMessage = `To proceed further, it is required to view/open the agreement document ${viewAgreementLabel} (*which is linked to in ${sectionLabel}). Thanks!`;
                      alert(alertMessage);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //YES/NO - required input
              if (
                isSuccess == true &&
                itemType == 'YESNO' &&
                validation.itemvalidationtype == 'REQUIREDINPUT'
              ) {
                if (itemCurrentValue == null || itemCurrentValue.length == 0) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDINPUT, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires a response to proceed further. Thanks.`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //DURATION - required input number
              if (
                isSuccess == true &&
                itemType == 'DURANTIONINPUT' &&
                validation.itemvalidationtype == 'REQUIREDINPUTNUMBER'
              ) {
                if (isNaN(itemCurrentValue) == true) {
                  isSuccess = false;
                  console.log(
                    '#validateSection - failed validation - REQUIREDINPUTNUMBER, halted',
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires a number to proceed further. Thanks.`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //YES/NO - required yes
              if (
                isSuccess == true &&
                itemType == 'YESNO' &&
                validation.itemvalidationtype == 'REQUIREDYES'
              ) {
                if (
                  itemCurrentValue == null ||
                  itemCurrentValue.length != 1 ||
                  itemCurrentValue[0] != 'YES'
                ) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDYES, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(
                        `${itemLabelDisplay} requires a YES response to proceed further. Thanks.`,
                      );
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //UPLOAD - required attachment (always)
              if (
                isSuccess == true &&
                itemType == 'UPLOAD' &&
                validation.itemvalidationtype == 'REQUIREDUPLOAD'
              ) {
                if (itemFiles.length == 0) {
                  isSuccess = false;
                  console.log(
                    '#validateSection - failed validation - REQUIREDUPLOAD, halted',
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(
                        `${itemLabelDisplay} requires an uploaded file to proceed further. Thanks.`,
                      );
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //UPLOAD - required attachment -- when no reference files[s] are present
              if (
                isSuccess == true &&
                itemType == 'UPLOAD' &&
                validation.itemvalidationtype == 'REQUIREDUPLOADWHENNOREFERENCE'
              ) {
                if (self.linkReferenceAttachments.length == 0 && itemFiles.length == 0) {
                  isSuccess = false;
                  console.log(
                    '#validateSection - failed validation - REQUIREDUPLOADWHENNOREFERENCE, halted',
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(
                        `${itemLabelDisplay} requires an uploaded file to proceed further. Thanks.`,
                      );
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //TEXTINPUT - required input
              if (
                isSuccess == true &&
                itemType == 'TEXTINPUT' &&
                validation.itemvalidationtype == 'REQUIREDINPUT'
              ) {
                if (itemCurrentValue == null || itemCurrentValue.trim() == '') {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDINPUT, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires text input to proceed further. Thanks.`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              // NAMEINPUT, ZIPCODEINPUT, AGEVALIDATION, SSNTEXTINPUT, PHONETEXTINPUT
              if (
                isSuccess &&
                [
                  'NAMETEXTINPUT',
                  'ZIPCODETEXTINPUT',
                  'DATEINPUT',
                  'SSNTEXTINPUT',
                  'PHONETEXTINPUT',
                ].includes(item.iteminputtededitorselectiontype)
              ) {
                const { isValid, message } = self.inputValueIsValid(item, itemCurrentValue);
                if (!isValid) {
                  isSuccess = false;
                  console.log(
                    `#validateSection - failed validation - ${item.iteminputtededitorselectiontype}, halted`,
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    alert(`${itemLabelDisplay} - ${message}. Thanks.`);
                  }, 100);
                  return;
                }
              }

              //TEXTINPUT - valid email input
              if (
                isSuccess == true &&
                itemType == 'TEXTINPUT' &&
                validation.itemvalidationtype == 'VALIDEMAIL'
              ) {
                let emailDotCount = (itemCurrentValue.match(/\./g) || []).length;
                let emailAtCount = (itemCurrentValue.match(/\@/g) || []).length;
                if (emailDotCount == 0 || emailAtCount != 1) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - VALIDEMAIL, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(
                        `${itemLabelDisplay} requires a valid email to proceed further. Thanks.`,
                      );
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //IMAGEINPUT - required input
              if (
                isSuccess == true &&
                itemType == 'IMAGEINPUT' &&
                validation.itemvalidationtype == 'REQUIREDINPUT'
              ) {
                if (itemCurrentValue == null || itemCurrentValue.length == 0) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDINPUT, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(
                        `${itemLabelDisplay} requires an uploaded image to proceed further. Thanks.`,
                      );
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }

                // check attachments
                let attachmentFailure = false;
                itemCurrentValue.forEach(inputAttachment => {
                  const file = self.userContentAttachments.find(fileAttachment => fileAttachment.id === inputAttachment.userattachmentid);
                  if (!file) {
                    attachmentFailure = true;
                    return;
                  }
                  if (file.isuploaded !== true) attachmentFailure = true;
                });

                if (attachmentFailure) {
                  alert('Your image is still uploading. Try submitting again in a little bit after upload is complete.');
                  isSuccess = false;
                  return;
                }
              }

              //PARAGRAPHINPUT - required input
              if (
                isSuccess == true && (itemType == 'PARAGRAPHINPUT' || itemType == 'HTMLINPUT') &&
                validation.itemvalidationtype == 'REQUIREDINPUT'
              ) {
                if (itemCurrentValue == null || itemCurrentValue.trim() == '') {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDINPUT, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires text input to proceed further. Thanks.`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //SIGNATURE - required input (always)
              if (
                isSuccess == true &&
                itemType == 'SIGNATUREINPUT' &&
                validation.itemvalidationtype == 'REQUIREDINPUT'
              ) {
                if (itemCurrentValue == null) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDINPUT, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(
                        `${itemLabelDisplay} requires a completed signature to proceed further. Thanks.`,
                      );
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //CHECKBOX - required group inputs (min)
              if (
                isSuccess == true &&
                itemType == 'CHECKBOX' &&
                validation.itemvalidationtype == 'REQUIREDGROUPCOUNTMIN'
              ) {
                let itemGroupCollectionTrue = itemGroupCollection.filter(function (d) {
                  return self.itemValues[d.itemid] == d.itemcheckedvalueyes;
                });
                if (itemGroupCollectionTrue.length < validation.itemvalidationtruecount) {
                  isSuccess = false;
                  console.log(
                    '#validateSection - failed validation - REQUIREDGROUPCOUNTMIN, halted',
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires a further answer(s) to proceed.`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //CHECKBOX - required group inputs (max)
              if (
                isSuccess == true &&
                itemType == 'CHECKBOX' &&
                validation.itemvalidationtype == 'REQUIREDGROUPCOUNTMAX'
              ) {
                let itemGroupCollectionTrue = itemGroupCollection.filter(function (d) {
                  return self.itemValues[d.itemid] == d.itemcheckedvalueyes;
                });
                if (itemGroupCollectionTrue.length > validation.itemvalidationtruecount) {
                  isSuccess = false;
                  console.log(
                    '#validateSection - failed validation - REQUIREDGROUPCOUNTMAX, halted',
                    item,
                  );
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires fewer selections to proceed`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              //CHECKBOX - required true for specific checkbox (always)
              if (
                isSuccess == true &&
                itemType == 'CHECKBOX' &&
                validation.itemvalidationtype == 'REQUIREDTRUE'
              ) {
                if (item.itemcheckedvalueyes != itemCurrentValue) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDTRUE, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires a YES selection to proceed`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }

              // CHECKBOXINPUT - conditionally required true for group of checkboxes
              if (
                isSuccess == true &&
                itemType == 'CHECKBOXINPUT' &&
                validation.itemvalidationtype.includes('CHECKSREQUIRED')
              ) {
                const count = item.checkcount;
                const required = validation.numchecksrequired;
                const comparisonFails = {
                  MINCHECKSREQUIRED: count < required,
                  MAXCHECKSREQUIRED: count > required,
                  EXACTCHECKSREQUIRED: count !== required,
                  ALLCHECKSREQUIRED: count < item.itemoptions.length,
                };
                if (comparisonFails[validation.itemvalidationtype]) {
                  isSuccess = false;
                  console.log(
                    `#validateSection - failed validation - ${validation.itemvalidationtype}, halted`,
                    item,
                  );
                  self.activeStepperSection = sectionIndex;

                  const failureMessages = {
                    MINCHECKSREQUIRED: `at least ${required}`,
                    MAXCHECKSREQUIRED: `no more than ${required}`,
                    EXACTCHECKSREQUIRED: `exactly ${required}`,
                    ALLCHECKSREQUIRED: 'all',
                  };

                  if (hideAlert) return;

                  setTimeout(function () {
                    alert(
                      `${itemLabelDisplay} requires ${
                        failureMessages[validation.itemvalidationtype]
                      } boxes checked to proceed`,
                    );
                  }, 100);
                  return;
                }
              }

              //SELECT - required true for specific checkbox (always)
              if (
                isSuccess == true &&
                itemType == 'SELECT' &&
                validation.itemvalidationtype == 'REQUIREDINPUT'
              ) {
                if (itemCurrentValue == null) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - REQUIREDINPUT, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  if (
                    validation.itemvalidationcustommsg == undefined ||
                    validation.itemvalidationcustommsg == null
                  ) {
                    alert(`${itemLabelDisplay} requires a completed answer to proceed`);
                  } else {
                    alert(`${validation.itemvalidationcustommsg}`);
                  }
                  return;
                }
              }

              // URLTEXTINPUT - valid url input
              if (
                isSuccess == true &&
                itemType == 'TEXTINPUT' &&
                validation.itemvalidationtype == 'VALIDURL'
              ) {
                const potentialURL = itemCurrentValue ? itemCurrentValue.split('.') : null;
                if (!potentialURL || potentialURL.length <= 1 || potentialURL.includes('')) {
                  isSuccess = false;
                  console.log('#validateSection - failed validation - VALIDURL, halted', item);
                  self.activeStepperSection = sectionIndex;
                  if (hideAlert) return;

                  setTimeout(function () {
                    if (
                      validation.itemvalidationcustommsg == undefined ||
                      validation.itemvalidationcustommsg == null
                    ) {
                      alert(`${itemLabelDisplay} requires a valid URL to proceed further. Thanks.`);
                    } else {
                      alert(`${validation.itemvalidationcustommsg}`);
                    }
                  }, 100);
                  return;
                }
              }
            });
          }
        });
      });
      if (isSuccess == false) {
        //Remove any stored validated section
        self.validatedSections = self.validatedSections.filter(function (d) {
          return d != sectionNum;
        });
        return false;
      } else {
        //Store validated section
        self.validatedSections.push(sectionNum);
        //Return success callback
        if (successCallback) successCallback();
        return true;
      }
    },

    //Handle/store new uploads
    storeNewUploads(item) {
      //Handle/send-to-server just the newly uploaded file(s)
      this.userContentAttachments
        .filter((file) => file.isnew === undefined)
        .forEach((newFile) => {
          //Validate: provided new file over max upload size?
          if (newFile.size > this.userContentMaxPreviewAcceptableUploadBytes) {
            alert(
              'The provided file (' +
                newFile.name +
                ') is greater than our 50GB max upload limit and will not be uploaded here. Thanks. Please contact support@harbourshare.com if you need additional assistance.',
            );
            return false;
          }

          //Init new upload
          newFile.itemid = item.itemid;
          newFile.id = item.id || `attachment-${uuidv4()}`;
          newFile.itemtype = item.itemtype;
          newFile.isnew = false;
          newFile.uploadpercent = 0;
          newFile.isuploaded = false;

          //Set upload-in-progress boolean
          this.isUserContentPendingUploads = true;

          //Store agreement input (*twice, on upload start and end)
          this.storeAgreementUpdate(item, newFile.name, 'user upload started');

          //File metadata
          let tgtJsonData = {
            requesttype: 'agreelinkdata-uploadusercontenteattachment',
            agreedisplayid: this.linkDisplayId,
            agreeclientsessionid: this.clientSessionId,
            agreedocumenttitle: newFile.name,
            agreedocumentfiletype: newFile.type, //*mime type
          };

          //Get signed URL for upload
          let tgtUrl = '/agreelinkdata?agreelinkdata-uploadusercontenteattachment';
          console.log('Requesting... ' + tgtUrl);
          console.log('   - request:', tgtJsonData);

          this.$harbourData
            .post(tgtUrl, tgtJsonData)
            .then((response) => {
              //Back
              console.log('Returning... ' + tgtUrl);
              console.log('   - response:', tgtJsonData);

              //Send the actual file data to Google Cloud Storage
              let responseData = response.data;
              let signedUrl = responseData.signeduploadurl;
              let cloudStorageEndPath = responseData.cloudstorageendpath;

              console.log('-- started upload: ' + newFile.name);

              this.$harbourData
                .put(
                  signedUrl,
                  newFile,
                  {},
                  {
                    headers: { 'content-type': newFile.type },
                    onUploadProgress(progressEvent) {
                      let uploadedPercent = Math.round((progressEvent.loaded / newFile.size) * 100);
                      newFile.uploadpercent = uploadedPercent;
                    },
                  },
                )
                .then((res) => {
                  console.log('-- completed upload: ' + newFile.name);
                  newFile.isuploaded = true;
                  newFile.uploadpercent = 100;
                  newFile.cloudStorageEndPath = cloudStorageEndPath;
                  newFile.sessionId = this.clientSessionId;

                  this.$forceUpdate();
                  this.updateIsUserContentPendingUploads();
                  this.autosave();
                  console.log('--NEW FILE', newFile);
                  this.storeAgreementUpdate(item, newFile.name, 'user upload completed');

                  if (newFile.type === 'application/pdf') {
                    const urlThumbnail = '/agreelinkdata?agreelinkdata-getpdfthumbnail';
                    let jsonData = {
                      requesttype: 'agreelinkdata-getpdfthumbnail',
                      attachmenttype: 'userattachment',
                      filename: newFile.name,
                      agreeclientsessionid: this.clientSessionId,
                      storagepath: cloudStorageEndPath,
                      agreedisplayid: this.linkDisplayId,
                      agreedocumentfiletype: newFile.type, //*mime type
                    };
                    this.$harbourData.post(urlThumbnail, jsonData).then((response) => {
                      newFile.previewbase64data = response.data.thumbnail_base64;
                      this.userContentAttachments = [...this.userContentAttachments];
                    });
                  }
                })
                .catch((e) => {
                  newFile.uploadpercent = 0;
                  newFile.isuploaded = false;
                  alert(
                    'Unable to finalize file upload for ' +
                      newFile.name +
                      ' -- please try again later, or contact support@harbourshare.com',
                  );
                });
            })
            .catch(() => {
              alert(
                'Unable to complete file upload for ' +
                  newFile.name +
                  ' -- please try again later, or contact support@harbourshare.com',
              );
            });
        });
    },

    /**
     * Load any image reference attachments for the SuperDoc agreement
     */
    async getSuperdocAgreementOwnerImages() {
      const aoImages = [];
      const imageFields = this.agreementCustomInputs.custominputs.filter(
        (field) => field.itemfieldtype === 'IMAGEINPUT',
      );
      for (const imageField of imageFields) {
        const referenceAttachmentsForField = this.linkReferenceAttachments.filter(
          (attachment) => attachment.referenceattachmentinputid === imageField.itemid,
        );

        for (const attachment of referenceAttachmentsForField) {
          const { referenceattachmentcloudstorageendpath: gcsPath } = attachment;
          const url = `${window.location.origin}/agreelinkreferenceattachment/${this.linkDisplayId}/${gcsPath}`;
          const blob = await getBlobFromUrl(url);
          const base64 = await readFileAsDataUrl(blob);
          aoImages.push({ ...attachment, attachmentbase64: base64 });
        }
      }

      this.agreementOwnerAttachments = aoImages;
    },

    async uploadImagePreview(previewItem) {
      //File metadata
      let cloudStorageEndPath = '';
      try {
        let tgtJsonData = {
          requesttype: 'agreelinkdata-uploadusercontenteattachment',
          agreedisplayid: this.linkDisplayId,
          agreeclientsessionid: this.clientSessionId,
          agreedocumenttitle: previewItem.name,
          agreedocumentfiletype: previewItem.type, //*mime type
        };

        //Get signed URL for upload
        const tgtUrl = '/agreelinkdata?agreelinkdata-uploadusercontenteattachment';
        const response = await this.$harbourData.post(tgtUrl, tgtJsonData);
        //Send the actual file data to Google Cloud Storage
        let responseData = response.data;
        let signedUrl = responseData.signeduploadurl;
        cloudStorageEndPath = responseData.cloudstorageendpath;

        await this.$harbourData.put(
          signedUrl,
          previewItem,
          {},
          { headers: { 'content-type': previewItem.type } },
        );
        return cloudStorageEndPath;
      } catch (e) {
        console.error(e);
        console.error(
          `Unable to complete upload for image preview ${previewItem.name} cloud path: ${cloudStorageEndPath}`,
        );
        return '';
      }
    },

    // filter out annotations for pdf preview
    pdfPreviewDocumentAnnotations() {
      const predicate = (annotation) => {
        // hide annotations that are conditionally hidden
        return (
          !this.currentlyHiddenConditionalInputs[annotation.itemid] ||
          // show annotations for other signer's inputs
          this.previousSignerData?.aggregateditemvalues[annotation.itemid]
        );
      };
      return this.allAnnotations.filter(predicate);
    },

    /**
     * Load the SuperDoc preview data from the signed urls
     * @param previewFilesPayload The SuperDoc preview files payload from the server
     */
    async prepareSuperdocPreview(previewFilesPayload) {
      try {
        this.superdocPreviewData = await SuperdocService.loadSuperdocPreviewData(
          previewFilesPayload,
        );
        if(this.superdocPreviewData && this.superdocPreviewData.length> 0) {
          this.activeSuperdocFile = this.superdocPreviewData[0]?.data;
        }
      } catch (error) {
        console.error('Failed to load SuperDoc preview data', error);
      }
    },

    previewImageFieldValueGetter(field, value, annotationId) {
      const inputAnnotations = this.allAnnotations.filter(
        (annotation) => annotation.itemid === field.itemid,
      );
      const annotationIndex = inputAnnotations.findIndex(
        (annotation) => annotation.originalannotationid === annotationId,
      );
      const attachmentIndex = field.multiple ? annotationIndex : 0;

      return this.getBase64ForImageInput(field.itemid, value[attachmentIndex]?.userattachmentid);
    },

    async openPdfPreview(itemJson, submitBtnAttr) {
      if (this.isPdfPreviewActive) {
        return;
      }

      this.isPdfPreviewActive = true;
      this.isPdfPreviewSubmitVisible = submitBtnAttr === 'true';

      try {
        const documentName = this.agreementData.agreementheader;

        const agreementPdfBlob = await this.prepareDataForPdfPreview();
        const source = new File([agreementPdfBlob], documentName, { type: 'application/pdf' });

        // MULTI-SIGNER ANNOTATIONS: combine current data with previous signers' data
        this.consolidatedData = { ...this.itemValuesPopulated };
        for (let key in this.previousSignerData.aggregateditemvalues) {
          this.consolidatedData[key] = this.previousSignerData.aggregateditemvalues[key];
        }

        let fields = [];
        this.allSignerInputs.forEach((input) => {
          if (this.currentlyHiddenConditionalInputs[input.itemid]) return;

          let itemoptions =
            input.itemoptions?.map((option) => {
              return { ...option, ischecked: option.valueToggle };
            }) || null;

          fields.push({
            ...input,
            itemlinkvalue: this.consolidatedData[input.itemid],
            itemoptions,
            ...(input.itemtype === 'IMAGEINPUT' && {
              valueGetter: ({ annotationId }) =>
                this.previewImageFieldValueGetter(
                  input,
                  this.consolidatedData[input.itemid],
                  annotationId,
                ),
            }),
          });
        });

        let currentSignerFields = fields.filter(
          (field) =>
            field.itemvisiblerequiredindex === this.userInfo.completionindex ||
            field.itemvisiblerequiredindex === null,
        );

        let currentSignerAnnotations = this.allAnnotations.filter((annotation) => {
          let found = !!currentSignerFields.find(
            (field) =>
              field.itemid === annotation.itemid || field.itemid === annotation.itemoriginalid,
          );
          return found;
        });

        // Get previously completed signer data.
        // Create an index of those IDs so we can extract the matching annotation.
        let otherSignerIds = Object.keys(this.previousSignerData?.aggregateditemvalues ?? {});
        let otherSignerAnnotations = this.allAnnotations
          .filter(
            (item) =>
              otherSignerIds.includes(item.itemid) || otherSignerIds.includes(item.itemoriginalid),
          )
          .map((item) => ({ ...item, nostyle: true }));

        let annotations = [...currentSignerAnnotations, ...otherSignerAnnotations];

        let submitItem;
        this.agreementData?.agreementcontent.sections.forEach((section) => {
          section.sectionitems.forEach((item) => {
            if (item.itemtype === 'FINALSUBMIT') {
              submitItem = item;
            }
          });
        });

        let headerCtas = [];
        const downloadCta = {
          id: 'download',
          label: 'Download',
          icon: 'file-arrow-down',
          type: 'secondary',
        };
        if (!this.isDownloadDisabled) headerCtas.push(downloadCta);

        const submitCta = {
          id: 'submit',
          label: 'Submit',
          type: 'primary',
          icon: 'paper-plane',
          disabled: this.isUserContentPendingUploads,
          onClick: () => {
            if (submitItem) {
              this.storeAgreementUpdate(submitItem, '#BUTTONCLICKED', 'button interaction');
            }
            this.finalSubmit();
          },
        };

        const isSectionsValid = this.validateSection('ALL', () => {}, { hideAlert: true });
        if (isSectionsValid) headerCtas.push(submitCta);

        this.superdocViewerModal = this.$openSuperdocViewerModal({
          linktitle: documentName,
          id: this.agreementId,
          source,
          fields,
          modules: {
            'hrbr-fields': {},
          },
          annotations,
          headerCtas,
          onCancel: () => {
            this.isPdfPreviewActive = false;
          },
        });

        this.isAgreementDocumentRendered = true;
        this.storeAgreementUpdate(itemJson, '#AGREEMENTLINKDOCUMENTVIEW', 'user opened agreement');
      } catch (e) {
        this.isPdfPreviewActive = false;
        alert('Unable to open document, try reloading the page.');
        console.error(e);
      }
    },

    async prepareDataForPdfPreview() {
      let agreementPdfBlob = null;
      if (this.linkPageAttachments.length) {
        let response = null;
        response = await this.$harbourData.post('/agreementpdfpreview', {
          requesttype: 'agreement_link_pdf_preview_with_pageattachments',
          agreementpdfgcppath: this.agreementPdfGcpPath,
          pageattachments: this.linkPageAttachments,
        });
        if (response.data.state == 'SUCCESS') {
          agreementPdfBlob = await getBlobFromUrl(
            `data:application/pdf;base64,${response.data.pdfbase64}`,
          );
          this.showPrevewWithAttachments = true;
        } else {
          console.error(`/agreementpdfpreview failed: ${response}`);
        }
      } else {
        const res = await fetch(this.agreementDocumentSignedUrl);
        agreementPdfBlob = await res.blob();
        this.showPrevewWithAttachments = false;
      }
      this.isPdfPreviewLoading = false;
      return agreementPdfBlob;
    },

    //Get file extension
    getExtension(attachmentFilename) {
      let filename = attachmentFilename;
      let filenameClean = filename.toLowerCase().trim();
      let fileExt = filenameClean.split('.').pop();
      return fileExt;
    },

    //Update pending uploads flag
    updateIsUserContentPendingUploads() {
      let self = this;
      if (
        self.userContentAttachments.filter(function (f) {
          return f.isuploaded != true;
        }).length == 0
      ) {
        self.isUserContentPendingUploads = false;
      } else {
        self.isUserContentPendingUploads = true;
      }
    },

    getUserContentAttachmentById(attachmentId) {
      return this.userContentAttachments.find((a) => a.id === attachmentId);
    },

    getBase64ForImageInput(inputId, attachmentId) {
      const allAttachments = [...this.userContentAttachments, ...this.allSignersAttachments];
      const imageAttachment = allAttachments.find((a) =>
        a.id ? a.id === attachmentId : a.itemid === inputId,
      );

      return imageAttachment?.thumbnail || imageAttachment?.base64data || '';
    },

    //Delete file
    deleteUserContentAttachment(index, attachmentId) {
      let self = this;
      let deletionFile = self.userContentAttachments[index];
      let itemId = deletionFile.itemid;
      let targetItem = null;
      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach((item) => {
          if (item.itemid === itemId) {
            targetItem = item;
          }
        });
      });
      self.userContentAttachments.splice(index, 1);

      if (attachmentId) {
        self.itemValues[itemId] = self.itemValues[itemId].filter(
          (image) => image.userattachmentid !== attachmentId,
        );
      } else {
        self.itemValues[itemId] = null;
      }

      if (targetItem && !self.itemValues[itemId]?.length) {
        targetItem.itemname = null;
        targetItem.itemfilename = null;
      }

      self.$forceUpdate();
      self.updateIsUserContentPendingUploads();
      self.storeAgreementUpdate(targetItem, deletionFile.name, 'user upload deleted');
    },

    //Store special linked values
    storeSpecialLinkedValues() {
      let self = this;
      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          //Save any special values
          let itemId = item.itemid;
          let itemCurrentValue = self.itemValues[itemId];
          let itemLinkedValue = item.itemspeciallinkedvalue;
          if (itemLinkedValue == 'EMAIL' && !self.isLoginOptionDisabled) {
            self.linkedSpecialValues['EMAIL'] = itemCurrentValue;
          }
          if (itemLinkedValue == 'FULLNAME' && !self.isLoginOptionDisabled) {
            self.linkedSpecialValues['FULLNAME'] = itemCurrentValue;
          }
        });
      });
    },

    //Remove/don't store conditionally hidden items
    removeConditionallyHiddenItems() {
      let self = this;
      self.agreementData.agreementcontent.sections.forEach(function (section) {
        section.sectionitems.forEach(function (item) {
          //Remove any stored value from a now-hidden item (*i.e., conditionally-displayed item)
          let itemId = item.itemid;
          if (self.visibleIneligibleItemsArray.includes(itemId) == true) {
            if (
              !(
                item.itemtype === 'TEXTINPUT' &&
                (item.iteminputtededitorselectiontype == 'DATEINPUT' ||
                  item.iteminputtededitorselectiontype == 'SIGNDATEINPUT')
              )
            ) {
              self.itemValues[item.itemid] = null;
            }
            if (
              item.itemtype === 'TEXTINPUT' &&
              (item.iteminputtededitorselectiontype == 'DATEINPUT' ||
                item.iteminputtededitorselectiontype == 'SIGNDATEINPUT') &&
              item.isdefaultdisplayed == false
            ) {
              if (self.itemValues[item.itemid]) {
                let current_date = self.getFormattedDate(null, item.itemformat);
                self.itemValues[item.itemid] = current_date;
              }
            }
          }
        });
      });
    },

    //Go to prior section
    goPriorSection() {
      let self = this;
      self.activeStepperSection = self.activeStepperSection - 1;
      self.itemValues['activeStepperSection'] = self.activeStepperSection;
      self.autosave('section', self.activeStepperSection, '');
      location.href = '#steps'; //*jump to top area
    },

    //Proceed to next section
    goNextSection() {
      let self = this;
      self.storeSpecialLinkedValues(); //*store any special values (e.g., NAME), for potential display in new section
      self.activeStepperSection = self.activeStepperSection + 1;
      self.itemValues['activeStepperSection'] = self.activeStepperSection;
      self.autosave('section', self.activeStepperSection, '');
      location.href = '#steps'; //*jump to top area
    },

    //Final submit
    finalSubmit() {
      //Re-validate all input and then submit to server
      console.log('-- FINAL SUBMIT INITIATED');

      //Validate: verifications started
      if (!this.getAllChecksStarted()) {
        this.$buefy.toast.open({
          message: `Please start and complete all User verifications`,
          type: 'is-danger',
          position: 'is-top',
          duration: 5000,
        });
        return;
      }

      //Validate and submit
      let self = this;
      self.storeSpecialLinkedValues(); //*e.g., EMAIL (RECIPIENT), MAINCONTENTUPLOAD, FULLNAME (RECIPIENT)
      self.validateSection('ALL', function () {
        //Validate: network acesss exists
        if (self.isNetworkConnectionLost) {
          alert(
            'The network connection was lost while you are working on this agreement. Please reload the page and try again if the agreement has not been submitted yet.',
          );
          return;
        }

        //Validate: already final-submitted?
        if (self.isFinalSubmitAlreadyCompleted == true) {
          console.log('-- FINAL SUBMIT ALREADY COMPLETED');
          return false;
        }
        self.isFinalSubmitAlreadyCompleted = true;

        //Remove any items that are currently conditionally-hidden (*don't store any provided value)
        self.removeConditionallyHiddenItems();

        // unhide previous signer's inputs
        const previousSignerValues = self.previousSignerData?.aggregateditemvalues || {};
        Object.keys(previousSignerValues).forEach((itemid) => {
          self.currentlyHiddenConditionalInputs[itemid] = false;
        });

        // Remove items hidden via conditional logic inputs
        Object.keys(self.currentlyHiddenConditionalInputs).forEach((itemid) => {
          if (self.currentlyHiddenConditionalInputs[itemid]) {
            self.itemValues[itemid] = null;
          }
        });

        //Send all finalized agreement info to server and store
        self.isFinalSubmitLoading = true;
        self.isPdfPreviewActive = false;
        self.superdocViewerModal?.close?.();

        // check for pre-submit actions
        let submitActionDetails = self.agreementData?.agreementformsubmitactions || [];
        if (submitActionDetails.length > 0) {
          const submitActionDetail = submitActionDetails[0];
          const action = submitActionDetail?.action;
          const updates = submitActionDetail?.updates;

          if (action && updates && action === 'UPDATEINPUTSPRESUBMIT' && Array.isArray(updates)) {
            updates.forEach((update) => {
              const match = self.allSignerInputs.find((input) => {
                const found = Object.keys(update.find).every(key => input[key] === update.find[key]);
                const hidden = self.currentlyHiddenConditionalInputs[input.itemid];
                return found && !hidden;
              });

              if (match) {
                // copy old item values to update object to preserve
                const value = self.itemValues[match.itemid];
                Object.assign(match, update.update);
                self.itemValues[match.itemid] = value; // restore old value
              }
            });
          }
        }

        self.finalSubmissionStore(
          function (successCompletionState) {
            //Store agreement state uodate - success!
            self.storeAgreementUpdate(
              '#AGREELINKVALIDATEDANDSUCCESFULLYSUBMITTED',
              '#AGREELINKVALIDATEDANDSUCCESFULLYSUBMITTED',
              'agreement validated with successful final submission',
              true, // final submission flag: store attachments, branding etc.
            );
            //Message any iframe parent on agreement completion
            try {
              let isIframed = window === window.parent || window.opener ? false : true;
              if (isIframed == true) {
                parent.postMessage('harbour_submission-completed', '*');
              }
            } catch (err) {
              console.log('finalSubmit - unable to communicate with parent', err.message);
            }

            //From URL, override go to override destination
            let current_submit_fullurl = window.document.location.search;
            if (current_submit_fullurl.includes('successredirect')) {
              const overrideDestinationUrl =
                new URLSearchParams(current_submit_fullurl).get('successredirect') || '';

              // Bitly ID redirect
              if (overrideDestinationUrl?.length === 7) {
                let override_destination_url = `https://bit.ly/${overrideDestinationUrl}`;
                console.log('--override: url success destination:', override_destination_url);
                window.location.href = override_destination_url;
                return false;
              } else if (overrideDestinationUrl) {
                console.log('--override: url success destination:', overrideDestinationUrl);
                window.location.href = overrideDestinationUrl;
                return false;
              }
            }

            //Based on agreement configuration, either show a success message or redirect to destination URL
            let submitActionDetails = self.agreementData.agreementformsubmitactions[0];
            if (submitActionDetails.action == 'SUBMITMESSAGE') {
              self.completedTitle = submitActionDetails.completedtitle;
              if (
                successCompletionState == 'COMPLETED' &&
                submitActionDetails.completedmessage != undefined
              ) {
                //Fully complete message
                self.completedMessage = submitActionDetails.completedmessage;
              } else if (
                successCompletionState == 'INCREMENTALLYCOMPLETED' &&
                submitActionDetails.incrementallycompletedmessage != undefined
              ) {
                //Party-submitted but yet awating others
                self.completedMessage = submitActionDetails.incrementallycompletedmessage;
              } else {
                //Default completion message
                self.completedMessage = 'Thanks for your submission.';
              }
            }
            if (submitActionDetails.action == 'SUBMITREDIRECT') {
              window.location.href = submitActionDetails.completedredirecturl;
            }
            self.isCompleted = true;
            location.href = '#app-agree';
            self.isFinalSubmitLoading = false;

            // Clear autosave data
            self.clearAutosaveData();
          },
          function () {
            //Error :-/
            self.isFinalSubmitLoading = false;
            self.isFinalSubmitAlreadyCompleted = false;
            alert(
              'Sorry, but I am afraid a server error occurred - please try again in just a bit or contact support@harbourshare.com',
            );
          },
        );
      });
    },

    //Updated stored item value
    updateInputValue(item, tgtNewValue) {
      let self = this;
      self.itemValues[item.itemid] = tgtNewValue;
      self.checkboxRenderKey = self.checkboxRenderKey + 1;
    },

    //Update stored checkbox value (*with customizable yes/no answers)
    updateStoreCheckboxValue(item, isItemCheckedNewState, group = null) {
      let self = this;

      //Get/set true value
      let itemTrueValue = 'YES';
      if (
        item.itemcheckedvalueyes != undefined &&
        item.itemcheckedvalueyes != null &&
        item.itemcheckedvalueyes != item.itemcheckedvalueno
      ) {
        itemTrueValue = item.itemcheckedvalueyes;
      }
      item.itemcheckedvalueyes = itemTrueValue;

      //Get/set false value
      let itemFalseValue = 'NO';
      if (
        item.itemcheckedvalueno != undefined &&
        item.itemcheckedvalueno != null &&
        item.itemcheckedvalueyes != item.itemcheckedvalueno
      ) {
        itemFalseValue = item.itemcheckedvalueno;
      }
      item.itemcheckedvalueno = itemFalseValue;

      //Update stored value
      this.$set(
        this.itemValues,
        item.itemid,
        isItemCheckedNewState ? itemTrueValue : itemFalseValue,
      );

      conditionalLogicHelpers.compareAndUpdate(
        this.allSignerInputs,
        this.currentlyHiddenConditionalInputs,
        this.itemValues,
        item,
        this.itemValues[item.itemid],
        false,
        group,
      );

      // if checkbox in group, tally check
      if (group && typeof group.checkcount === 'number') {
        if (self.itemValues[item.itemid] && isItemCheckedNewState === true) {
          group.checkcount++;
        } else {
          group.checkcount--;
        }
      }

      self.$forceUpdate();
      return false;
    },

    //Store prior e-consent
    updateStoreEconsent: function (item) {
      let currentEconsent = this.itemValues[item.itemid]; //*YES or NO
      let priorStoredEConsents = this.getCookie('harbour-prior-econsents');
      if (priorStoredEConsents == null) {
        priorStoredEConsents = '';
      }
      if (currentEconsent == 'YES') {
        priorStoredEConsents = '||' + this.linkDisplayId + '||' + priorStoredEConsents;
        priorStoredEConsents = priorStoredEConsents.slice(0, 2000);
        this.setCookie('harbour-prior-econsents', priorStoredEConsents, 24);
      } else {
        this.setCookie('harbour-prior-econsents', 'NO', 24);
      }
      return false;
    },

    //Send input update to server
    storeAgreementUpdate(item, itemValue, itemMessage, isFinalSubmission = false) {
      //Agree link item value update
      let self = this;
      let itemId = item.itemid;
      let itemDisplayLabel = item.itemdisplaylabel;
      let itemType = item.itemtype;
      let itemLinkedValue = item.itemspeciallinkedvalue;
      let itemJson = Object.assign({}, item);

      // remove image thumbnail base64 and base64data from here just not to hit columns limit
      if (itemJson.thumbnail) {
        delete itemJson.thumbnail;
      }
      if (item.base64data) {
        delete itemJson.base64data;
      }

      let isAgreementEditorNameField =
        typeof item === 'object' && 'iteminputtededitorselectiontype' in item
          ? item.iteminputtededitorselectiontype == 'NAMETEXTINPUT'
          : false;

      //Use the name field in the agreement link to set the default type-to-sign value,
      // if more than one name field don't use it as a default value for the signature
      if (
        self.numberOfNameFields == 1 &&
        (isAgreementEditorNameField || itemLinkedValue == 'NAME') &&
        itemValue
      ) {
        self.typedUserName = itemValue;
      }

      //Special case: agree link overall state update
      //-- successfully authenticated and content loaded/displayed
      if (item == '#AGREELINKAUTHENTICATEDANDCONTENTLOADED') {
        itemId = '#AGREELINKAUTHENTICATEDANDCONTENTLOADED';
        itemDisplayLabel = '#AGREELINKAUTHENTICATEDANDCONTENTLOADED';
        itemType = 'AGREELINKSTATE';
        itemJson = {};
        itemJson = { email: self.userInfo?.email };
      }
      //-- successful final validatation and final submission
      if (item == '#AGREELINKVALIDATEDANDSUCCESFULLYSUBMITTED') {
        itemId = '#AGREELINKVALIDATEDANDSUCCESFULLYSUBMITTED';
        itemDisplayLabel = '#AGREELINKVALIDATEDANDSUCCESFULLYSUBMITTED';
        itemType = 'AGREELINKSTATE';
        itemJson = { email: self.userInfo?.email };
      }
      if (item === '#USEREMAILCHANGE') {
        itemId = '#USEREMAILCHANGE';
        itemDisplayLabel = itemMessage;
        itemType = 'AGREELINKSTATE';
        itemJson = {};
      }

      //Special case: no item item label specified (*i.e., bold text [e.g., "Enter name"] above form item)
      if (itemDisplayLabel == null || itemDisplayLabel == '') {
        itemDisplayLabel = '-- NO LABEL --';
      }

      //Create summary/update mssage
      let updateMessage = `UPDATE: "${itemDisplayLabel}" (${itemType}) - ${itemMessage}: ${itemValue}`;

      // store agreement data without html string
      const agreementDataWithoutDocumentHtml = JSON.parse(JSON.stringify(self.agreementData));
      agreementDataWithoutDocumentHtml.agreementcustominputs.ckeditorhtmldata = null;

      const itemValuesWithoutSignaturePadBase64 = JSON.parse(
        JSON.stringify(self.itemValuesPopulated),
      );
      this.allSignerInputs.forEach((input) => {
        if (
          input.itemtype === 'SIGNATUREINPUT' &&
          itemValuesWithoutSignaturePadBase64[input.itemid] !== undefined
        ) {
          itemValuesWithoutSignaturePadBase64[input.itemid] = '#SIGNATUREINPUT';
        }
      });

      //Send agreement update data
      let agreeDataUrl = '/agreelinkdata?agreelinkdata-storeagreementupdate';
      let agreePostData = {
        requesttype: 'agreelinkdata-storeagreementupdate',
        agreeupdatemessage: updateMessage,
        //
        itemid: itemId,
        itemtype: itemType,
        itemnewvalue: itemValue,
        itemjsoninfo: itemJson,
        //
        allitemvalues: itemValuesWithoutSignaturePadBase64, // dependent on isFinalSubmission
        //
        referenceattachments: self.linkReferenceAttachments, //*[{...}]
        pageattachments: self.linkPageAttachments, //*[{...}]
        userattachments: [], // dependent on isFinalSubmission
        //
        linkdisplayid: self.linkDisplayId,
        agreepasscode: self.linkPasscode,
        agreeemailconfirmationvalue: self.emailConfirmationValue,
        //
        clientsessionid: self.clientSessionId,
        clientpagereferrer: self.clientReferrer,
        clienturlparamsjson: self.clientUrlParams,
        clientfullurl: window.location.href.split('#')[0], //*ignore hash values
        clientdeploymentid: self.clientDeploymentId, //*perviously dynamic
        clientactivesteppersection: self.activeStepperSection,
        //
        agreementid: self.agreementId,
        agreementjson: agreementDataWithoutDocumentHtml, // dependent on isFinalSubmission
        //
        brandingid: self.brandingId,
        brandingjson: {}, // dependent on isFinalSubmission
        //
        linkgenerationid: self.linkGenerationId,
      };

      // full payload if final submission
      if (isFinalSubmission) {
        agreePostData = {
          ...agreePostData,
          userattachments: self.getUserAttachmentsJson(),
          brandingjson: self.brandingData,
          agreementjson: self.agreementData,
          allitemvalues: self.itemValuesPopulated,
        };
      }

      // Autosave
      self.autosave(item, itemValue, itemMessage);

      console.log('Requesting... ' + agreeDataUrl);
      console.log('   - request:', agreePostData);

      self.$harbourData
        .post(agreeDataUrl, agreePostData)
        .then((response) => {
          //Back
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - response:', response);
        })
        .catch((error) => {
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - error:', error);
        });

      //Fin
      return false;
    },

    //Send input update to server
    storeAgreementLinkView: function () {
      const self = this;
      //Send agreement update data
      const agreeDataUrl = '/agreelinkdata?agreelinkdata-storeagreementview';
      const agreePostData = {
        requesttype: 'agreelinkdata-storeagreementview',
        agreeemailconfirmationvalue: self.emailConfirmationValue,
        //
        linkdisplayid: self.linkDisplayId,
        //
        clientsessionid: self.clientSessionId,
        clienturlparamsjson: self.clientUrlParams,
        clientfullurl: window.location.href.split('#')[0], //*ignore hash values
        //
        agreementid: self.agreementId,
        agreementjson: self.agreementData,
        orgsubdomain: self.linkOrgSubdomain,
      };

      console.log('Requesting... ' + agreeDataUrl);
      console.log('   - request:', agreePostData);

      self.$harbourData
        .post(agreeDataUrl, agreePostData, self.clientUrlParams)
        .then((response) => {
          //Back
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - response:', response);

          //Set viewer cookie
          self.setViewerCookie();
        })
        .catch((error) => {
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - error:', error);
        });

      //Fin
      return false;
    },

    setViewerCookie() {
      const self = this;
      const viewerCookieName = 'harbour_viewer_displayid-' + self.linkDisplayId;
      if (!self.getCookie(viewerCookieName)) {
        self.setCookie(viewerCookieName, '1', 1);
      }
    },

    //Get newly-added user attachment info
    getUserAttachmentsJson() {
      //-- Newly added-by-user file(s) -- added when completing the current form
      let self = this;
      let userAttachmentInfoArray = [];
      self.userContentAttachments.forEach((file) => {
        if (self.currentlyHiddenConditionalInputs[file.itemid]) return;

        userAttachmentInfoArray.push({
          userattachmentcloudstorageendpath: file.cloudStorageEndPath,
          userattachmentfilename: file.name,
          userattachmentsource: 'WEBAPP-AGREELINK-USERATTACHMENT',
          userattachmentuploaderemail: self.userEmail || null,
          userattachmentfilesizebytes: file.size,
          userattachmentisimagestamp: file.isimagestamp || false,
          userattachmentinputid: file.itemid,
          userattachmentid: file.id,
          userattachmentpreviewcloudstorageendpath: file.previewcloudstoragepath,
        });
      });
      return userAttachmentInfoArray;
    },

    //On unable to play a video --> replace with image
    unrenderableVideoEvent(event, mediaAttachment) {
      let self = this;
      mediaAttachment.isUnrenderable = true;
      self.$forceUpdate();
    },

    //Final submission store
    async finalSubmissionStore(successCallback, errorCallback) {
      //Get all attached file verifications (e.g., md5hash)
      let self = this;
      let userAttachmentsJson = self.getUserAttachmentsJson();

      // if ckeditor agreement, let the server know for separate processing
      let ckeditorHtmlData = self.ckeditorHtmlData;
      let isCkAgreement = false;
      if (self.ckeditorAgreementId && ckeditorHtmlData) {
        isCkAgreement = true;
      }

      const itemValuesProcessed = self.getProcessedItemValues(self.itemValuesPopulated);

      //Send final submission to server
      let agreeDataUrl = '/agreelinkdata?agreelinkdata-storefinalagreementsubmission';
      let agreePostData = {
        requesttype: 'agreelinkdata-storefinalagreementsubmission',
        agreeupdatemessage: 'store final agreement submission',
        //
        allitemvalues: itemValuesProcessed,
        currentlyhiddeninputs: self.currentlyHiddenConditionalInputs,
        //
        referenceattachments: self.linkReferenceAttachments, //*[{...}]
        pageattachments: self.linkPageAttachments, //*[{...}]
        userattachments: userAttachmentsJson, //*[{...}]
        //
        linkdisplayid: self.linkDisplayId,
        agreepasscode: self.linkPasscode,
        agreeemailconfirmationvalue: self.emailConfirmationValue,
        //
        sessionid: self.clientSessionId,
        clientpagereferrer: self.clientReferrer,
        clienturlparamsjson: self.clientUrlParams,
        clientfullurl: window.location.href.split('#')[0], //*ignore hash values
        clientdeploymentid: self.clientDeploymentId,
        clientactivesteppersection: self.activeStepperSection,
        //
        agreementid: self.agreementId,
        agreementjson: self.agreementData,
        //
        brandingid: self.brandingId,
        brandingjson: self.brandingData,
        //
        linkgenerationid: self.linkGenerationId,
        //
        allitemmetadata: self.itemMetadata,
        isckagreement: isCkAgreement,
        timezoneoffset: new Date().getTimezoneOffset(),
        //
        superdoc_id: self.superdocId,
      };

      console.log('Requesting... ' + agreeDataUrl);
      console.log('   - request:', agreePostData);

      self.$harbourData
        .post(agreeDataUrl, agreePostData)
        .then((response) => {
          //Back
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - response:', response);

          //Check for inactivated agreement
          const responseData = response.data;
          if (responseData.state == 'FAIL') {
            if (responseData.agreementstate == 'INVALIDFINALSUBMITREQUEST-LINKNOWINACTIVATED') {
              alert(
                "I'm very sorry -- but since you initially began working on this agreement, the link was deactivated or revoked by the owner. This agreement submission is cancelled. Please contact the link sender/source for additional assistance as needed here. Thanks.",
              );
              self.isFinalSubmitLoading = false;
              return false;
            }
            if (
              responseData.agreementstate == 'INVALIDFINALSUBMITREQUEST-AUTH' &&
              responseData.authenticationstatemessage == '#EMAILCONFIRMATIONALLPARTIESCOMPLETED'
            ) {
              self.isAlreadyCompletedBeforeFinalSubmission = true;
              self.isFinalSubmitLoading = false;
              return false;
            }
          }

          //Check state
          if (
            responseData.submissionstate != 'COMPLETED' &&
            responseData.submissionstate != 'INCREMENTALLYCOMPLETED'
          ) {
            errorCallback();
            return false;
          }
          if (responseData.submissionstate == 'COMPLETED') {
            this.agreementReferenceId = responseData.referenceid;
            this.linkOrgSubdomain = responseData.subdomain;
          }

          //Success
          successCallback(responseData.submissionstate);
        })
        .catch((error) => {
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - error:', error);
          errorCallback();
        });
    },

    getProcessedItemValues(itemValues) {
      let values = { ...itemValues };
      try {
        values = this.formatSectionItemsDates(values);
        values = this.formatCountriesAndStates(values);
        return values;
      } catch (e) {
        return itemValues;
      }
    },

    formatCountriesAndStates(itemValues) {
      const fieldTypes = ['STATETEXTINPUT', 'COUNTRYTEXTINPUT'];
      try {
        const values = { ...itemValues };
        for (let key in values) {
          const input = this.allSignerInputs.find((item) => item.itemid === key);
          const isHidden = input.iteminputtype === 'hidden';
          const isIneligible = this.visibleIneligibleItemsArray.includes(key);

          if (
            fieldTypes.includes(input?.iteminputtededitorselectiontype) &&
            !isHidden &&
            !isIneligible
          ) {
            const data = this.getAddressInputDropdownData(input.iteminputtededitorselectiontype);
            values[key] = data.find((item) => item.name === values[key])?.code || values[key];
          }
        }
        return values;
      } catch (e) {
        return itemValues;
      }
    },

    getAddressInputDropdownData(fieldType) {
      const dataMap = new Map([
        ['COUNTRYTEXTINPUT', COUNTRIES_LIST],
        [
          'STATETEXTINPUT',
          [
            ...Object.keys(CANADA_STATES).map((key) => ({ name: key, code: CANADA_STATES[key] })),
            ...Object.keys(US_STATES).map((key) => ({ name: key, code: US_STATES[key] })),
          ],
        ],
      ]);
      return dataMap.get(fieldType);
    },

    formatSectionItemsDates(itemValues) {
      const values = { ...itemValues };
      const sections = this.agreementData.agreementcontent.sections || [];

      const isDateItem = (item) =>
        item.iteminputtededitorselectiontype === 'DATEINPUT' ||
        item.iteminputtededitorselectiontype === 'SIGNDATEINPUT';

      const formatItemValue = (item) => {
        const itemValue = values[item.itemid];
        if (!itemValue) return;
        values[item.itemid] = this.getFormattedDate(itemValue, item.itemformat);
      };

      const isSectionItemAvailable = (item) => {
        const isHidden = item.iteminputtype === 'hidden';
        const isIneligible = this.visibleIneligibleItemsArray.includes(item.itemid);
        return isDateItem(item) && !isHidden && !isIneligible;
      };

      const formatItems = (items) => {
        for (const item of items) {
          if (isSectionItemAvailable(item)) formatItemValue(item);
        }
      };

      const formatSectionItems = (sections) => {
        for (const section of sections) {
          formatItems(section.sectionitems);
        }
      };

      formatSectionItems(sections);
      return values;
    },

    //Harbour credit click
    harbourCreditClick() {
      window.open('https://www.harbourshare.com/?hc');
      return false;
    },

    //Render text with markup with customized values (*from link-creator custom inputs, user info from email auth)
    markupCustomizeInputs(textTemplate) {
      //Skip markup? (*no text)
      let self = this;
      if (textTemplate == undefined || textTemplate == null) {
        return textTemplate;
      }
      //Skip markup (*no markup substitutions found)
      if (textTemplate.includes('{{') == false) {
        return textTemplate;
      }
      if (self.isCkeditorAgreement) {
        return textTemplate;
      }
      if (self.agreementCustomInputs == undefined || self.agreementCustomInputs == null) {
        return textTemplate;
      }
      if (
        self.agreementCustomInputs.custominputs == undefined ||
        self.agreementCustomInputs.custominputs == null
      ) {
        return textTemplate;
      }
      //Render with markup (inputs exist)
      let customInputsJson = {};
      self.agreementCustomInputs.custominputs.forEach(function (customInput) {
        if (customInput.itemlinkvalue != undefined && customInput.itemlinkvalue != null) {
          customInputsJson[customInput.itemid] = customInput.itemlinkvalue;
        }
      });
      //Render markup (with custom inputs)
      let context = {
        custominputs: customInputsJson, //*from link-creator-entered custom input values
        documentinputs: customInputsJson, //*new name for the above
        userinfo: self.userInfo, //*from authenticated user info
        urlinputs: self.clientUrlParams, //*from URL
      };
      let result = Mark.up(textTemplate, context);
      return result;
    },

    //Store custom input attachment
    storeImageThumbnailInput(item) {
      const self = this;
      self.isUserContentPendingUploads = true;
      //Create/click file upload element
      let fileInputElement = document.createElement('input');
      fileInputElement.style.display = 'none';
      fileInputElement.type = 'file';

      if (item.multiple) {
        fileInputElement.multiple = 'multiple';
      }

      fileInputElement.addEventListener('cancel', () => self.isUserContentPendingUploads = false);

      fileInputElement.addEventListener(
        'change',
        async (event) => {
          //Validate: file selected?
          let files = event.target.files;
          if (!files.length) {
            console.log('--> [dev] file uplooader: no upload file(s) selected');
            return;
          }

          const uploadedImagesLen = this.itemValues[item.itemid]?.length || 0;
          const imagescount = parseInt(item.imagescount);

          if (uploadedImagesLen + files.length > imagescount && item.multiple) {
            this.$buefy.toast.open({
              message: `Maximum allowed number of images for this input is - ${item.imagescount}`,
              type: 'is-danger',
              position: 'is-top',
              duration: 3500,
            });
            return;
          }

          if (files.length > imagescount && item.multiple) {
            files = event.target.files.slice(imagescount);
          }

          if (!item.multiple) {
            files = event.target.files;

            // delete attachment if one already uploaded from this input
            self.userContentAttachments = self.userContentAttachments.filter(
              (attachment) => attachment.itemid !== item.itemid,
            );
            self.itemValues[item.itemid] = [];
          }

          for (let tgtFile of files) {
            //Validate: type (JPG, PNG)?
            let tgtFileName = tgtFile.name;
            let tgtFileNameForComparison = tgtFileName.toLowerCase().replace('.jpeg', '.jpg');
            const isValid = await isImageValid(tgtFile);

            if (
              (!tgtFileNameForComparison.includes('.jpg') &&
                !tgtFileNameForComparison.includes('.png')) ||
              !isValid
            ) {
              alert(
                'The provided file is not a required type (JPG or PNG) or corrupted. Please re-export and try again.',
              );
              return false;
            }

            //Validate: min file size?
            let tgtFileBytes = tgtFile.size;
            if (tgtFileBytes < 5) {
              alert('The provided image is too small. Please try again with a larger version.');
              return false;
            }
            // upper bound = 100mb
            if (tgtFileBytes > 1E8) {
              alert('The provided image is too large. Please try again with a smaller version.');
              return false;
            }

            item.itemfilename = tgtFile.name;

            //Create/resize/store thumbnail
            let maxWidth = 600;
            let maxHeight = 600;
            self.createThumbnailFromFile(
              tgtFile,
              maxWidth,
              maxHeight,
              async (resizedImageBase64Data) => {
                const id = `attachment-${uuidv4()}`;
                if (!self.itemValues[item.itemid]) self.itemValues[item.itemid] = [];
                self.itemValues[item.itemid].push({
                  userattachmentid: id,
                });

                // store image upload as attachment
                tgtFile.itemid = item.itemid;
                tgtFile.itemtype = item.itemtype;
                tgtFile.isimagestamp = true;
                tgtFile.id = id;

                // required for multiple image upload
                tgtFile.thumbnail = resizedImageBase64Data;

                // upload preview image to cloud
                const previewBlob = await getBlobFromUrl(resizedImageBase64Data);
                const previewFile = new File([previewBlob], `${tgtFile.name}_preview`, {
                  type: previewBlob.type,
                });
                tgtFile.previewcloudstoragepath = await this.uploadImagePreview(previewFile);

                self.userContentAttachmentsBuffer.push(tgtFile);
                self.fileUploadInputClickHandler(tgtFile);
              },
            );
          }
        },
        false,
      );

      //Append/simulate click
      document.body.appendChild(fileInputElement);
      fileInputElement.click();
    },

    //Logout firebase
    logout() {
      let self = this;

      //Confirm agreement link logout
      let confirmation = confirm("Continue to log out and clear the agreement's fields?");
      if (!confirmation) {
        return false;
      } else {
        self.loginFirebaseCheck();
        self.contextDict = null;
        firebase
          .auth()
          .signOut()
          .then(() => {
            console.log('#AGREELINK - FIREBASE LOGOUT SUCCESS');
            window.location.href = '/agreelinklogout?id=' + self.linkDisplayId;
          })
          .catch((error) => {
            console.log('#AGREELINK - FIREBASE LOGOUT ERROR', error);
          });
      }
    },

    // Handle checkbox input
    checkboxInputHandler(item, newValue) {
      if (newValue && newValue === 'NO') {
        const eventType = 'agreement.rejected';
        const payload = {
          agreement_id: this.agreementId,
          link_id: this.linkDisplayId,
          link_url: `https://hrbr.co/${this.linkDisplayId}`,
          event_type: eventType,
          partner_info: JSON.parse(this.partnerInfo),
        };
        this.triggerWebhook(eventType, payload);
      }
      this.updateInputValue(item, [newValue]);
      this.storeAgreementUpdate(item, newValue, 'updated checkbox');
      conditionalLogicHelpers.compareAndUpdate(
        this.allSignerInputs,
        this.currentlyHiddenConditionalInputs,
        this.itemValues,
        item,
        this.itemValues[item.itemid][0],
      );
    },

    // Handle select ( dropdowninput ) input
    dropdownInputSelectHandler(item) {
      this.debounceStoreAgreementUpdate(
        item,
        this.itemValues[item.itemid],
        'Updated dropdown input',
      );
          conditionalLogicHelpers.compareAndUpdate(
            this.allSignerInputs,
            this.currentlyHiddenConditionalInputs,
            this.itemValues,
            item,
            this.itemValues[item.itemid],
          );
    },

    sanitizeSSNInput(value) {
      if (!value) {
        return '';
      }
      // allow only dashes and numbers and no spaces
      const newValue = value
        .split('')
        .filter((c) => c === '-' || !isNaN(c))
        .join('')
        .replace(/\s/g, '');
      return newValue;
    },

    ssnKeydownHandler(value) {
      return this.ssnInputHyphenateInput(this.sanitizeSSNInput(value));
    },

    ssnInputHyphenateInput(value) {
      const newValue = value.split('');

      const hyphenIndices = [3, 6]; // where to insert hyphens
      hyphenIndices.forEach((i) => {
        if (newValue[i] && newValue[i] !== '-') {
          newValue.splice(i, 0, '-');
        }
      });

      return newValue.join('');
    },

    isInputRequired(item, itemValue) {
      if (item.haslogic) {
        const logicRules = item.logicrules || [];
        logicRules.forEach((rule) => {
          if (rule.operand !== itemValue)
            this.notRequiredConditionalInputs = [
              ...new Set([...this.notRequiredConditionalInputs, ...rule.inputs]),
            ];
        });
      }
      return (
        item.itemvalidations.some(
          (validation) => validation?.itemvalidationtype === 'REQUIREDINPUT',
        ) && !this.notRequiredConditionalInputs.includes(item.itemid)
      );
    },

    inputValueIsValid(item, itemValue) {
      const { validationsMap } = validationHelpers;

      const isRequired = this.isInputRequired(item, itemValue);

      let isInputValid = true;
      let lastMessage;
      for (const rule of item.itemvalidations) {
        const validationFunction = validationsMap.get(rule.itemvalidationtype);
        if (!validationFunction) continue;

        let isValid;
        let validationMessage;

        if (
          rule.itemvalidationtype === 'VALIDSSN' &&
          !this.contextDict.gae_service.includes('production')
        ) {
          continue;
        }

        if (rule.itemvalidationtype === 'ZIPCODE') {
          const countryField = this.allSignerInputs.find(
            (input) =>
              (input.autoaddedinternalname === 'country' && input.groupid === item.groupid) ||
              (item.autocompletegroupid === input.autocompletegroupid &&
                input.iteminputtededitorselectiontype === 'COUNTRYTEXTINPUT'),
          );
          const country = this.itemValues[countryField?.itemid];
          const { value, message } = validationFunction(itemValue, isRequired, country);
          isValid = value;
          validationMessage = message;
        } else if (['STATEINPUT', 'COUNTRYINPUT'].includes(rule.itemvalidationtype)) {
          const suggestionsList = this.getGlobalSuggestions(item);
          const { value, message } = validationFunction(
            itemValue,
            isRequired,
            suggestionsList.suggestions,
          );
          isValid = value;
          validationMessage = message;

          // Validate zipcode when Country has changed
          const zipcodeField = this.allSignerInputs.find(
            (input) =>
              item.autocompletegroupid === input.autocompletegroupid &&
              input.iteminputtededitorselectiontype === 'ZIPCODETEXTINPUT',
          );
          if (zipcodeField) {
            const zipcodeValidation = validationsMap.get('ZIPCODE');
            const { value: isZipCodeValid, message: zipCodeValidationMessage } = zipcodeValidation(
              this.itemValues[zipcodeField.itemid],
              this.isInputRequired(zipcodeField, this.itemValues[zipcodeField.itemid]),
              itemValue,
            );
            zipcodeField.inputinvalid = !isZipCodeValid;
            zipcodeField.inputvalidationmessage = zipCodeValidationMessage;
          }
        } else {
          const validationValue =
            rule.itemvalidationtype === 'PHONEMASKVALIDATION'
              ? item.inputmaskvalue
              : rule.itemvalidationvalue;
          const { value, message } = validationFunction(itemValue, isRequired, validationValue);
          isValid = value;
          validationMessage = message;
        }
        if (isValid) continue;
        isInputValid = isValid;
        lastMessage = validationMessage;
      }
      return {
        isValid: isInputValid,
        message: lastMessage,
      };
    },

    getPhoneMaskValue(input) {
      const isMaskValidationEnabled = input.itemvalidations.some(
        (validation) => validation?.itemvalidationtype === 'PHONEMASKVALIDATION',
      );
      return isMaskValidationEnabled ? input.inputmaskvalue : '';
    },

    async onFeeInputChange(event, item) {
      const value = event;

      await this.$nextTick(); // to apply updates to the dom

      if (!item.itemsuffixvalue) {
        this.itemValues[item.itemid] = value.replace(/[^\d.,$€£¥]/g, '');
      } else {
        this.itemValues[item.itemid] = value.replace(/[^\d.,]/g, '');
      }
      this.debounceStoreAgreementUpdate(item, this.itemValues[item.itemid], 'updated text');
    },

    openInHarbour() {
      let signupPrefix = 'signup';
      if (this.contextDict.gae_service === 'staging') signupPrefix = 'signup-staging';
      const destinationAgreementUrl = `https://${signupPrefix}.myharbourshare.com/createworkspace?si=completed_link_cta&tab=mysignedagreements&referenceid=${this.agreementReferenceId}`;
      window.open(destinationAgreementUrl);
    },

    // Determine which sections has at least one visible field, so section will be visible as well
    visibleSectionsMethod() {
      let visibleSectionsSet = new Set(); // store unique sections
      let sections = this.agreementData?.agreementcontent.sections;
      sections?.forEach((section) => {
        section.sectionitems.forEach((item) => {
          const isHiddenConditional =
            this.currentlyHiddenConditionalInputs &&
            this.currentlyHiddenConditionalInputs[item.itemid];

          if (
            isHiddenConditional ||
            item.iteminputtype === 'hidden' ||
            item.isautoinserteddefaultitem ||
            this.visibleIneligibleItemsArray.includes(item.itemid)
          ) {
            return;
          }
          visibleSectionsSet.add(section);
        });
      });
      this.visibleSections = [...visibleSectionsSet];

      // no sections have visible fields, so show all sections
      // (this can occur if all inputs in agreement are autoinserted)
      if (!this.visibleSections.length) {
        this.visibleSections = sections;
      }
    },

    handleOfflineEvent() {
      this.isNetworkConnectionLost = true;
    },

    /* [start] Verifications specific methods */
    async createVerification(
      verificationData,
      inputId,
      checkType,
      selectedProvider,
      selectedTier = null,
      status = 'in_progress',
      result = 'pending',
      applicationId = null,
      checkSubtype = null,
    ) {
      // SURGICAL FIX: Use public verification endpoint for agreement links
      const res = await verificationsApiService.createPublicVerification({
        verification_data: verificationData,
        verification_type: checkType,
        verification_subtype: checkSubtype,
        verification_tier: selectedTier,
        session_id: this.clientSessionId,
        agreement_link_id: this.linkDisplayId,
        verification_metadata: this.clientUrlParams,
        organization_id: this.organizationId,
        provider_name: selectedProvider,
        application_id: applicationId,
        status: status,
        result: result,
      }, this.linkDisplayId, this.organizationId, this.clientSessionId);
      this.saveLocalStorageKey(checkType, res.id, inputId);
      if (res.redirect_url) {
        this.saveLocalStorageKey(`${checkType}_redirect_url`, res.redirect_url, res.id);
      }
      return res;
    },

    async updateVerification(verificationId, data) {
      return await verificationsApiService.updateVerification(verificationId, data);
    },

    async getVerification(verificationId) {
      return await verificationsApiService.getVerification(verificationId);
    },

    saveLocalStorageKey(localStoreKey, data, extraId = null) {
      if (extraId) {
        return localStorage.setItem(`${localStoreKey}_${this.linkDisplayId}_${extraId}`, data);
      }
      return localStorage.setItem(`${localStoreKey}_${this.linkDisplayId}`, data);
    },

    removeLocalStorageKey(localStoreKey, extraId = null) {
      if (extraId) {
        return localStorage.removeItem(`${localStoreKey}_${this.linkDisplayId}_${extraId}`);
      }
      return localStorage.removeItem(`${localStoreKey}_${this.linkDisplayId}`);
    },

    getLocalStorageKey(localStoreKey, extraId = null) {
      if (extraId) {
        return localStorage.getItem(`${localStoreKey}_${this.linkDisplayId}_${extraId}`);
      }
      return localStorage.getItem(`${localStoreKey}_${this.linkDisplayId}`);
    },

    async poll(fn, fnCondition, ms, times, message, lastMessage) {
      let iteration = 1;
      let result = await fn();
      while (fnCondition(result) && iteration <= times) {
        await wait(ms);
        result = await fn();
        iteration += 1;
        this.currentPollingMessage = message;
      }
      if (lastMessage && fnCondition(result)) {
        this.currentPollingMessage = lastMessage;
      }
      return result;
    },

    getLocationData(data, input) {
      if (!input.autoaddeditem) return;

      const dataCopy = Object.assign(data);
      // Remove parts which doesn't have values
      Object.keys(dataCopy).forEach((key) => dataCopy[key] === undefined && delete dataCopy[key]);
      const { county, country } = data;

      const verificationInputs = this.allSignerInputs.filter((input) =>
        this.checkInputTypes.includes(input.itemtype),
      );
      const countryInputsIds = verificationInputs.map(
        (input) => input.autoaddedinputsmap['country'],
      );
      const countyInputsIds = verificationInputs.map((input) => input.autoaddedinputsmap['county']);

      if (countryInputsIds.length && country) {
        countryInputsIds.forEach((inputId) => (this.itemValues[inputId] = country));
      }
      if (countyInputsIds.length && county) {
        countyInputsIds.forEach((inputId) => (this.itemValues[inputId] = county));
      }

      this.addressData = {
        ...this.addressData,
        ...data,
      };
    },

    getLinkedInputsValues(item) {
      const verificationInput = this.allSignerInputs.find((input) => input.itemid === item.itemid);
      const { provider, autoaddedinputsmap } = verificationInput;
      const defaultInputs = DEFAULT_INPUTS_MAP[item.itemtype] || [];
      const values = {};

      for (const [key, value] of Object.entries(autoaddedinputsmap)) {
        const inputConfig = defaultInputs.find((input) => input.internalname === key);
        // Skip different provider fields
        if (inputConfig?.provider && inputConfig?.provider !== provider) continue;
        values[key] = this.itemValues[value];
      }

      return values;
    },

    validateLinkedInputValues(checkType) {
      const linkedInputs = this.currentSignerInputs.find(
        (input) => input.itemtype === checkType,
      ).autoaddedinputsmap;
      let invalidFound = false; // Flag to track if an invalid input is found
      this.currentSignerInputs.forEach((input) => {
        if (!invalidFound && Object.values(linkedInputs).includes(input.itemid)) {
          const { isValid, message } = this.inputValueIsValid(input, this.itemValues[input.itemid]);
          if (!isValid) {
            this.displayInputErrorMessage(input, message);
            invalidFound = true; // Set the flag to true to break the loop
          }
        }
      });
      return invalidFound;
    },

    async isVerificationDataEqual(verificationId, inputValues) {
      if (!verificationId) return;

      const { verification_data } = await this.getVerification(verificationId);
      return _.isEqual(inputValues, verification_data);
    },

    async requestIdentityCheck(item, inputValues) {
      if (!inputValues) return;

      const verificationId = this.getLocalStorageKey('enhanced_identity_verification', item.itemid);
      let redirectUrl = this.getLocalStorageKey(
        'enhanced_identity_verification_redirect_url',
        verificationId,
      );

      const isDataEqual = await this.isVerificationDataEqual(verificationId, inputValues);
      if (redirectUrl && !isDataEqual) {
        await this.updateVerification(verificationId, { status: 'cancelled' });
        this.removeLocalStorageKey('enhanced_identity_verification', item.itemid);
        this.removeLocalStorageKey('enhanced_identity_verification_redirect_url', verificationId);
        redirectUrl = null;
      }

      this.isCheckModalActive = true;
      if (!redirectUrl) {
        try {
          const { redirect_url } = await this.createVerification(
            inputValues,
            item.itemid,
            'enhanced_identity_verification',
            this.getCheckProvider(item),
            null,
            'started',
            null,
          );
          redirectUrl = redirect_url;
        } catch (error) {
          this.isCheckModalActive = false;
          // TODO: 'checkType' is not defined
          this.setVerificationFieldLoader(checkType, false);
          return;
        }
      }
      return redirectUrl;
    },

    async requestUSCriminalCheck(item, inputValues) {
      if (!inputValues) return;

      const selectedTier = this.allSignerInputs.find(
        (input) => input.itemtype === item.itemtype,
      ).checktype;
      const selectedProvider = this.getCheckProvider(item);
      const verificationData = { ...inputValues };
      if (selectedProvider === 'turn_ai') {
        verificationData.metadata = {
          ip_address: this.contextDict['user_ip'] ?? '192.168.0.1',
          user_agent: this.contextDict['browser_useragent'],
        };
        verificationData.timestamps = {};
        for (const consent of this.checkConsents) {
          verificationData.timestamps[consent.consenttype] = [
            new Date(consent.completeddatetimeepochms),
          ];
        }
        verificationData.timestamps['signature'] = [new Date()];
        verificationData.consent_document = this.createSignature(verificationData);
        verificationData.check_id = this.turnCheckId || this.getLocalStorageKey('turn_check_id');
      }
      const { id } = await this.createVerification(
        verificationData,
        item.itemid,
        'us_criminal_record_check',
        selectedProvider,
        selectedTier,
      );
      await wait(3000);
      return id;
    },

    createSignature(verificationData) {
      let currentYPosition = 30;

      const getMaxWidth = (ctx, text) => {
        let metrics = ctx.measureText(text);
        maxWidth = Math.max(maxWidth, metrics.width);
      };

      const getFontHeight = (ctx, text) => {
        let metrics = ctx.measureText(text);
        //let fontHeight = metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
        let actualHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
        return actualHeight;
      };

      const drawNewLineBold = (ctx, text) => {
        ctx.font = '700 30px Arial';
        ctx.fillText(text, 5, currentYPosition);
        currentYPosition += getFontHeight(ctx, text);
      };

      const drawNewLine = (ctx, text) => {
        ctx.font = '400 25px Arial';
        ctx.fillText(text, 5, currentYPosition);
        currentYPosition += getFontHeight(ctx, text);
      };

      let maxLineHeight = 0;
      let maxWidth = 0;

      let signerName = verificationData.first_name;
      if (verificationData.middle_name) {
        signerName += ' ' + verificationData.middle_name;
      }
      if (verificationData.last_name) {
        signerName += ' ' + verificationData.last_name;
      }

      const textDigitallySigned = `Digitally signed by: ${signerName}`;
      const textSignerEmail = `Signer email: ${this.userEmail}`;

      let canvas = document.createElement('canvas');
      let ctx = canvas.getContext('2d');
      ctx.font = '700 30px Arial';
      getMaxWidth(ctx, textDigitallySigned);
      getMaxWidth(ctx, textSignerEmail);

      maxLineHeight = getFontHeight(ctx, textDigitallySigned);
      maxLineHeight = Math.max(maxLineHeight, getFontHeight(ctx, textSignerEmail));

      canvas.width = maxWidth;
      canvas.height = 6 * maxLineHeight;

      drawNewLineBold(ctx, signerName);
      drawNewLine(ctx, textDigitallySigned);
      drawNewLine(ctx, 'Reason: Background Check');

      const dateNow = new Date(),
        dateNowFormated =
          [dateNow.getMonth() + 1, dateNow.getDate(), dateNow.getFullYear()].join('/') +
          ' ' +
          [dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds()].join(':');
      drawNewLine(ctx, `Date: ${dateNowFormated}`);
      drawNewLine(ctx, textSignerEmail);
      drawNewLine(ctx, 'Location: USA');

      return canvas.toDataURL();
    },

    async requestPanelDrugCheck(item, inputValues) {
      if (!inputValues) return;

      const selectedTier =
        this.allSignerInputs.find((input) => input.itemtype === item.itemtype).checktype ||
        '5 panel';
      let serviceId = null;
      if (selectedTier === '5 panel') {
        serviceId = 315;
      } else if (selectedTier === '7 panel') {
        serviceId = 415;
      } else if (selectedTier === '9 panel') {
        serviceId = 316;
      } else if (selectedTier === '10 panel') {
        serviceId = 317;
      }

      await this.openDrugTestWidget(item, inputValues, serviceId, selectedTier);
      this.isIframeLoading = false;
      return true;
    },

    async requestMVRCheck(item, inputValues) {
      if (!inputValues) return;

      const verificationData = {
        ...inputValues,
        license_number: inputValues.license_number.replace(/\s/g, ''),
        license_type: inputValues.license_country,
        license_prov_state: inputValues.license_prov_state_us || inputValues.license_prov_state_ca,
      };
      const { id } = await this.createVerification(
        verificationData,
        item.itemid,
        'motor_vehicle_record',
        this.getCheckProvider(item),
      );
      this.isIframeLoading = false;
      await wait(3000);
      return id;
    },

    async postDrugTestSchedule(item, inputValues, selectedTier, registrationId) {
      // skip if drug test verification already exists
      if (this.getLocalStorageKey('panel_drug_check')) return;

      this.isPanelDrugModalActive = false;
      this.isPanelDrugSchedulingInProgress = false;

      await this.createVerification(
        inputValues,
        item.itemid,
        'panel_drug_check',
        this.getCheckProvider(item),
        selectedTier,
        'in_progress',
        'pending',
        registrationId,
      );
      this.setVerificationStatus(item.itemtype, 'In progress', item.itemid);

      // check conditional logic
      const input = this.allSignerInputs.find(
        (input) => input.iteminputtededitorselectiontype === item.itemtype,
      );
      this.unhideAutosaveData(input, this.itemValues[input.itemid]);
      conditionalLogicHelpers.compareAndUpdate(
        this.allSignerInputs,
        this.currentlyHiddenConditionalInputs,
        this.itemValues,
        input,
        this.itemValues[input.itemid],
        false,
        null,
      );
    },

    getCheckProvider(item) {
      // return provider from input settings or fallback when provider key is not set
      return (
        this.allSignerInputs.find((input) => input.itemid === item.itemid)?.provider ||
        DEFAULT_PROVIDER_PER_CHECK[item.itemtype]
      );
    },

    async runCheck(item, inputValues) {
      const checkType = item.itemtype;
      this.setVerificationFieldLoader(checkType, true);

      const iframeChecks = ['IDENTITYCHECK'];
      const checkRequestsMap = new Map([
        ['IDENTITYCHECK', this.requestIdentityCheck],
        ['USBACKGROUNDCHECK', this.requestUSCriminalCheck],
        ['VEHICLERECORDCHECK', this.requestMVRCheck],
        ['PANELDRUGCHECK', this.requestPanelDrugCheck],
      ]);
      try {
        if (iframeChecks.includes(checkType)) {
          this.isIframeLoading = true;
          this.checkIframeId = checkType;
          this.checkIframeUrl = await checkRequestsMap.get(checkType)(item, inputValues);
          if (!this.checkIframeUrl) {
            this.isIframeLoading = false;
            return;
          }
        } else {
          if (!(await checkRequestsMap.get(checkType)(item, inputValues))) return;
        }
        this.setVerificationFieldLoader(checkType, false);

        const status = checkType === 'IDENTITYCHECK' ? 'Continue' : 'In progress';
        if (checkType !== 'PANELDRUGCHECK')
          this.setVerificationStatus(checkType, status, item.itemid);

        const input = this.allSignerInputs.find(
          (input) => input.iteminputtededitorselectiontype === checkType,
        );
        this.unhideAutosaveData(input, this.itemValues[input.itemid]);
        conditionalLogicHelpers.compareAndUpdate(
          this.allSignerInputs,
          this.currentlyHiddenConditionalInputs,
          this.itemValues,
          input,
          this.itemValues[input.itemid],
          false,
          null,
        );
      } catch (e) {
        this.isIframeLoading = false;
        this.isCheckModalActive = false;
        this.setVerificationFieldLoader(checkType, false);
      }
    },

    onCheckIframeLoaded(evt) {
      if (evt.target.src.includes('certn') || evt.target.src.includes('oneid')) {
        this.isIframeLoading = false;
      }
    },

    initCheckStatuses() {
      const sections = this.agreementData?.agreementcontent.sections;
      sections?.forEach((section) => {
        section.sectionitems.forEach((item) => {
          if (this.checkInputTypes.includes(item.itemtype))
            this.checkStatuses[item.itemtype] = null;
        });
      });
    },

    async getCheckResult() {
      const validationNamesMap = {
        // IDENTITYCHECK: 'enhanced_identity_verification',
        USBACKGROUNDCHECK: 'us_criminal_record_check',
        VEHICLERECORDCHECK: 'motor_vehicle_record_check',
        PANELDRUGCHECK: 'panel_drug_check',
      };

      // Enable loaders
      for (const checkName of Object.keys(validationNamesMap)) {
        this.setVerificationFieldLoader(checkName, true);
      }

      // Iterate over all sections
      const verificationResultPromises = [];
      const checkInputs = [];
      this.currentSignerInputs.forEach((item) => {
        if (this.checkInputTypes.includes(item.itemtype)) {
          const verificationId = this.getLocalStorageKey(
            `${validationNamesMap[item.itemtype]}`,
            item.itemid,
          );
          if (verificationId) {
            verificationResultPromises.push(this.getVerification(verificationId));
            checkInputs.push(item);
          }
        }
      });

      // Get verification results
      const results = await Promise.allSettled(verificationResultPromises);
      for (const [index, result] of results.entries()) {
        if (result.status === 'fulfilled') {
          const res = result.value;
          if (!res) {
            for (const checkName of Object.keys(validationNamesMap)) {
              this.setVerificationFieldLoader(checkName, false);
            }
            continue;
          }
          const verificationType = checkInputs[index].itemtype;
          // Drug and ID checks have different statuses
          if (res.status === 'started') {
            this.setVerificationStatus(verificationType, 'Continue', checkInputs[index].itemid);
          } else {
            this.setVerificationStatus(
              verificationType,
              this.verificationResults[res.result],
              checkInputs[index].itemid,
            );
          }

          this.unhideAutosaveData(checkInputs[index], this.itemValues[checkInputs[index].itemid]);
          conditionalLogicHelpers.compareAndUpdate(
            this.allSignerInputs,
            this.currentlyHiddenConditionalInputs,
            this.itemValues,
            checkInputs[index],
            this.itemValues[checkInputs[index].itemid],
            false,
            null,
          );
        }
      }
      // Disable loaders
      for (const checkName of Object.keys(validationNamesMap)) {
        this.setVerificationFieldLoader(checkName, false);
      }
    },

    // Move it to separate function to have polling for this type of verification
    async askForEnhancedVerificationResult() {
      this.setVerificationFieldLoader('IDENTITYCHECK', true);

      const input = this.currentSignerInputs.find(
        (input) => input.iteminputtededitorselectiontype === 'IDENTITYCHECK',
      );

      if (!input) return;

      const verificationId = this.getLocalStorageKey(
        'enhanced_identity_verification',
        input.itemid,
      );
      const isVerificationCompleted = this.getLocalStorageKey(
        'enhanced_identity_verification_completed',
        verificationId,
      );
      if (isVerificationCompleted) {
        let response;

        let fetchReport = () => this.getVerification(verificationId);
        let validate = (result) => result.result === 'pending';
        response = await this.poll(
          fetchReport,
          validate,
          5000,
          4,
          'Verification in progress. Please hang tight!',
        );

        if (response.result === 'pending') {
          response = await this.poll(
            fetchReport,
            validate,
            10000,
            3,
            'Still working on it…!',
            'Your verification requires additional processing time. You can remain on this page or check back in a bit.',
          );
        } else {
          this.currentPollingMessage = '';
        }

        if (response.status === 'cancelled') {
          this.setVerificationStatus('IDENTITYCHECK', null, input.itemid);
        } else if (response.status === 'started') {
          this.setVerificationStatus('IDENTITYCHECK', 'Continue', input.itemid);
        } else {
          this.setVerificationStatus(
            'IDENTITYCHECK',
            this.verificationResults[response.result],
            input.itemid,
          );
        }

        this.itemValues[input.itemid] = this.checkStatuses['IDENTITYCHECK'];
        this.unhideAutosaveData(input, this.itemValues[input.itemid]);
        conditionalLogicHelpers.compareAndUpdate(
          this.allSignerInputs,
          this.currentlyHiddenConditionalInputs,
          this.itemValues,
          input,
          this.itemValues[input.itemid],
          false,
          null,
        );
      } else if (verificationId) {
        this.setVerificationStatus('IDENTITYCHECK', 'Continue', input.itemid);
      }
      this.setVerificationFieldLoader('IDENTITYCHECK', false);
    },

    onDrugCheckIframeLoaded() {
      this.$refs.MIS.contentWindow.postMessage({ type: 1, data: this.drugCheckParams }, '*');
    },

    onDrugCheckIframeClosed() {
      postMessage({ type: 2, data: null }, '*'); // triggers closing process
    },

    async openDrugTestWidget(item, inputValues, serviceId, selectedTier) {
      const { access_token, customer_id } = await this.getClearStarAccessToken();
      const checkType = item.itemtype;

      // CERT_00002 is test customer ID, so serviceId should always be 10-Panel Urine
      if (customer_id === 'CERT_00002') {
        serviceId = '10-Panel Urine';
      }

      let registrationId;
      const parameters = {
        access_token: access_token,
        BOID: '170170',
        CustomerID: customer_id,
        ServiceID: serviceId,
        ApplicantFirstName: inputValues.first_name,
        ...(inputValues.middle_name && { ApplicantMiddleName: inputValues.middle_name }),
        ApplicantLastName: inputValues.last_name,
        ApplicantAddress: inputValues.full_address,
        ApplicantCity: inputValues.city,
        ApplicantState: US_STATES[inputValues.state] || '', // 2 letter state code
        ApplicantZipCode: inputValues.zipcode,
        ApplicantDOB: inputValues.birth_date,
        ApplicantGender: inputValues.gender,
        ApplicantEmail: inputValues.email,
        ApplicantDayTimePhone: inputValues.phone_number.replace(/\D/g, ''),
        ApplicantSSN: inputValues.ssn.replace(/-/g, ''), // this is the ID field in the widget
        ApplicantEveningPhone: inputValues.phone_number,
        DonorInformation: 1,
        TestingAuthorityCode: 'FAA',
        TestReasonCategoryCode: 'PRE',
        Hide3rdPartySites: true,
        SendEmailToDonor: true,
        ShowContinueButton: false,
        ShowConfirmationScreen: true, // shows a confirmation page which is nice
        ShowInstructionScreen: false, // finish without instructions
      };

      this.drugCheckParams = parameters;
      this.isPanelDrugModalActive = true;
      this.isPanelDrugSchedulingInProgress = true;

      //callback events
      let resize = (size) => {
        if (this.$refs.MIS) {
          this.$refs.MIS.style.height = size + 'px';
        }
      };
      let scrollTop = () => {
        window.setTimeout(function () {
          window.scrollTo(0, 0);
        }, 0);
      };
      let finish = () => {
        this.isPanelDrugModalActive = false;
        this.isPanelDrugSchedulingInProgress = false;
        this.setVerificationStatus(checkType, 'In progress', item.itemid);

        // Check conditional logic
        const input = this.allSignerInputs.find(
          (input) => input.iteminputtededitorselectiontype === checkType,
        );
        this.unhideAutosaveData(input, this.itemValues[input.itemid]);
        conditionalLogicHelpers.compareAndUpdate(
          this.allSignerInputs,
          this.currentlyHiddenConditionalInputs,
          this.itemValues,
          input,
          this.itemValues[input.itemid],
          false,
          null,
        );
      };
      let eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
      const eventer = window[eventMethod];
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

      eventer(messageEvent, (e) => {
        if (!e) return;
        if (e.data instanceof Array) {
          for (let i = 0; i < e.data.length; i++) {
            const item = e.data[i];
            console.log(
              'ServiceID: ' + item.ServiceID + ' - Type: ' + item.Type + ' - RegistrationID: ',
            );
          }
        } else {
          if (e.data.type === 5) {
            resize(e.data.data);
          } // notification when widget has been resized
          if (e.data.type === 6) {
            finish();
          } // notification when widget has finished
          if (e.data.type === 7) {
            scrollTop();
          } // notification to the host to scroll top
          if (e.data.type === 2) {
            this.isPanelDrugModalActive = false;
            this.isPanelDrugSchedulingInProgress = false;
            this.setVerificationStatus(checkType, null, item.itemid);
          } // close widget and cancel the verification
          if (e.data.type === 3) {
            if (this.drugCheckUserId) return;
            registrationId = e.data.data;
            this.drugCheckUserId = registrationId;
            // registrationId = -1 User selected "Use paper process" checkbox.
            // The donor was not registered with any lab and a CCF was not sent.
            if (registrationId !== -1) {
              this.postDrugTestSchedule(item, inputValues, selectedTier, registrationId);
            }
          }
        }
      });
    },

    async getClearStarAccessToken() {
      return await externalServicesApiService.getClearStarAccessToken({
        organization_id: this.organizationId,
      });
    },

    setVerificationFieldLoader(checkType, value) {
      this.checkResultLoading = {
        ...this.checkResultLoading,
        [checkType]: value,
      };
    },

    setVerificationStatus(checkType, value, inputId) {
      let localInputId = inputId;
      if (!inputId) {
        localInputId = this.currentSignerInputs.find(
          (input) => input.iteminputtededitorselectiontype === checkType,
        )?.itemid;
      }
      this.checkStatuses = {
        ...this.checkStatuses,
        [checkType]: value,
      };

      this.itemValues = {
        ...this.itemValues,
        [localInputId]: value,
      };
    },

    getAllChecksStarted() {
      const allVerificationFields = this.currentSignerInputs.filter((input) =>
        this.checkInputTypes.includes(input.itemtype),
      );
      let isAllChecksStarted = true;
      // Need try/catch for testing purposes(WebView link submit issues)
      try {
        isAllChecksStarted = allVerificationFields.length
          ? allVerificationFields.every((input) => {
              const isRequired = input.itemvalidations.some(
                (validation) => validation?.itemvalidationtype === 'REQUIREDINPUT',
              );
              return isRequired
                ? !!this.itemValues[input.itemid] && this.itemValues[input.itemid] !== 'Continue'
                : true;
            })
          : true;
      } catch (e) {
        console.error(e);
        Sentry.captureException(e);
        Sentry.captureMessage('Error occured while pre-submit checks validation');
        isAllChecksStarted = false;
      }
      return isAllChecksStarted;
    },

    storeConsentUpdate(consent, itemMessage) {
      //Agree link item value update
      let self = this;
      let itemId = consent.id;
      let itemDisplayLabel = consent.consenttitle;
      let itemType = consent.consenttype;
      let itemJson = consent;

      let updateMessage = `UPDATE: "${itemDisplayLabel}" (${itemType}) - ${itemMessage}`;

      //Send agreement update data
      let agreeDataUrl = '/agreelinkdata?agreelinkdata-storeagreementupdate';
      let agreePostData = {
        requesttype: 'agreelinkdata-storeagreementupdate',
        agreeupdatemessage: updateMessage,
        //
        itemid: itemId,
        itemtype: itemType,
        itemnewvalue: itemMessage,
        itemjsoninfo: itemJson,
        //
        allitemvalues: consent,
        //
        referenceattachments: self.linkReferenceAttachments, //*[{...}]
        pageattachments: self.linkPageAttachments, //*[{...}]
        userattachments: [], //*[{...}]
        //
        linkdisplayid: self.linkDisplayId,
        agreepasscode: self.linkPasscode,
        agreeemailconfirmationvalue: self.emailConfirmationValue,
        //
        clientsessionid: self.clientSessionId,
        clientpagereferrer: self.clientReferrer,
        clienturlparamsjson: self.clientUrlParams,
        clientfullurl: window.location.href.split('#')[0], //*ignore hash values
        clientdeploymentid: self.clientDeploymentId, //*perviously dynamic
        clientactivesteppersection: self.activeStepperSection,
        //
        agreementid: self.agreementId,
        agreementjson: self.agreementData,
        //
        brandingid: self.brandingId,
        brandingjson: self.brandingData,
        //
        linkgenerationid: self.linkGenerationId,
      };
      console.log('Requesting... ' + agreeDataUrl);
      console.log('   - request:', agreePostData);

      self.$harbourData
        .post(agreeDataUrl, agreePostData)
        .then((response) => {
          //Back
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - response:', response);
        })
        .catch((error) => {
          console.log('Returning... ' + agreeDataUrl);
          console.log('   - error:', error);
        });

      //Fin
      return false;
    },

    displayInputErrorMessage(input, message) {
      this.$buefy.toast.open({
        message: `${input.itemdisplaylabel}: ${message}`,
        type: 'is-danger',
        position: 'is-top',
        duration: 7000,
        pauseOnHover: true,
      });
    },

    async openChecksConsentModal(item) {
      // make sure linked input validations are passed (e.g. SSN, DOB with age restriction, etc.)
      const checkType = item.itemtype;
      if (this.validateLinkedInputValues(checkType)) return;

      // run check if consent is already given (e.g. after refresh or back navigation)
      const inputValues = this.getLinkedInputsValues(item);
      if (this.isConsentsGiven) {
        this.runCheck(item, inputValues);
        return;
      }

      let checkConsents = [];
      this.setVerificationFieldLoader(checkType, true);
      const selectedProvider = this.getCheckProvider(item);

      try {
        if (selectedProvider === 'turn_ai')
          checkConsents = await this.getTurnConsentForms(inputValues);
        else if (selectedProvider === 'certn' || selectedProvider === 'clear_star')
          checkConsents = await this.getCertnConsentForms(item, inputValues);
      } catch (error) {
        this.setVerificationFieldLoader(checkType, false);
        return;
      }
      this.setVerificationFieldLoader(checkType, false);

      const props = {
        checkConsents: checkConsents,
        inputValues: inputValues,
        companyName: this.contextDict.org_name || '',
        linkDisplayId: this.linkDisplayId,
        requestTitle: this.agreementData?.agreementheader || 'Agreement',
      };
      const events = {
        'on-consents-given': (checkConsents) => {
          this.isConsentsGiven = true;
          this.saveLocalStorageKey('consents_given', true, this.userEmail);
          this.checkConsents = checkConsents;
          this.sendConsentsFiles(inputValues);
          this.runCheck(item, inputValues);
        },
        'on-audit-trail-update': (consent, itemMessage) =>
          this.storeConsentUpdate(consent, itemMessage),
      };
      this.openVerificationConsentModal({ props, events });
    },

    openVerificationConsentModal(options = {}) {
      const { props = {}, events = {} } = options;

      const modal = this.$buefy.modal.open({
        component: HrbrVerificationsConsent,
        parent: this,
        fullScreen: false,
        hasModalCard: true,
        canCancel: true,
        props,
        events,
      });

      document.documentElement.classList.add('hrbr-certn-checks-modal-card--opened');

      return modal;
    },

    sendConsentsFiles(inputValues) {
      // only send requested consent files (marking "Send by email" checkbox)
      if (
        !this.checkConsents.length ||
        !this.checkConsents.some((consent) => consent.issendbyemail)
      ) {
        return;
      }
      this.$harbourData
        .post('/agreelinkdata?agreelinkdata_send_completed_check_consent_file', {
          requesttype: 'agreelinkdata_send_completed_check_consent_file',
          checkconsents: this.checkConsents,
          information: inputValues,
          linkdisplayid: this.linkDisplayId,
          requesttitle: this.agreementData?.agreementheader || 'Agreement',
        })
        .catch((err) => {
          throw new Error(err);
        });
    },

    async getTurnConsentForms(inputValues) {
      // get consent forms from Turn API dynamically
      const { check_id, disclosures } = await externalServicesApiService.createTurnCheck(
        {
          zipcode: inputValues.zipcode,
        },
        {
          organization_id: this.organizationId,
          check_type: 'us_criminal_record_check',
        },
      );
      this.turnCheckId = check_id;
      this.saveLocalStorageKey('turn_check_id', check_id);
      return this.parseTurnConsentForms(disclosures);
    },

    parseTurnConsentForms(disclosures) {
      // sort disclosures by order
      disclosures.sort((a, b) => a.order - b.order);

      this.checkConsents = [];
      for (const [index, disclosure] of disclosures.entries()) {
        let inputs = {};
        if (index === disclosures.length - 1) {
          inputs = {
            SIGNATUREINPUT: null,
          };
        }
        this.checkConsents.push({
          consenttype: disclosure.key,
          consenttitle: disclosure.title,
          isviewed: false,
          iscompleted: false,
          ispdf: false,
          triggers: {},
          vieweddatetimeepochms: null,
          completeddatetimeepochms: null,
          inputs: inputs,
          id: disclosure.key,
          isrequired: true,
          isloaded: true,
          htmldata: disclosure.copy_html,
          issendbyemail: false,
        });
      }
      return this.checkConsents;
    },

    getCertnConsentForms(item, inputValues) {
      // fcra consent must always be last
      const orderedCheckConsents = [...item.itemconsents];
      orderedCheckConsents.push(orderedCheckConsents.splice(0, 1)[0]);
      for (const consent of orderedCheckConsents) {
        consent.isrequired = true;
        consent.issendbyemail = false;
        if (consent.triggers.state) {
          const checkState = inputValues.state.toLowerCase();
          if (!consent.triggers.state.includes(checkState)) {
            consent.isrequired = false;
          }
        }
        if (consent.triggers.county) {
          const checkCounty = inputValues.county?.toLowerCase();
          if (!consent.triggers.county.includes(checkCounty)) {
            consent.isrequired = false;
          }
        }
      }
      return orderedCheckConsents.filter((item) => item.isrequired);
    },
    /* [end] Verifications specific methods */

    onAutocompleteSelect(item, selectedOption) {
      this.autocompleteSelectEventInProgress = true;
      setTimeout(() => {
        this.autocompleteSelectEventInProgress = false;
      }, 3000);

      this.storeAgreementUpdate(item, selectedOption, 'Updated autocomplete input');
    },

    isFieldVisible(field) {
      if (field.ishidden) return false;
      return (
        field.iteminputtype !== 'hidden' &&
        !this.visibleIneligibleItemsArray.includes(field.itemid) &&
        !this.currentlyHiddenConditionalInputs[field.itemid]
      );
    },

    async convertFileToDocx(fileBlob) {
      const fileBase64 = await readFileAsDataUrl(fileBlob);
      try {
        const { converted } = await this.convertFile({
          fileBase64,
          fromType: 'html',
          toType: 'docx',
        });
        const convertedBase64NoMeta = converted.split(';base64,').pop();

        const docxMimeType =
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        const base64Meta = `data:${docxMimeType};base64,`;

        const convertedBase64 = `${base64Meta}${convertedBase64NoMeta}`;
        const convertedBlob = await getBlobFromUrl(convertedBase64);
        return convertedBlob;
      } catch (error) {
        this.$buefy.toast.open({
          message:
            'Unable to convert the file at this time. Please convert it to DOCX and try again',
          type: 'is-danger',
          position: 'is-top',
          duration: 3500,
        });
        console.error(error);

        throw error;
      }
    },

    async convertFile({ fileBase64, fromType, toType }) {
      const res = await this.$harbourData.post('/agreementeditor-convertdocument', {
        fromtype: fromType,
        totype: toType,
        filebase64: fileBase64,
      });

      return res.data;
    },

    generateAgreementHtmlId(elementType, itemType, itemDisplayLabel) {
      let sanitizedDisplayLabel = this.sanitizeDisplayField(itemDisplayLabel);
      sanitizedDisplayLabel = sanitizedDisplayLabel
        ? `-${sanitizedDisplayLabel.slice(0, 100)}`
        : '';
      switch (itemType) {
        case 'TEXTINPUT':
          return `agreement-${elementType}-text${sanitizedDisplayLabel}`;
        case 'SIGNATUREINPUT':
          return `agreement-${elementType}-signature${sanitizedDisplayLabel}`;
        case 'NAMETEXTINPUT':
          return `agreement-${elementType}-name${sanitizedDisplayLabel}`;
        case 'EMAILTEXTINPUT':
          return `agreement-${elementType}-email${sanitizedDisplayLabel}`;
        case 'SIGNDATEINPUT':
          return `agreement-${elementType}-signdate${sanitizedDisplayLabel}`;
        case 'DATEINPUT':
          return `agreement-${elementType}-date`;
        case 'ADDRESSTEXTINPUT':
          return `agreement-${elementType}-address${sanitizedDisplayLabel}`;
        case 'STREETADDRESSTEXTINPUT':
          return `agreement-${elementType}-street${sanitizedDisplayLabel}`;
        case 'YESNOINPUT':
          return `agreement-${elementType}-yesno${sanitizedDisplayLabel}`;
        case 'PHONETEXTINPUT':
          return `agreement-${elementType}-phone${sanitizedDisplayLabel}`;
        case 'COMPANYNAMETEXTINPUT':
          return `agreement-${elementType}-company${sanitizedDisplayLabel}`;
        case 'FILEUPLOADER':
          return `agreement-${elementType}-fileuploader${sanitizedDisplayLabel}`;
        case 'IMAGEINPUT':
          return `agreement-${elementType}-image${sanitizedDisplayLabel}`;
        case 'STATETEXTINPUT':
          return `agreement-${elementType}-state${sanitizedDisplayLabel}`;
        case 'CITYTEXTINPUT':
          return `agreement-${elementType}-city${sanitizedDisplayLabel}`;
        case 'ZIPCODETEXTINPUT':
          return `agreement-${elementType}-zipcode${sanitizedDisplayLabel}`;
        case 'JOBTITLETEXTINPUT':
          return `agreement-${elementType}-jobtitle${sanitizedDisplayLabel}`;
        case 'HTMLINPUT':
          return `agreement-${elementType}-html${sanitizedDisplayLabel}`;
        case 'FEEINPUT':
          return `agreement-${elementType}-fee${sanitizedDisplayLabel}`;
        case 'DURATIONINPUT':
          return `agreement-${elementType}-duration${sanitizedDisplayLabel}`;
        case 'SELECT':
          return `agreement-${elementType}-select${sanitizedDisplayLabel}`;
        case 'CHECKBOXINPUT':
          return `agreement-${elementType}-checkboxinput${sanitizedDisplayLabel}`;
        case 'CHECKBOX':
          return `agreement-${elementType}-checkbox${sanitizedDisplayLabel}`;
        case 'URLTEXTINPUT':
          return `agreement-${elementType}-url${sanitizedDisplayLabel}`;
        case 'DROPDOWNINPUT':
          return `agreement-${elementType}-dropdown${sanitizedDisplayLabel}`;
        case 'SSNTEXTINPUT':
          return `agreement-${elementType}-ssn${sanitizedDisplayLabel}`;
        case 'BANNERINPUT':
          return `agreement-${elementType}-banner${sanitizedDisplayLabel}`;
        case 'IDENTITYCHECK':
          return `agreement-${elementType}-id-check${sanitizedDisplayLabel}`;
        case 'BACKGROUNDCHECK':
          return `agreement-${elementType}-bg-check${sanitizedDisplayLabel}`;
        case 'USBACKGROUNDCHECK':
          return `agreement-${elementType}-us-bg-check${sanitizedDisplayLabel}`;
        case 'VEHICLERECORDCHECK':
          return `agreement-${elementType}-vehicle${sanitizedDisplayLabel}`;
        case 'PANELDRUGCHECK':
          return `agreement-${elementType}-drug-check${sanitizedDisplayLabel}`;
        case 'DISPLAYTEXT':
          return `agreement-${elementType}-display${sanitizedDisplayLabel}`;
      }
      return null;
    },

    sanitizeDisplayField(itemDisplayLabel) {
      if (!itemDisplayLabel) {
        return null;
      }
      let sanitized = itemDisplayLabel.toLowerCase();
      sanitized = sanitized.replace(/\s/g, '-');
      sanitized = sanitized.replace(/[^A-Za-z0-9\-]/g, '');
      sanitized = sanitized.replace(/[^A-Za-z0-9]+$/, '');

      return sanitized;
    },

    // for showing yesNo inputs "no" message
    showYesNoMessage(item, itemValues) {
      if (
        itemValues[item.itemid] &&
        itemValues[item.itemid].includes('NO') === true &&
        item.itemrespondednomessage !== null &&
        item.itemrespondednomessage.trim() !== ''
      ) {
        return true;
      }
      return false;
    },

    //Truncate any long text for display with ellipsis (e.g., long filenames)
    truncateText(textValue) {
      if (textValue.length > 25) {
        return textValue.slice(0, 25) + '...';
      }
      return textValue;
    },

    getGlobalSuggestions(item) {
      if (item.iteminputtededitorselectiontype === 'COUNTRYTEXTINPUT') {
        return {
          suggestions: COUNTRIES_LIST.map((c) => c.name),
        };
      }
      if (item.iteminputtededitorselectiontype === 'STATETEXTINPUT') {
        const autocompleteGroup = item.autocompletegroupid;
        const sameGroupCountryInput = this.allSignerInputs.find(
          (i) =>
            autocompleteGroup === i.autocompletegroupid &&
            i.iteminputtededitorselectiontype === 'COUNTRYTEXTINPUT',
        );
        const valueName = this.itemValues[sameGroupCountryInput?.itemid];
        const valueCode = COUNTRIES_LIST.find((item) => item.name === valueName)?.code;

        if (valueCode === 'US') {
          return {
            suggestions: Object.keys(US_STATES),
          };
        }
        if (valueCode === 'CA') {
          return {
            suggestions: Object.keys(CANADA_STATES),
          };
        }
        return {
          suggestions: [],
        };
      }
      return {
        suggestions: [],
      };
    },
  },

  created() {
    //Set display id
    let self = this;
    let el = document.createElement('a');
    el.href = window.location.href;
    self.linkDisplayId = el.pathname.replace('/agree/', '');

    //Set refer
    self.clientReferrer = document.referrer;

    //Set URL params
    self.clientUrlParams = {};
    try {
      self.clientUrlParams = Object.fromEntries(new URLSearchParams(location.search));
    } catch (error) {
      console.log('Object.fromEntries not supported');
    }

    if (self.clientUrlParams.lang === 'jp') {
      self.harbourStore.lang = 'jp';
    }

    this.typingEmailConfirmationDebounced = debounce((item) => {
      this.typingEmailConfirmation(item);
    }, 450);

    //Debounce (e.g., after text input) and then store new agreement input
    this.debounceStoreAgreementUpdate = debounce(function (item, itemValue, itemMessage) {
      let self = this;
      self.storeAgreementUpdate(item, itemValue, itemMessage);
    }, 800);

    // Check enhanced identity verification completion in production
    window.onmessage = async (e) => {
      const childWindow = this.$refs.identityCheck?.contentWindow;
      if (e.source !== childWindow || !childWindow) {
        return;
      }
      const { data } = e;
      // TODO: handle error
      if (!data || data.hasError) {
        this.isCheckModalActive = false;
        return;
      }
      if (data.hasCompleted) {
        this.isCheckModalActive = false;
        const input = this.currentSignerInputs.find(
          (input) => input.iteminputtededitorselectiontype === 'IDENTITYCHECK',
        );
        const verificationId = this.getLocalStorageKey(
          'enhanced_identity_verification',
          input.itemid,
        );
        this.saveLocalStorageKey('enhanced_identity_verification_completed', true, verificationId);
        await this.updateVerification(verificationId, { status: 'in_progress', result: 'pending' });
        await this.askForEnhancedVerificationResult();
      }
    };

    // Request/update branding
    self.requestBrandingData(function (responseData) {
      //Update logo and background color
      self.brandingId = responseData.brandingid;
      self.brandingData = {
        brandinglogo: responseData.brandinglogourl,
        brandingbackground: responseData.brandingbkgurl,
        brandingtheme: responseData.brandingtheme,
      };

      //Update styling with custom CSS from branding, if provided
      let customBrandCSS = responseData.brandingoverridecss;
      if (customBrandCSS != null && customBrandCSS != '') {
        console.log('--override: branding override css applied:', customBrandCSS);
        let style = document.createElement('style');
        style.setAttribute('type', 'text/css');
        if (style.styleSheet) {
          style.styleSheet.cssText = customBrandCSS;
        } else {
          style.appendChild(document.createTextNode(customBrandCSS));
        }
        document.getElementsByTagName('head')[0].appendChild(style);
      }

      //Get theme CSS
      if (self.brandingData.brandingtheme != null) {
        self.brandingThemeCSS = self.getAvailableOrganizationalThemes().filter(function (d) {
          return d.themename == self.brandingData.brandingtheme;
        })[0].themecss;
      }
    });

    //Override theme - dark
    const overrideThemeDark =  `
        <style>

            .b-steps, .b-steps *{
                color: #4289C3 !important;
            }
            .step-title{
                color: white !important;
            }
            .step-marker{
                border-color: #67686D !important;
                background-color: #67686D !important;
            }
            .is-active .step-marker{
                border-color: #4289C3 !important;
                background-color: #4289C3 !important;
            }
            .step-marker .fas{
                color: #ffffffe0 !important;
            }

            .review-document__icon{
                color: #ffffffde !important;
            }

            #email-login-id{
                display: none !important;
            }

            .html-input-rendered, .html-input-rendered *{
                background-color: #01030E !important;
                color: white !important;
            }

            input, textarea, select, .input-wrap, .vue-signature-pad:not(.signaturecontent), .review-document{
                background-color: #212333 !important;
                border-color: #494E63 !important;
                color: white !important;
            }
            input::placeholder {
                color: #ffffff59 !important;
            }

            .field label{
                color: white !important;
                font-weight: 300 !important;
                opacity: .9 !important;
            }

            .field .icon, .vue-url-input .left-icon{
                color: #ffffff !important;
                opacity: .83 !important;
            }
            .field:has(input:focus) .icon, .vue-url-input:has(input:focus) .left-icon{
                color: #ffffff !important;
                opacity: .95 !important;
            }

            .b-radio.radio.button i, .greyButton i, .b-radio.radio.button{
                color: #8b8b8b !important;
            }
            .b-radio.radio.button.is-success i{
                color: white !important;
            }

            #app-agree, .agreelink-body, #content{
                background-color: #01030E !important;
            }

            .clear-form{
                color: #ffffffb3 !important;
            }

            #btn-previous-section{
                opacity: .3 !important;
                margin-right: 3px !important;
            }

            #btn-next-section, .finalSubmit button{
                background-color: #4289C3 !important;
                border-color: #4289C3 !important;
                color: white !important;
            }

            .b-steps .steps .step-items .step-item.is-success:before, .b-steps .steps .step-items .step-item.is-success:after {
                 color: #616369 !important;
                 background: #616369 !important;
            }

            .control-label a{
                color: #00b0ff !important;
            }

            .help{
                color: #ffffffb0 !important;
            }

            .vue-signature-pad--body--canvas{
                background-color: white !important;
            }

            .successMsg{
                display: none !important;
            }
            .success-messsage::after{
                content: "Thank you for your interest in Troveo! Once you submit, we will review your application. If there is a fit, we will be in touch soon.";
                color: white !important;
            }

            #input-signature-pad-mode-type{
                background-color: white !important;
                color: black !important;
            }

            .checkbox .label, .checkbox .fal{
                color: black !important;
            }

            .b-checkbox span{
                color: #888888 !important;
            }
            .b-checkbox.is-success span{
                color: white !important;
            }

        </style>
    `;

    // Update styling with custom CSS from URL, if provided
    let currentFullUrl = window.location.href;
    if (currentFullUrl.includes('styled=true') == true) {
      const urlOverrideParams = new URLSearchParams(currentFullUrl);
      const urlOverrideFontFamily = urlOverrideParams.get('labelFont') || 'auto';
      const urlOverrideFontColor = (
        '#' + (urlOverrideParams.get('labelFontColor') || 'auto')
      ).replace('#auto', 'auto');
      const urlOverrideIsStyleMin = urlOverrideParams.get('styleMin') || 'auto';
      const urlOverrideIsNoCredit = urlOverrideParams.get('noCredit') || 'auto';
      const urlOverrideSubmitBackgroundColor = (
        '#' + (urlOverrideParams.get('submitBkgColor') || 'auto')
      ).replace('#auto', 'auto');
      let urlOverrideCSS = `
        /* Custom font for field labels */
        @font-face {
          font-family: 'CustomerFont';
          src: url('https://storage.googleapis.com/public_statichosting/customer_fonts/${urlOverrideFontFamily}.woff2') format('woff2');
          font-weight:500;
          font-style: normal;
          font-display: swap;
        }
        .label, b, .form-label{
          font-size: 15px;
          line-height: 16px;
          font-family: CustomerFont,Roboto,Arial,Helvetica,sans-serif !important;
          color: ${urlOverrideFontColor} !important;
          word-spacing: 1px !important;
        }
      `;
      let urlOverrideCSSMinimalStyle = `
        /* Hide banner/logo/attachment column */
        #content{
          top: 0px !important;
          background-color: white !important;
          box-shadow:none !important;
        }
        #logo, #banner, #title, #subtitle, .autosave-header-container, #harbourBottomLinks{
          display:none !important;
        }
        #content, body{
          top:0px !important;
          background-color: white !important;
          padding:10px !important;
          padding-left:10px !important;
          padding-right:10px !important;
          padding-bottom:10px !important;
          padding-top:10px !important;
        }
        #harbourCredit {
          top: 0px !important;
          position: initial !important;
          padding-top: 25px !important;
        }
      `;
      let urlOverrideSubmitButtonCSS = `
        .finalSubmit{
          font-family: CustomerFont,Roboto,Arial,Helvetica,sans-serif !important;
          background-color:${urlOverrideSubmitBackgroundColor} !important;
          padding-right:45px !important;
          color:white !important;
        }
      `;
      let urlOverrideCSSNoCredit = `
        #harbourCredit{
          display:none;
        }
      `;
      let urlOverrideCSSNoCompletionCTA = `
        .success-cta{
          display:none;
        }
      `;
      let urlOverrideCSSNoCompletionEmail = `
        .success-email-confirmation{
          display:none;
        }
      `;
      //Apply style
      let customUrlCSS = urlOverrideCSS;
      if (urlOverrideIsStyleMin == 'true') {
        customUrlCSS =
          customUrlCSS +
          urlOverrideCSSMinimalStyle +
          urlOverrideCSSNoCompletionCTA +
          urlOverrideCSSNoCompletionEmail;
      }
      if (urlOverrideIsNoCredit == 'true') {
        customUrlCSS = customUrlCSS + urlOverrideCSSNoCredit;
      }
      if (urlOverrideSubmitBackgroundColor != 'auto') {
        customUrlCSS = customUrlCSS + urlOverrideSubmitButtonCSS;
      }
      console.log('--override: url override css applied:', customUrlCSS);
      let style = document.createElement('style');
      style.setAttribute('type', 'text/css');
      if (style.styleSheet) {
        style.styleSheet.cssText = customUrlCSS;
      } else {
        style.appendChild(document.createTextNode(customUrlCSS));
      }
      document.getElementsByTagName('head')[0].appendChild(style);
    }

    //Apply override themes
    if(currentFullUrl.includes('styled=true') == true){

      //Dark theme override
      if(currentFullUrl.includes('theme=dark') == true){
        console.log('--override: url override theme applied:', overrideThemeDark);
        document.head.insertAdjacentHTML("beforeend", overrideThemeDark);
      }

    }

    self.getContextDict(
      function () {
        if (self.contextDict) {
          console.log('#AGREELINK - Success getContextDict');
        } else {
          console.log('#AGREELINK - Failed getContextDict');
        }
      },
      function () {
        console.log('#AGREELINK - Failed getContextDict');
      },
    );
  },

  async mounted() {
    let self = this;

    // Set confirmation email
    const confirmationEmail = document.body?.getAttribute('data-confirmation-email') || null;
    const systemEmail = document.body?.getAttribute('data-context-systememail') || null;
    if (confirmationEmail) {
      self.emailConfirmationValue = confirmationEmail;
      self.isAuthenticatedByMagicLink = true;
    } else if (systemEmail) {
      self.emailConfirmationValue = systemEmail;
      self.isAuthenticatedBySystemEmail = true;
    }

    if (self.emailConfirmationValue) {
      self.userEmail = self.emailConfirmationValue;
      //Send to mixpanel
      if (typeof self.activityRecorder === 'function') {
        self.activityRecorder(
          'WebApp - Agreement Link',
          'email automatically confirmed via magic link',
          {
            message: 'web app agreement link - email automatically confirmed',
            linkid: self.linkDisplayId,
          },
          'MEDIUM',
          'MAGICLINK-EMAILCONFIRMATION',
        );
      }
    }

    //Get creator organization service (e.g., "canary"), redirect agreement link as needed to match service
    let agreeDisplayId = window.location.href.split('/').pop().split('?')[0];
    let agreeDataUrl = '/agreelinkdata?agreelinkdata-getcurrentservice';
    let agreePostData = {
      requesttype: 'agreelinkdata-getcurrentservice',
      clientlinkdisplayid: agreeDisplayId,
    };
    console.log('Requesting... ' + agreeDataUrl);
    console.log('   - request:', agreePostData);

    try {
      const currentServiceData = await self.$harbourData.post(agreeDataUrl, agreePostData);
      //Response back
      console.log('Returning... ' + agreeDataUrl);
      console.log('   - response:', currentServiceData);
      //Redirect to organizaton-matching service/subdomain as needed
      let linkCurrentService = currentServiceData.data.linkcurrentservice;
      let organizationCurrentService = currentServiceData.data.organizationcurrentservice;
      if (
        linkCurrentService == null ||
        linkCurrentService == 'localhost' ||
        linkCurrentService == 'localdev' ||
        linkCurrentService == 'livetest'
      ) {
        console.log('-- no service redirect on localhost');
      } else {
        if (linkCurrentService != organizationCurrentService) {
          if (organizationCurrentService == 'canary') {
            console.log('-- service redirect...');
            window.location.href =
              'https://newcreate.myharbourshare.com' +
              window.location.href.split('.myharbourshare.com').pop();
          } else if (organizationCurrentService == 'staging') {
            console.log('-- service redirect...');
            window.location.href =
              'https://newsign.myharbourshare.com' +
              window.location.href.split('.myharbourshare.com').pop();
          } else {
            console.log('-- no service redirect (link-x-org match found)');
          }
        }
      }
    } catch (error) {
      console.log('Returning... ' + agreeDataUrl);
      console.log('   - error:', error);
    }

    //Get creator organization subdomain (e.g., "waynetech" [https://waynetech.myharbourshare.com]) to notification view email
    let agreeDataOrgSubdomainUrl = '/agreelinkdata?agreelinkdata-getorganizationsubdomain';
    let agreePostDataOrgSubdomain = {
      requesttype: 'agreelinkdata-getorganizationsubdomain',
      linkdisplayid: agreeDisplayId,
    };
    console.log('Requesting... ' + agreeDataOrgSubdomainUrl);
    console.log('   - request:', agreePostDataOrgSubdomain);

    self.$harbourData.post(agreeDataOrgSubdomainUrl, agreePostDataOrgSubdomain).then((response) => {
      //Response back
      console.log('Returning... ' + agreeDataOrgSubdomainUrl);
      console.log('   - response:', response);

      //Get agreement link organization creator subdomain
      self.linkOrgSubdomain = response.data.link_subdomain;
      self.linkOrgOwnerId = response.data.link_orgowner_id;
      self.linkOrgOwnerName = response.data.link_orgowner_name;
    });

    //After initial agreement link data loading, trigger agreement view
    self.requestAgreementData(
      async function () {
        // public link
        if (self.isPasscodeNeeded == false && self.isEmailConfirmationNeeded == false) {
          self.storeAgreementLinkView();
        }
      },
      function () {
        // passcode link
        if (self.isPasscodeNeeded == true && self.isEmailConfirmationNeeded == false) {
          self.storeAgreementLinkView();
        }
      },
    );

    //Determine if this is a web view based on size
    window.addEventListener('resize', function () {
      if (document.body.clientWidth < 768) {
        self.isMobileView = true;
      } else {
        self.isMobileView = false;
      }
    });
    if (document.body.clientWidth < 768) {
      self.isMobileView = true;
    }

    //Determine if this is a table-based view
    const userAgent = (navigator.userAgent + '').toLowerCase();
    const isTabletUserAgent =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        userAgent,
      );
    self.isTabletView = isTabletUserAgent;

    // legacy document preview
    document.body.addEventListener('click', (event) => {
      const targetElement = event.target;

      if (targetElement.tagName === 'A' && targetElement.hash === '#AGREEDOCUMENT') {
        event.preventDefault();

        const { submitBtn: submitBtnAttr } = targetElement.dataset;
        const { itemjson: itemJsonStr } = targetElement.closest('div[data-itemjson]').dataset;

        try {
          const itemJson = JSON.parse(itemJsonStr);
          const { documentanchor: anchorName } = itemJson;
          this.viewDocumentClickHandler({ itemJson, submitBtnAttr, anchorName });
        } catch (e) {
          console.error('viewDocumentClickHandler: invalid itemJsonStr', e);
        }
      }
    });

    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('offline', this.handleOfflineEvent);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.handleOfflineEvent);
    window.removeEventListener('offline', this.handleOfflineEvent);
    window.removeEventListener('onVerificationCompleted', this.onVerificationCompleted, false);
  },
};
